var Go = Object.defineProperty;
var Wo = (e, t, n) => t in e ? Go(e, t, { enumerable: !0, configurable: !0, writable: !0, value: n }) : e[t] = n;
var he = (e, t, n) => Wo(e, typeof t != "symbol" ? t + "" : t, n);
import W, { createContext as St, useContext as Ge, useState as V, useCallback as y, useEffect as x, useRef as q, useMemo as T, useLayoutEffect as Ko, useDebugValue as qo, Suspense as Xo, lazy as Rn, useSyncExternalStore as Et, forwardRef as Jo, useImperativeHandle as Yo, useReducer as Qo } from "react";
import { jsxs as E, jsx as a, Fragment as j } from "react/jsx-runtime";
import { CommentsExtension as X } from "@blocknote/core/comments";
import { FilePanelExtension as Ne, LinkToolbarExtension as We, VALID_LINK_PROTOCOLS as er, DEFAULT_LINK_PROTOCOL as tr, FormattingToolbarExtension as be, ShowSelectionExtension as nr, TableHandlesExtension as O, SuggestionMenu as re, SideMenuExtension as te, getDefaultEmojiPickerItems as or, getDefaultSlashMenuItems as rr, filterSuggestionItems as ir } from "@blocknote/core/extensions";
import { useFloating as xt, autoUpdate as cr, useTransitionStyles as Tt, useTransitionStatus as lr, useDismiss as sr, useHover as ar, useInteractions as ur, useMergeRefs as dr, offset as ee, flip as ue, shift as Te, safePolygon as fr, size as we } from "@floating-ui/react";
import { filenameFromURL as Kt, getNodeById as Ht, formatKeyboardShortcut as Ke, isTableCellSelection as mr, isFileBlock as Ce, blockHasZodProps as ve, editorHasBlockTypeAndPropsAreValid as Bn, editorHasBlockType as hr, defaultZodPropSchema as le, mapTableCell as ke, editorHasBlockTypeAndZodProps as Ve, mergeCSSClasses as G, EMPTY_CELL_WIDTH as pr, EMPTY_CELL_HEIGHT as gr, isTableCell as ye, getColspan as On, getRowspan as Pn, getBlockFromPos as br, camelToDataKebab as Ae, audioParse as vr, createAudioBlockConfig as Cr, fileParse as _r, createFileBlockConfig as wr, imageParse as kr, createImageBlockConfig as yr, getPageBreakSlashMenuItems as Sr, videoParse as Er, createVideoBlockConfig as xr, defaultToggledState as Me, UnreachableCaseError as Nn, BlockNoteEditor as Tr, BlockNoteSchema as Hr, defaultStyleSpecs as Vr, createParagraphBlockSpec as Mr, nodeToCustomInlineContent as qt, partialInlineContentToInlineContent as Zr, inlineContentToNodes as Ir, addInlineContentAttributes as Lr, getInlineContentParseRules as zr, addInlineContentKeyboardShortcuts as Rr, propsToAttributes as Br, createInternalInlineContentSpec as Or, addStyleAttributes as ot, getStyleParseRules as Pr, stylePropsToAttributes as Nr, createInternalStyleSpec as Ar } from "@blocknote/core";
import { useStore as $r } from "@tanstack/react-store";
import { posToDOMRect as Dr, Node as Fr } from "@tiptap/core";
import { createPortal as Vt, flushSync as An } from "react-dom";
import { ReactNodeViewRenderer as $n, useReactNodeView as Dn, NodeViewWrapper as Fn, Mark as jr, ReactMarkViewRenderer as Ur, ReactMarkViewContext as Gr } from "@tiptap/react";
import { createRoot as Wr } from "react-dom/client";
const jn = St(void 0);
function ne(e) {
  return Ge(jn);
}
const Kr = St(
  void 0
);
function _() {
  return Ge(Kr);
}
function C(e) {
  const t = ne();
  if (!(t != null && t.editor))
    throw new Error(
      "useBlockNoteEditor was called outside of a BlockNoteContext provider or BlockNoteView component"
    );
  return t.editor;
}
function H() {
  return ne().editor.dictionary;
}
const qr = (e) => {
  const t = _(), n = H(), o = C(), r = o.getBlock(e.blockId), [i, c] = V(""), s = y(
    (d) => {
      c(d.currentTarget.value);
    },
    []
  ), l = y(
    (d) => {
      d.key === "Enter" && (d.preventDefault(), o.updateBlock(r.id, {
        props: {
          name: Kt(i),
          url: i
        }
      }));
    },
    [o, r.id, i]
  ), u = y(() => {
    o.updateBlock(r.id, {
      props: {
        name: Kt(i),
        url: i
      }
    });
  }, [o, r.id, i]);
  return /* @__PURE__ */ E(t.FilePanel.TabPanel, { className: "bn-tab-panel", children: [
    /* @__PURE__ */ a(
      t.FilePanel.TextInput,
      {
        className: "bn-text-input",
        placeholder: n.file_panel.embed.url_placeholder,
        value: i,
        onChange: s,
        onKeyDown: l,
        "data-test": "embed-input"
      }
    ),
    /* @__PURE__ */ a(
      t.FilePanel.Button,
      {
        className: "bn-button",
        onClick: u,
        "data-test": "embed-input-button",
        children: n.file_panel.embed.embed_button[r.type] || n.file_panel.embed.embed_button.file
      }
    )
  ] });
}, Xr = (e) => {
  var f, m;
  const t = _(), n = H(), { setLoading: o } = e, r = C(), i = r.getBlock(e.blockId), [c, s] = V(!1);
  x(() => {
    c && setTimeout(() => {
      s(!1);
    }, 3e3);
  }, [c]);
  const l = y(
    (h) => {
      if (h === null)
        return;
      async function g(b) {
        if (o(!0), r.uploadFile !== void 0)
          try {
            let v = await r.uploadFile(b, e.blockId);
            typeof v == "string" && (v = {
              props: {
                name: b.name,
                url: v
              }
            }), r.updateBlock(e.blockId, v);
          } catch {
            s(!0);
          } finally {
            o(!1);
          }
      }
      g(h);
    },
    [e.blockId, r, o]
  ), u = r.schema.blockSpecs[i.type], d = (m = (f = u.implementation.meta) == null ? void 0 : f.fileBlockAccept) != null && m.length ? u.implementation.meta.fileBlockAccept.join(",") : "*/*";
  return /* @__PURE__ */ E(t.FilePanel.TabPanel, { className: "bn-tab-panel", children: [
    /* @__PURE__ */ a(
      t.FilePanel.FileInput,
      {
        className: "bn-file-input",
        "data-test": "upload-input",
        accept: d,
        placeholder: n.file_panel.upload.file_placeholder[i.type] || n.file_panel.upload.file_placeholder.file,
        value: null,
        onChange: l
      }
    ),
    c && /* @__PURE__ */ a("div", { className: "bn-error-text", children: n.file_panel.upload.upload_error })
  ] });
}, Un = (e) => {
  const t = _(), n = H(), o = C(), [r, i] = V(!1), c = e.tabs ?? [
    ...o.uploadFile !== void 0 ? [
      {
        name: n.file_panel.upload.title,
        tabPanel: /* @__PURE__ */ a(Xr, { blockId: e.blockId, setLoading: i })
      }
    ] : [],
    {
      name: n.file_panel.embed.title,
      tabPanel: /* @__PURE__ */ a(qr, { blockId: e.blockId })
    }
  ], [s, l] = V(
    e.defaultOpenTab || c[0].name
  );
  return /* @__PURE__ */ a(
    t.FilePanel.Root,
    {
      className: "bn-panel",
      defaultOpenTab: s,
      openTab: s,
      setOpenTab: l,
      tabs: c,
      loading: r
    }
  );
};
function Jr(e) {
  let t = new DOMRect();
  const n = "getBoundingClientRect" in e ? () => e.getBoundingClientRect() : () => e.element.getBoundingClientRect();
  return () => "element" in e && (e.cacheMountedBoundingClientRect ?? !0) ? (e.element.isConnected && (t = n()), t) : n();
}
const Q = (e) => {
  var g, b, v;
  const { refs: t, floatingStyles: n, context: o } = xt({
    whileElementsMounted: cr,
    ...e.useFloatingOptions
  }), { isMounted: r, styles: i } = Tt(
    o,
    e.useTransitionStylesProps
  ), { status: c } = lr(
    o,
    e.useTransitionStatusProps
  ), s = sr(o, e.useDismissProps), l = ar(o, { enabled: !1, ...e.useHoverProps }), { getFloatingProps: u } = ur([s, l]), d = q(""), f = q(null), m = dr([f, t.setFloating]);
  if (x(() => {
    e.reference && ("element" in e.reference && t.setReference(e.reference.element), t.setPositionReference({
      getBoundingClientRect: Jr(
        e.reference
      )
    }));
  }, [e.reference, t]), x(
    () => {
      var S;
      (c === "initial" || c === "open") && (S = f.current) != null && S.innerHTML && (d.current = f.current.innerHTML);
    },
    // `props.children` is added to the deps, since it's ultimately the HTML of
    // the children that we're storing.
    [c, e.reference, e.children]
  ), !r)
    return !1;
  const h = {
    ...e.elementProps,
    style: {
      display: "flex",
      ...(g = e.elementProps) == null ? void 0 : g.style,
      zIndex: `calc(var(--bn-ui-base-z-index) + ${((v = (b = e.elementProps) == null ? void 0 : b.style) == null ? void 0 : v.zIndex) || 0})`,
      ...n,
      ...i
    },
    ...u()
  };
  return c === "close" ? /* @__PURE__ */ a(
    "div",
    {
      ref: m,
      ...h,
      dangerouslySetInnerHTML: { __html: d.current }
    }
  ) : /* @__PURE__ */ a("div", { ref: m, ...h, children: e.children });
}, Gn = (e) => {
  const { blockId: t, children: n, ...o } = e, r = C(), i = T(
    () => r.transact((c) => {
      if (!t)
        return;
      const s = Ht(t, c.doc);
      if (!s)
        return;
      const { node: l } = r.prosemirrorView.domAtPos(
        s.posBeforeNode + 1
      );
      if (l instanceof Element)
        return {
          element: l
        };
    }),
    [r, t]
  );
  return /* @__PURE__ */ a(Q, { reference: i, ...o, children: t !== void 0 && n });
};
function Z(e, t) {
  const o = ((t == null ? void 0 : t.editor) ?? C()).getExtension(e);
  if (!o)
    throw new Error("Extension not found", { cause: { plugin: e } });
  return o;
}
function L(e, t) {
  const { store: n } = Z(e, t);
  if (!n)
    throw new Error("Store not found on plugin", { cause: { plugin: e } });
  return $r(n, t == null ? void 0 : t.selector);
}
const Yr = (e) => {
  const t = C(), n = Z(Ne), o = L(Ne), r = T(
    () => ({
      useFloatingOptions: {
        open: !!o,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (c, s, l) => {
          c || n.closeMenu(), l === "escape-key" && t.focus();
        },
        middleware: [ee(10), ue()]
      },
      elementProps: {
        style: {
          zIndex: 90
        }
      },
      ...e.floatingUIOptions
    }),
    [o, t, n, e.floatingUIOptions]
  ), i = e.filePanel || Un;
  return /* @__PURE__ */ a(Gn, { blockId: o, ...r, children: o && /* @__PURE__ */ a(i, { blockId: o }) });
};
function Qr(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var ei = function e(t, n) {
  if (t === n) return !0;
  if (t && n && typeof t == "object" && typeof n == "object") {
    if (t.constructor !== n.constructor) return !1;
    var o, r, i;
    if (Array.isArray(t)) {
      if (o = t.length, o != n.length) return !1;
      for (r = o; r-- !== 0; )
        if (!e(t[r], n[r])) return !1;
      return !0;
    }
    if (t instanceof Map && n instanceof Map) {
      if (t.size !== n.size) return !1;
      for (r of t.entries())
        if (!n.has(r[0])) return !1;
      for (r of t.entries())
        if (!e(r[1], n.get(r[0]))) return !1;
      return !0;
    }
    if (t instanceof Set && n instanceof Set) {
      if (t.size !== n.size) return !1;
      for (r of t.entries())
        if (!n.has(r[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(t) && ArrayBuffer.isView(n)) {
      if (o = t.length, o != n.length) return !1;
      for (r = o; r-- !== 0; )
        if (t[r] !== n[r]) return !1;
      return !0;
    }
    if (t.constructor === RegExp) return t.source === n.source && t.flags === n.flags;
    if (t.valueOf !== Object.prototype.valueOf) return t.valueOf() === n.valueOf();
    if (t.toString !== Object.prototype.toString) return t.toString() === n.toString();
    if (i = Object.keys(t), o = i.length, o !== Object.keys(n).length) return !1;
    for (r = o; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, i[r])) return !1;
    for (r = o; r-- !== 0; ) {
      var c = i[r];
      if (!(c === "_owner" && t.$$typeof) && !e(t[c], n[c]))
        return !1;
    }
    return !0;
  }
  return t !== t && n !== n;
};
const ti = /* @__PURE__ */ Qr(ei);
var ht = { exports: {} }, rt = {}, Ze = { exports: {} }, it = {};
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Xt;
function ni() {
  if (Xt) return it;
  Xt = 1;
  var e = W;
  function t(f, m) {
    return f === m && (f !== 0 || 1 / f === 1 / m) || f !== f && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : t, o = e.useState, r = e.useEffect, i = e.useLayoutEffect, c = e.useDebugValue;
  function s(f, m) {
    var h = m(), g = o({ inst: { value: h, getSnapshot: m } }), b = g[0].inst, v = g[1];
    return i(
      function() {
        b.value = h, b.getSnapshot = m, l(b) && v({ inst: b });
      },
      [f, h, m]
    ), r(
      function() {
        return l(b) && v({ inst: b }), f(function() {
          l(b) && v({ inst: b });
        });
      },
      [f]
    ), c(h), h;
  }
  function l(f) {
    var m = f.getSnapshot;
    f = f.value;
    try {
      var h = m();
      return !n(f, h);
    } catch {
      return !0;
    }
  }
  function u(f, m) {
    return m();
  }
  var d = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? u : s;
  return it.useSyncExternalStore = e.useSyncExternalStore !== void 0 ? e.useSyncExternalStore : d, it;
}
var ct = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Jt;
function oi() {
  return Jt || (Jt = 1, process.env.NODE_ENV !== "production" && function() {
    function e(h, g) {
      return h === g && (h !== 0 || 1 / h === 1 / g) || h !== h && g !== g;
    }
    function t(h, g) {
      d || r.startTransition === void 0 || (d = !0, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var b = g();
      if (!f) {
        var v = g();
        i(b, v) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), f = !0);
      }
      v = c({
        inst: { value: b, getSnapshot: g }
      });
      var S = v[0].inst, $ = v[1];
      return l(
        function() {
          S.value = b, S.getSnapshot = g, n(S) && $({ inst: S });
        },
        [h, b, g]
      ), s(
        function() {
          return n(S) && $({ inst: S }), h(function() {
            n(S) && $({ inst: S });
          });
        },
        [h]
      ), u(b), b;
    }
    function n(h) {
      var g = h.getSnapshot;
      h = h.value;
      try {
        var b = g();
        return !i(h, b);
      } catch {
        return !0;
      }
    }
    function o(h, g) {
      return g();
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var r = W, i = typeof Object.is == "function" ? Object.is : e, c = r.useState, s = r.useEffect, l = r.useLayoutEffect, u = r.useDebugValue, d = !1, f = !1, m = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? o : t;
    ct.useSyncExternalStore = r.useSyncExternalStore !== void 0 ? r.useSyncExternalStore : m, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), ct;
}
var Yt;
function Wn() {
  return Yt || (Yt = 1, process.env.NODE_ENV === "production" ? Ze.exports = ni() : Ze.exports = oi()), Ze.exports;
}
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var Qt;
function ri() {
  if (Qt) return rt;
  Qt = 1;
  var e = W, t = Wn();
  function n(u, d) {
    return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
  }
  var o = typeof Object.is == "function" ? Object.is : n, r = t.useSyncExternalStore, i = e.useRef, c = e.useEffect, s = e.useMemo, l = e.useDebugValue;
  return rt.useSyncExternalStoreWithSelector = function(u, d, f, m, h) {
    var g = i(null);
    if (g.current === null) {
      var b = { hasValue: !1, value: null };
      g.current = b;
    } else b = g.current;
    g = s(
      function() {
        function S(z) {
          if (!$) {
            if ($ = !0, I = z, z = m(z), h !== void 0 && b.hasValue) {
              var F = b.value;
              if (h(F, z))
                return M = F;
            }
            return M = z;
          }
          if (F = M, o(I, z)) return F;
          var oe = m(z);
          return h !== void 0 && h(F, oe) ? (I = z, F) : (I = z, M = oe);
        }
        var $ = !1, I, M, U = f === void 0 ? null : f;
        return [
          function() {
            return S(d());
          },
          U === null ? void 0 : function() {
            return S(U());
          }
        ];
      },
      [d, f, m, h]
    );
    var v = r(u, g[0], g[1]);
    return c(
      function() {
        b.hasValue = !0, b.value = v;
      },
      [v]
    ), l(v), v;
  }, rt;
}
var lt = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var en;
function ii() {
  return en || (en = 1, process.env.NODE_ENV !== "production" && function() {
    function e(u, d) {
      return u === d && (u !== 0 || 1 / u === 1 / d) || u !== u && d !== d;
    }
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var t = W, n = Wn(), o = typeof Object.is == "function" ? Object.is : e, r = n.useSyncExternalStore, i = t.useRef, c = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    lt.useSyncExternalStoreWithSelector = function(u, d, f, m, h) {
      var g = i(null);
      if (g.current === null) {
        var b = { hasValue: !1, value: null };
        g.current = b;
      } else b = g.current;
      g = s(
        function() {
          function S(z) {
            if (!$) {
              if ($ = !0, I = z, z = m(z), h !== void 0 && b.hasValue) {
                var F = b.value;
                if (h(F, z))
                  return M = F;
              }
              return M = z;
            }
            if (F = M, o(I, z))
              return F;
            var oe = m(z);
            return h !== void 0 && h(F, oe) ? (I = z, F) : (I = z, M = oe);
          }
          var $ = !1, I, M, U = f === void 0 ? null : f;
          return [
            function() {
              return S(d());
            },
            U === null ? void 0 : function() {
              return S(U());
            }
          ];
        },
        [d, f, m, h]
      );
      var v = r(u, g[0], g[1]);
      return c(
        function() {
          b.hasValue = !0, b.value = v;
        },
        [v]
      ), l(v), v;
    }, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  }()), lt;
}
process.env.NODE_ENV === "production" ? ht.exports = ri() : ht.exports = ii();
var ci = ht.exports;
const li = typeof window < "u" ? Ko : x;
class si {
  constructor(t) {
    he(this, "transactionNumber", 0);
    he(this, "lastTransactionNumber", 0);
    he(this, "lastSnapshot");
    he(this, "editor");
    he(this, "subscribers", /* @__PURE__ */ new Set());
    this.editor = t, this.lastSnapshot = { editor: t, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = {
      editor: this.editor,
      transactionNumber: this.transactionNumber
    }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(t) {
    return this.subscribers.add(t), () => {
      this.subscribers.delete(t);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(t, n) {
    if (this.editor = t, this.editor) {
      const o = () => {
        this.transactionNumber += 1, this.subscribers.forEach((c) => c());
      }, r = this.editor._tiptapEditor, i = {
        all: "transaction",
        selection: "selectionUpdate",
        change: "update"
      };
      return r.on(i[n], o), () => {
        r.off(i[n], o);
      };
    }
  }
}
function P(e) {
  const t = ne(), n = e.editor || (t == null ? void 0 : t.editor) || null, o = e.on || "all", [r] = V(() => new si(n)), i = ci.useSyncExternalStoreWithSelector(
    r.subscribe,
    r.getSnapshot,
    r.getServerSnapshot,
    e.selector,
    e.equalityFn ?? ti
  );
  return li(() => r.watch(n, o), [n, r, o]), qo(i), i;
}
const Mt = (e) => {
  const { position: t, children: n, ...o } = e, { from: r, to: i } = t || {}, c = C(), s = T(() => {
    var l;
    if (!(r === void 0 || i === void 0))
      return {
        // Use first child as the editor DOM element may itself be scrollable.
        // For FloatingUI to auto-update the position during scrolling, the
        // `contextElement` must be a descendant of the scroll container.
        element: ((l = c.domElement) == null ? void 0 : l.firstElementChild) || void 0,
        getBoundingClientRect: () => Dr(c.prosemirrorView, r, i ?? r)
      };
  }, [c, r, i]);
  return /* @__PURE__ */ a(Q, { reference: s, ...o, children: t !== void 0 && n });
};
var Kn = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
}, tn = W.createContext && /* @__PURE__ */ W.createContext(Kn), ai = ["attr", "size", "title"];
function ui(e, t) {
  if (e == null) return {};
  var n = di(e, t), o, r;
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(e);
    for (r = 0; r < i.length; r++)
      o = i[r], !(t.indexOf(o) >= 0) && Object.prototype.propertyIsEnumerable.call(e, o) && (n[o] = e[o]);
  }
  return n;
}
function di(e, t) {
  if (e == null) return {};
  var n = {};
  for (var o in e)
    if (Object.prototype.hasOwnProperty.call(e, o)) {
      if (t.indexOf(o) >= 0) continue;
      n[o] = e[o];
    }
  return n;
}
function $e() {
  return $e = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = arguments[t];
      for (var o in n)
        Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
    }
    return e;
  }, $e.apply(this, arguments);
}
function nn(e, t) {
  var n = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    t && (o = o.filter(function(r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), n.push.apply(n, o);
  }
  return n;
}
function De(e) {
  for (var t = 1; t < arguments.length; t++) {
    var n = arguments[t] != null ? arguments[t] : {};
    t % 2 ? nn(Object(n), !0).forEach(function(o) {
      fi(e, o, n[o]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : nn(Object(n)).forEach(function(o) {
      Object.defineProperty(e, o, Object.getOwnPropertyDescriptor(n, o));
    });
  }
  return e;
}
function fi(e, t, n) {
  return t = mi(t), t in e ? Object.defineProperty(e, t, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : e[t] = n, e;
}
function mi(e) {
  var t = hi(e, "string");
  return typeof t == "symbol" ? t : t + "";
}
function hi(e, t) {
  if (typeof e != "object" || !e) return e;
  var n = e[Symbol.toPrimitive];
  if (n !== void 0) {
    var o = n.call(e, t);
    if (typeof o != "object") return o;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (t === "string" ? String : Number)(e);
}
function qn(e) {
  return e && e.map((t, n) => /* @__PURE__ */ W.createElement(t.tag, De({
    key: n
  }, t.attr), qn(t.child)));
}
function w(e) {
  return (t) => /* @__PURE__ */ W.createElement(pi, $e({
    attr: De({}, e.attr)
  }, t), qn(e.child));
}
function pi(e) {
  var t = (n) => {
    var {
      attr: o,
      size: r,
      title: i
    } = e, c = ui(e, ai), s = r || n.size || "1em", l;
    return n.className && (l = n.className), e.className && (l = (l ? l + " " : "") + e.className), /* @__PURE__ */ W.createElement("svg", $e({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, n.attr, o, c, {
      className: l,
      style: De(De({
        color: e.color || n.color
      }, n.style), e.style),
      height: s,
      width: s,
      xmlns: "http://www.w3.org/2000/svg"
    }), i && /* @__PURE__ */ W.createElement("title", null, i), e.children);
  };
  return tn !== void 0 ? /* @__PURE__ */ W.createElement(tn.Consumer, null, (n) => t(n)) : t(Kn);
}
function gi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 7V11L2 6L8 1V5H13C17.4183 5 21 8.58172 21 13C21 17.4183 17.4183 21 13 21H4V19H13C16.3137 19 19 16.3137 19 13C19 9.68629 16.3137 7 13 7H8Z" }, child: [] }] })(e);
}
function Xn(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M7.29117 20.8242L2 22L3.17581 16.7088C2.42544 15.3056 2 13.7025 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C10.2975 22 8.6944 21.5746 7.29117 20.8242ZM7.58075 18.711L8.23428 19.0605C9.38248 19.6745 10.6655 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.3345 4.32549 14.6175 4.93949 15.7657L5.28896 16.4192L4.63416 19.3658L7.58075 18.711Z" }, child: [] }] })(e);
}
function bi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M7.24264 17.9967H3V13.754L14.435 2.319C14.8256 1.92848 15.4587 1.92848 15.8492 2.319L18.6777 5.14743C19.0682 5.53795 19.0682 6.17112 18.6777 6.56164L7.24264 17.9967ZM3 19.9967H21V21.9967H3V19.9967Z" }, child: [] }] })(e);
}
function vi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M23 12L15.9289 19.0711L14.5147 17.6569L20.1716 12L14.5147 6.34317L15.9289 4.92896L23 12ZM3.82843 12L9.48528 17.6569L8.07107 19.0711L1 12L8.07107 4.92896L9.48528 6.34317L3.82843 12Z" }, child: [] }] })(e);
}
function Zt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 8L9.00319 2H19.9978C20.5513 2 21 2.45531 21 2.9918V21.0082C21 21.556 20.5551 22 20.0066 22H3.9934C3.44476 22 3 21.5501 3 20.9932V8ZM10 4V9H5V20H19V4H10Z" }, child: [] }] })(e);
}
function Ci(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM5 19H19V21H5V19ZM3 14H21V16H3V14ZM5 9H19V11H5V9Z" }, child: [] }] })(e);
}
function _i(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM3 14H21V16H3V14ZM3 9H21V11H3V9Z" }, child: [] }] })(e);
}
function wi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H17V21H3V19ZM3 14H21V16H3V14ZM3 9H17V11H3V9Z" }, child: [] }] })(e);
}
function ki(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM7 19H21V21H7V19ZM3 14H21V16H3V14ZM7 9H21V11H7V9Z" }, child: [] }] })(e);
}
function yi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 11H12.5C13.8807 11 15 9.88071 15 8.5C15 7.11929 13.8807 6 12.5 6H8V11ZM18 15.5C18 17.9853 15.9853 20 13.5 20H6V4H12.5C14.9853 4 17 6.01472 17 8.5C17 9.70431 16.5269 10.7981 15.7564 11.6058C17.0979 12.3847 18 13.837 18 15.5ZM8 13V18H13.5C14.8807 18 16 16.8807 16 15.5C16 14.1193 14.8807 13 13.5 13H8Z" }, child: [] }] })(e);
}
function Si(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3.41436 5.99995L5.70726 3.70706L4.29304 2.29285L0.585938 5.99995L4.29304 9.70706L5.70726 8.29285L3.41436 5.99995ZM9.58594 5.99995L7.29304 3.70706L8.70726 2.29285L12.4144 5.99995L8.70726 9.70706L7.29304 8.29285L9.58594 5.99995ZM14.0002 2.99995H21.0002C21.5524 2.99995 22.0002 3.44767 22.0002 3.99995V20C22.0002 20.5522 21.5524 21 21.0002 21H3.00015C2.44787 21 2.00015 20.5522 2.00015 20V12H4.00015V19H20.0002V4.99995H14.0002V2.99995Z" }, child: [] }] })(e);
}
function on(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5.55397 22H3.3999L10.9999 3H12.9999L20.5999 22H18.4458L16.0458 16H7.95397L5.55397 22ZM8.75397 14H15.2458L11.9999 5.88517L8.75397 14Z" }, child: [] }] })(e);
}
function pt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM21.0005 8V20H19.0005L19 10.204L17 10.74V8.67L19.5005 8H21.0005Z" }, child: [] }] })(e);
}
function gt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 8C20.5711 8 22.25 9.67893 22.25 11.75C22.25 12.6074 21.9623 13.3976 21.4781 14.0292L21.3302 14.2102L18.0343 18H22V20H15L14.9993 18.444L19.8207 12.8981C20.0881 12.5908 20.25 12.1893 20.25 11.75C20.25 10.7835 19.4665 10 18.5 10C17.5818 10 16.8288 10.7071 16.7558 11.6065L16.75 11.75H14.75C14.75 9.67893 16.4289 8 18.5 8Z" }, child: [] }] })(e);
}
function bt(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M22 8L21.9984 10L19.4934 12.883C21.0823 13.3184 22.25 14.7728 22.25 16.5C22.25 18.5711 20.5711 20.25 18.5 20.25C16.674 20.25 15.1528 18.9449 14.8184 17.2166L16.7821 16.8352C16.9384 17.6413 17.6481 18.25 18.5 18.25C19.4665 18.25 20.25 17.4665 20.25 16.5C20.25 15.5335 19.4665 14.75 18.5 14.75C18.214 14.75 17.944 14.8186 17.7056 14.9403L16.3992 13.3932L19.3484 10H15V8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" }, child: [] }] })(e);
}
function Jn(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 20H11V13H4V20H2V4H4V11H11V4H13V20ZM22 8V16H23.5V18H22V20H20V18H14.5V16.66L19.5 8H22ZM20 11.133L17.19 16H20V11.133Z" }, child: [] }] })(e);
}
function Yn(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M22 8V10H17.6769L17.2126 12.6358C17.5435 12.5472 17.8912 12.5 18.25 12.5C20.4591 12.5 22.25 14.2909 22.25 16.5C22.25 18.7091 20.4591 20.5 18.25 20.5C16.4233 20.5 14.8827 19.2756 14.4039 17.6027L16.3271 17.0519C16.5667 17.8881 17.3369 18.5 18.25 18.5C19.3546 18.5 20.25 17.6046 20.25 16.5C20.25 15.3954 19.3546 14.5 18.25 14.5C17.6194 14.5 17.057 14.7918 16.6904 15.2478L14.8803 14.3439L16 8H22ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4Z" }, child: [] }] })(e);
}
function Qn(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21.097 8L18.499 12.5C20.7091 12.5 22.5 14.2909 22.5 16.5C22.5 18.7091 20.7091 20.5 18.5 20.5C16.2909 20.5 14.5 18.7091 14.5 16.5C14.5 15.7636 14.699 15.0737 15.0461 14.4811L18.788 8H21.097ZM4 4V11H11V4H13V20H11V13H4V20H2V4H4ZM18.5 14.5C17.3954 14.5 16.5 15.3954 16.5 16.5C16.5 17.6046 17.3954 18.5 18.5 18.5C19.6046 18.5 20.5 17.6046 20.5 16.5C20.5 15.3954 19.6046 14.5 18.5 14.5Z" }, child: [] }] })(e);
}
function Ei(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM3 12.5L7 9V16L3 12.5Z" }, child: [] }] })(e);
}
function xi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 4H21V6H3V4ZM3 19H21V21H3V19ZM11 14H21V16H11V14ZM11 9H21V11H11V9ZM7 12.5L3 16V9L7 12.5Z" }, child: [] }] })(e);
}
function rn(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 5H11V19H8V21H16V19H13V5H16V3H8V5ZM2 7C1.44772 7 1 7.44772 1 8V16C1 16.5523 1.44772 17 2 17H8V15H3V9H8V7H2ZM16 9H21V15H16V17H22C22.5523 17 23 16.5523 23 16V8C23 7.44772 22.5523 7 22 7H16V9Z" }, child: [] }] })(e);
}
function Ti(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M15 20H7V18H9.92661L12.0425 6H9V4H17V6H14.0734L11.9575 18H15V20Z" }, child: [] }] })(e);
}
function Hi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 17H22V19H19V22H17V17ZM7 7H2V5H5V2H7V7ZM18.364 15.5355L16.9497 14.1213L18.364 12.7071C20.3166 10.7545 20.3166 7.58866 18.364 5.63604C16.4113 3.68342 13.2455 3.68342 11.2929 5.63604L9.87868 7.05025L8.46447 5.63604L9.87868 4.22183C12.6123 1.48816 17.0445 1.48816 19.7782 4.22183C22.5118 6.9555 22.5118 11.3877 19.7782 14.1213L18.364 15.5355ZM15.5355 18.364L14.1213 19.7782C11.3877 22.5118 6.9555 22.5118 4.22183 19.7782C1.48816 17.0445 1.48816 12.6123 4.22183 9.87868L5.63604 8.46447L7.05025 9.87868L5.63604 11.2929C3.68342 13.2455 3.68342 16.4113 5.63604 18.364C7.58866 20.3166 10.7545 20.3166 12.7071 18.364L14.1213 16.9497L15.5355 18.364ZM14.8284 7.75736L16.2426 9.17157L9.17157 16.2426L7.75736 14.8284L14.8284 7.75736Z" }, child: [] }] })(e);
}
function eo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M18.3638 15.5355L16.9496 14.1213L18.3638 12.7071C20.3164 10.7545 20.3164 7.58866 18.3638 5.63604C16.4112 3.68341 13.2453 3.68341 11.2927 5.63604L9.87849 7.05025L8.46428 5.63604L9.87849 4.22182C12.6122 1.48815 17.0443 1.48815 19.778 4.22182C22.5117 6.95549 22.5117 11.3876 19.778 14.1213L18.3638 15.5355ZM15.5353 18.364L14.1211 19.7782C11.3875 22.5118 6.95531 22.5118 4.22164 19.7782C1.48797 17.0445 1.48797 12.6123 4.22164 9.87868L5.63585 8.46446L7.05007 9.87868L5.63585 11.2929C3.68323 13.2455 3.68323 16.4113 5.63585 18.364C7.58847 20.3166 10.7543 20.3166 12.7069 18.364L14.1211 16.9497L15.5353 18.364ZM14.8282 7.75736L16.2425 9.17157L9.17139 16.2426L7.75717 14.8284L14.8282 7.75736Z" }, child: [] }] })(e);
}
function to(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8.00008 6V9H5.00008V6H8.00008ZM3.00008 4V11H10.0001V4H3.00008ZM13.0001 4H21.0001V6H13.0001V4ZM13.0001 11H21.0001V13H13.0001V11ZM13.0001 18H21.0001V20H13.0001V18ZM10.7072 16.2071L9.29297 14.7929L6.00008 18.0858L4.20718 16.2929L2.79297 17.7071L6.00008 20.9142L10.7072 16.2071Z" }, child: [] }] })(e);
}
function no(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM5 3V6H6V7H3V6H4V4H3V3H5ZM3 14V11.5H5V11H3V10H6V12.5H4V13H6V14H3ZM5 19.5H3V18.5H5V18H3V17H6V21H3V20H5V19.5ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" }, child: [] }] })(e);
}
function oo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 4H21V6H8V4ZM4.5 6.5C3.67157 6.5 3 5.82843 3 5C3 4.17157 3.67157 3.5 4.5 3.5C5.32843 3.5 6 4.17157 6 5C6 5.82843 5.32843 6.5 4.5 6.5ZM4.5 13.5C3.67157 13.5 3 12.8284 3 12C3 11.1716 3.67157 10.5 4.5 10.5C5.32843 10.5 6 11.1716 6 12C6 12.8284 5.32843 13.5 4.5 13.5ZM4.5 20.4C3.67157 20.4 3 19.7284 3 18.9C3 18.0716 3.67157 17.4 4.5 17.4C5.32843 17.4 6 18.0716 6 18.9C6 19.7284 5.32843 20.4 4.5 20.4ZM8 11H21V13H8V11ZM8 18H21V20H8V18Z" }, child: [] }] })(e);
}
function Vi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M20 3C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM11 5H5V10.999H7V9L10 12L7 15V13H5V19H11V17H13V19H19V13H17V15L14 12L17 9V10.999H19V5H13V7H11V5ZM13 13V15H11V13H13ZM13 9V11H11V9H13Z" }, child: [] }] })(e);
}
function Mi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20C20.5523 3 21 3.44772 21 4V20ZM19 11V5H13.001V7H15L12 10L9 7H11V5H5V11H7V13H5V19H11V17H9L12 14L15 17H13.001V19H19V13H17V11H19ZM11 13H9V11H11V13ZM15 13H13V11H15V13Z" }, child: [] }] })(e);
}
function ro(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 4H3V6H21V4ZM21 11H8V13H21V11ZM21 18H8V20H21V18ZM5 11H3V20H5V11Z" }, child: [] }] })(e);
}
function Zi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17.1538 14C17.3846 14.5161 17.5 15.0893 17.5 15.7196C17.5 17.0625 16.9762 18.1116 15.9286 18.867C14.8809 19.6223 13.4335 20 11.5862 20C9.94674 20 8.32335 19.6185 6.71592 18.8555V16.6009C8.23538 17.4783 9.7908 17.917 11.3822 17.917C13.9333 17.917 15.2128 17.1846 15.2208 15.7196C15.2208 15.0939 15.0049 14.5598 14.5731 14.1173C14.5339 14.0772 14.4939 14.0381 14.4531 14H3V12H21V14H17.1538ZM13.076 11H7.62908C7.4566 10.8433 7.29616 10.6692 7.14776 10.4778C6.71592 9.92084 6.5 9.24559 6.5 8.45207C6.5 7.21602 6.96583 6.165 7.89749 5.299C8.82916 4.43299 10.2706 4 12.2219 4C13.6934 4 15.1009 4.32808 16.4444 4.98426V7.13591C15.2448 6.44921 13.9293 6.10587 12.4978 6.10587C10.0187 6.10587 8.77917 6.88793 8.77917 8.45207C8.77917 8.87172 8.99709 9.23796 9.43293 9.55079C9.86878 9.86362 10.4066 10.1135 11.0463 10.3004C11.6665 10.4816 12.3431 10.7148 13.076 11H13.076Z" }, child: [] }] })(e);
}
function Ii(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 10V14H19V10H13ZM11 10H5V14H11V10ZM13 19H19V16H13V19ZM11 19V16H5V19H11ZM13 5V8H19V5H13ZM11 5H5V8H11V5ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3Z" }, child: [] }] })(e);
}
function It(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M13 6V21H11V6H5V4H19V6H13Z" }, child: [] }] })(e);
}
function Li(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M8 3V12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12V3H18V12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12V3H8ZM4 20H20V22H4V20Z" }, child: [] }] })(e);
}
function zi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M2 3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082C21.556 3 22 3.44495 22 3.9934V20.0066C22 20.5552 21.5447 21 21.0082 21H2.9918C2.44405 21 2 20.5551 2 20.0066V3.9934ZM8 5V19H16V5H8ZM4 5V7H6V5H4ZM18 5V7H20V5H18ZM4 9V11H6V9H4ZM18 9V11H20V9H18ZM4 13V15H6V13H4ZM18 13V15H20V13H18ZM4 17V19H6V17H4ZM18 17V19H20V17H18Z" }, child: [] }] })(e);
}
function io(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 11.1005L7 9.1005L12.5 14.6005L16 11.1005L19 14.1005V5H5V11.1005ZM4 3H20C20.5523 3 21 3.44772 21 4V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3ZM15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10Z" }, child: [] }] })(e);
}
function Ri(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M21 15V18H24V20H21V23H19V20H16V18H19V15H21ZM21.0082 3C21.556 3 22 3.44495 22 3.9934L22.0007 13.3417C21.3749 13.1204 20.7015 13 20 13V5H4L4.001 19L13.2929 9.70715C13.6528 9.34604 14.22 9.31823 14.6123 9.62322L14.7065 9.70772L18.2521 13.2586C15.791 14.0069 14 16.2943 14 19C14 19.7015 14.1204 20.3749 14.3417 21.0007L2.9918 21C2.44405 21 2 20.5551 2 20.0066V3.9934C2 3.44476 2.45531 3 2.9918 3H21.0082ZM8 7C9.10457 7 10 7.89543 10 9C10 10.1046 9.10457 11 8 11C6.89543 11 6 10.1046 6 9C6 7.89543 6.89543 7 8 7Z" }, child: [] }] })(e);
}
function Bi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M20 3C20.5523 3 21 3.44772 21 4V5.757L19 7.757V5H5V13.1L9 9.1005L13.328 13.429L12.0012 14.7562L11.995 18.995L16.2414 19.0012L17.571 17.671L18.8995 19H19V16.242L21 14.242V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V4C3 3.44772 3.44772 3 4 3H20ZM21.7782 7.80761L23.1924 9.22183L15.4142 17L13.9979 16.9979L14 15.5858L21.7782 7.80761ZM15.5 7C16.3284 7 17 7.67157 17 8.5C17 9.32843 16.3284 10 15.5 10C14.6716 10 14 9.32843 14 8.5C14 7.67157 14.6716 7 15.5 7Z" }, child: [] }] })(e);
}
function co(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M22 18V20H2V18H22ZM2 3.5L10 8.5L2 13.5V3.5ZM22 11V13H12V11H22ZM22 4V6H12V4H22Z" }, child: [] }] })(e);
}
function Oi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M3 3.9934C3 3.44476 3.44495 3 3.9934 3H20.0066C20.5552 3 21 3.44495 21 3.9934V20.0066C21 20.5552 20.5551 21 20.0066 21H3.9934C3.44476 21 3 20.5551 3 20.0066V3.9934ZM10.6219 8.41459C10.5562 8.37078 10.479 8.34741 10.4 8.34741C10.1791 8.34741 10 8.52649 10 8.74741V15.2526C10 15.3316 10.0234 15.4088 10.0672 15.4745C10.1897 15.6583 10.4381 15.708 10.6219 15.5854L15.5008 12.3328C15.5447 12.3035 15.5824 12.2658 15.6117 12.2219C15.7343 12.0381 15.6846 11.7897 15.5008 11.6672L10.6219 8.41459Z" }, child: [] }] })(e);
}
function lo(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M2 16.0001H5.88889L11.1834 20.3319C11.2727 20.405 11.3846 20.4449 11.5 20.4449C11.7761 20.4449 12 20.2211 12 19.9449V4.05519C12 3.93977 11.9601 3.8279 11.887 3.73857C11.7121 3.52485 11.3971 3.49335 11.1834 3.66821L5.88889 8.00007H2C1.44772 8.00007 1 8.44778 1 9.00007V15.0001C1 15.5524 1.44772 16.0001 2 16.0001ZM23 12C23 15.292 21.5539 18.2463 19.2622 20.2622L17.8445 18.8444C19.7758 17.1937 21 14.7398 21 12C21 9.26016 19.7758 6.80629 17.8445 5.15557L19.2622 3.73779C21.5539 5.75368 23 8.70795 23 12ZM18 12C18 10.0883 17.106 8.38548 15.7133 7.28673L14.2842 8.71584C15.3213 9.43855 16 10.64 16 12C16 13.36 15.3213 14.5614 14.2842 15.2841L15.7133 16.7132C17.106 15.6145 18 13.9116 18 12Z" }, child: [] }] })(e);
}
function Pi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M11 11V5H13V11H19V13H13V19H11V13H5V11H11Z" }, child: [] }] })(e);
}
function Ni(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M9.9997 15.1709L19.1921 5.97852L20.6063 7.39273L9.9997 17.9993L3.63574 11.6354L5.04996 10.2212L9.9997 15.1709Z" }, child: [] }] })(e);
}
function Ai(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM18 8H6V20H18V8ZM9 4V6H15V4H9Z" }, child: [] }] })(e);
}
function $i(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M17 6H22V8H20V21C20 21.5523 19.5523 22 19 22H5C4.44772 22 4 21.5523 4 21V8H2V6H7V3C7 2.44772 7.44772 2 8 2H16C16.5523 2 17 2.44772 17 3V6ZM9 11V17H11V11H9ZM13 11V17H15V11H13ZM9 4V6H15V4H9Z" }, child: [] }] })(e);
}
function Di(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M4 19H20V12H22V20C22 20.5523 21.5523 21 21 21H3C2.44772 21 2 20.5523 2 20V12H4V19ZM14 9H19L12 16L5 9H10V3H14V9Z" }, child: [] }] })(e);
}
function Fi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M10 6V8H5V19H16V14H18V20C18 20.5523 17.5523 21 17 21H4C3.44772 21 3 20.5523 3 20V7C3 6.44772 3.44772 6 4 6H10ZM21 3V12L17.206 8.207L11.2071 14.2071L9.79289 12.7929L15.792 6.793L12 3H21Z" }, child: [] }] })(e);
}
function ji(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 10C3.9 10 3 10.9 3 12C3 13.1 3.9 14 5 14C6.1 14 7 13.1 7 12C7 10.9 6.1 10 5 10ZM19 10C17.9 10 17 10.9 17 12C17 13.1 17.9 14 19 14C20.1 14 21 13.1 21 12C21 10.9 20.1 10 19 10ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10Z" }, child: [] }] })(e);
}
function Ui(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M5 11V13H19V11H5Z" }, child: [] }] })(e);
}
function Gi(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM8 13C8 15.2091 9.79086 17 12 17C14.2091 17 16 15.2091 16 13H8ZM8 11C8.82843 11 9.5 10.3284 9.5 9.5C9.5 8.67157 8.82843 8 8 8C7.17157 8 6.5 8.67157 6.5 9.5C6.5 10.3284 7.17157 11 8 11ZM16 11C16.8284 11 17.5 10.3284 17.5 9.5C17.5 8.67157 16.8284 8 16 8C15.1716 8 14.5 8.67157 14.5 9.5C14.5 10.3284 15.1716 11 16 11Z" }, child: [] }] })(e);
}
function cn(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "currentColor" }, child: [{ tag: "path", attr: { d: "M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20ZM8 13H16C16 15.2091 14.2091 17 12 17C9.79086 17 8 15.2091 8 13ZM8 11C7.17157 11 6.5 10.3284 6.5 9.5C6.5 8.67157 7.17157 8 8 8C8.82843 8 9.5 8.67157 9.5 9.5C9.5 10.3284 8.82843 11 8 11ZM16 11C15.1716 11 14.5 10.3284 14.5 9.5C14.5 8.67157 15.1716 8 16 8C16.8284 8 17.5 8.67157 17.5 9.5C17.5 10.3284 16.8284 11 16 11Z" }, child: [] }] })(e);
}
const Wi = {
  bold: yi,
  italic: Ti,
  underline: Li,
  strike: Zi,
  code: vi
};
function Ki(e, t) {
  return e in t.schema.styleSchema && t.schema.styleSchema[e].type === e && t.schema.styleSchema[e].propSchema === "boolean";
}
const Ie = (e) => {
  const t = H(), n = _(), o = C(), r = P({
    editor: o,
    selector: ({ editor: s }) => {
      var l;
      if (
        // The editor is read-only.
        !(!s.isEditable || // The style is not in the schema.
        !Ki(e.basicTextStyle, s) || // None of the selected blocks have inline content
        !(((l = s.getSelection()) == null ? void 0 : l.blocks) || [
          s.getTextCursorPosition().block
        ]).find((u) => u.content !== void 0))
      )
        return e.basicTextStyle in s.getActiveStyles() ? { active: !0 } : { active: !1 };
    }
  }), i = y(
    (s) => {
      o.focus(), o.toggleStyles({ [s]: !0 });
    },
    [o, e]
  );
  if (r === void 0)
    return null;
  const c = Wi[e.basicTextStyle];
  return /* @__PURE__ */ a(
    n.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": e.basicTextStyle,
      onClick: () => i(e.basicTextStyle),
      isSelected: r.active,
      label: t.formatting_toolbar[e.basicTextStyle].tooltip,
      mainTooltip: t.formatting_toolbar[e.basicTextStyle].tooltip,
      secondaryTooltip: Ke(
        t.formatting_toolbar[e.basicTextStyle].secondary_tooltip,
        t.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ a(c, {})
    }
  );
}, vt = (e) => {
  const t = e.textColor || "default", n = e.backgroundColor || "default", o = e.size || 16, r = T(
    () => ({
      pointerEvents: "none",
      fontSize: (o * 0.75).toString() + "px",
      height: o.toString() + "px",
      lineHeight: o.toString() + "px",
      textAlign: "center",
      width: o.toString() + "px"
    }),
    [o]
  );
  return /* @__PURE__ */ a(
    "div",
    {
      className: "bn-color-icon",
      "data-background-color": n,
      "data-text-color": t,
      style: r,
      children: "A"
    }
  );
}, ln = [
  "default",
  "gray",
  "brown",
  "red",
  "orange",
  "yellow",
  "green",
  "blue",
  "purple",
  "pink"
], qe = (e) => {
  const t = _(), n = H();
  return /* @__PURE__ */ E(j, { children: [
    /* @__PURE__ */ a(() => e.text ? /* @__PURE__ */ E(j, { children: [
      /* @__PURE__ */ a(t.Generic.Menu.Label, { children: n.color_picker.text_title }),
      ln.map((i) => /* @__PURE__ */ a(
        t.Generic.Menu.Item,
        {
          onClick: () => {
            e.onClick && e.onClick(), e.text.setColor(i);
          },
          "data-test": "text-color-" + i,
          icon: /* @__PURE__ */ a(vt, { textColor: i, size: e.iconSize }),
          checked: e.text.color === i,
          children: n.color_picker.colors[i]
        },
        "text-color-" + i
      ))
    ] }) : null, {}),
    /* @__PURE__ */ a(() => e.background ? /* @__PURE__ */ E(j, { children: [
      /* @__PURE__ */ a(t.Generic.Menu.Label, { children: n.color_picker.background_title }),
      ln.map((i) => /* @__PURE__ */ a(
        t.Generic.Menu.Item,
        {
          onClick: () => {
            e.onClick && e.onClick(), e.background.setColor(i);
          },
          "data-test": "background-color-" + i,
          icon: /* @__PURE__ */ a(vt, { backgroundColor: i, size: e.iconSize }),
          checked: e.background.color === i,
          children: n.color_picker.colors[i]
        },
        "background-color-" + i
      ))
    ] }) : null, {})
  ] });
};
function Le(e, t) {
  return `${e}Color` in t.schema.styleSchema && t.schema.styleSchema[`${e}Color`].type === `${e}Color` && t.schema.styleSchema[`${e}Color`].propSchema === "string";
}
const qi = () => {
  const e = _(), t = H(), n = C(), o = Le("text", n), r = Le("background", n), i = P({
    editor: n,
    selector: ({ editor: l }) => {
      var f;
      if (
        // The editor is read-only.
        !l.isEditable || // None of the selected blocks have inline content
        !(((f = l.getSelection()) == null ? void 0 : f.blocks) || [
          l.getTextCursorPosition().block
        ]).find((m) => m.content !== void 0)
      )
        return;
      const u = Le("text", l), d = Le("background", l);
      if (!(!u && !d))
        return {
          textColor: u ? l.getActiveStyles().textColor || "default" : void 0,
          backgroundColor: d ? l.getActiveStyles().backgroundColor || "default" : void 0
        };
    }
  }), c = y(
    (l) => {
      if (!o)
        throw Error(
          "Tried to set text color, but style does not exist in editor schema."
        );
      l === "default" ? n.removeStyles({ textColor: l }) : n.addStyles({ textColor: l }), setTimeout(() => {
        n.focus();
      });
    },
    [n, o]
  ), s = y(
    (l) => {
      if (!r)
        throw Error(
          "Tried to set background color, but style does not exist in editor schema."
        );
      l === "default" ? n.removeStyles({ backgroundColor: l }) : n.addStyles({ backgroundColor: l }), setTimeout(() => {
        n.focus();
      });
    },
    [r, n]
  );
  return i === void 0 ? null : /* @__PURE__ */ E(e.Generic.Menu.Root, { children: [
    /* @__PURE__ */ a(e.Generic.Menu.Trigger, { children: /* @__PURE__ */ a(
      e.FormattingToolbar.Button,
      {
        className: "bn-button",
        "data-test": "colors",
        label: t.formatting_toolbar.colors.tooltip,
        mainTooltip: t.formatting_toolbar.colors.tooltip,
        icon: /* @__PURE__ */ a(
          vt,
          {
            textColor: i.textColor,
            backgroundColor: i.backgroundColor,
            size: 20
          }
        )
      }
    ) }),
    /* @__PURE__ */ a(
      e.Generic.Menu.Dropdown,
      {
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ a(
          qe,
          {
            text: i.textColor ? {
              color: i.textColor,
              setColor: c
            } : void 0,
            background: i.backgroundColor ? {
              color: i.backgroundColor,
              setColor: s
            } : void 0
          }
        )
      }
    )
  ] });
}, sn = (e) => {
  for (const t of er)
    if (e.startsWith(t))
      return e;
  return `${tr}://${e}`;
}, so = (e) => {
  const t = _(), n = H(), { editLink: o } = Z(We), { url: r, text: i, showTextField: c } = e, [s, l] = V(r), [u, d] = V(i);
  x(() => {
    l(r), d(i);
  }, [i, r]);
  const f = y(
    (b) => {
      var v, S;
      b.key === "Enter" && (b.preventDefault(), o(sn(s), u, e.range.from), (v = e.setToolbarOpen) == null || v.call(e, !1), (S = e.setToolbarFrozen) == null || S.call(e, !1));
    },
    [o, s, u, e]
  ), m = y(
    (b) => l(b.currentTarget.value),
    []
  ), h = y(
    (b) => d(b.currentTarget.value),
    []
  ), g = y(() => {
    var b, v;
    o(sn(s), u, e.range.from), (b = e.setToolbarOpen) == null || b.call(e, !1), (v = e.setToolbarFrozen) == null || v.call(e, !1);
  }, [o, s, u, e]);
  return /* @__PURE__ */ E(t.Generic.Form.Root, { children: [
    /* @__PURE__ */ a(
      t.Generic.Form.TextInput,
      {
        className: "bn-text-input",
        name: "url",
        icon: /* @__PURE__ */ a(eo, {}),
        autoFocus: !0,
        placeholder: n.link_toolbar.form.url_placeholder,
        value: s,
        onKeyDown: f,
        onChange: m,
        onSubmit: g
      }
    ),
    c !== !1 && /* @__PURE__ */ a(
      t.Generic.Form.TextInput,
      {
        className: "bn-text-input",
        name: "title",
        icon: /* @__PURE__ */ a(It, {}),
        placeholder: n.link_toolbar.form.title_placeholder,
        value: u,
        onKeyDown: f,
        onChange: h,
        onSubmit: g
      }
    )
  ] });
};
function Xi(e) {
  return "link" in e.schema.inlineContentSchema && e.schema.inlineContentSchema.link === "link";
}
const Ji = () => {
  const e = C(), t = _(), n = H(), o = Z(be), { showSelection: r } = Z(nr), [i, c] = V(!1);
  x(() => {
    r(i);
  }, [i, r]);
  const s = P({
    editor: e,
    selector: ({ editor: l }) => {
      var u;
      if (
        // The editor is read-only.
        !(!l.isEditable || // Links are not in the schema.
        !Xi(l) || // Table cells are selected.
        mr(l.prosemirrorState.selection) || // None of the selected blocks have inline content
        !(((u = l.getSelection()) == null ? void 0 : u.blocks) || [
          l.getTextCursorPosition().block
        ]).find((d) => d.content !== void 0))
      )
        return {
          url: l.getSelectedLinkUrl(),
          text: l.getSelectedText(),
          range: {
            from: l.prosemirrorState.selection.from,
            to: l.prosemirrorState.selection.to
          }
        };
    }
  });
  return x(() => {
    const l = (u) => {
      (u.ctrlKey || u.metaKey) && u.key === "k" && (c(!0), u.preventDefault());
    };
    return e.prosemirrorView.dom.addEventListener("keydown", l), () => {
      e.prosemirrorView.dom.removeEventListener("keydown", l);
    };
  }, [e.prosemirrorView, e.headless]), s === void 0 ? null : /* @__PURE__ */ E(t.Generic.Popover.Root, { open: i, children: [
    /* @__PURE__ */ a(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ a(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        "data-test": "createLink",
        label: n.formatting_toolbar.link.tooltip,
        mainTooltip: n.formatting_toolbar.link.tooltip,
        secondaryTooltip: Ke(
          n.formatting_toolbar.link.secondary_tooltip,
          n.generic.ctrl_shortcut
        ),
        icon: /* @__PURE__ */ a(eo, {}),
        onClick: () => c(!0)
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ a(
          so,
          {
            url: s.url || "",
            text: s.text,
            range: s.range,
            showTextField: !1,
            setToolbarOpen: (l) => o.store.setState(l)
          }
        )
      }
    )
  ] });
};
function p(e, t, n) {
  function o(s, l) {
    var u;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (u = s._zod).traits ?? (u.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(e), t(s, l);
    for (const d in c.prototype)
      d in s || Object.defineProperty(s, d, { value: c.prototype[d].bind(s) });
    s._zod.constr = c, s._zod.def = l;
  }
  const r = (n == null ? void 0 : n.Parent) ?? Object;
  class i extends r {
  }
  Object.defineProperty(i, "name", { value: e });
  function c(s) {
    var l;
    const u = n != null && n.Parent ? new i() : this;
    o(u, s), (l = u._zod).deferred ?? (l.deferred = []);
    for (const d of u._zod.deferred)
      d();
    return u;
  }
  return Object.defineProperty(c, "init", { value: o }), Object.defineProperty(c, Symbol.hasInstance, {
    value: (s) => {
      var l, u;
      return n != null && n.Parent && s instanceof n.Parent ? !0 : (u = (l = s == null ? void 0 : s._zod) == null ? void 0 : l.traits) == null ? void 0 : u.has(e);
    }
  }), Object.defineProperty(c, "name", { value: e }), c;
}
class ge extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class ao extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const uo = {};
function se(e) {
  return uo;
}
function Yi(e) {
  const t = Object.values(e).filter((o) => typeof o == "number");
  return Object.entries(e).filter(([o, r]) => t.indexOf(+o) === -1).map(([o, r]) => r);
}
function Ct(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Lt(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function zt(e) {
  return e == null;
}
function Rt(e) {
  const t = e.startsWith("^") ? 1 : 0, n = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, n);
}
function Qi(e, t) {
  const n = (e.toString().split(".")[1] || "").length, o = t.toString();
  let r = (o.split(".")[1] || "").length;
  if (r === 0 && /\d?e-\d?/.test(o)) {
    const l = o.match(/\d?e-(\d?)/);
    l != null && l[1] && (r = Number.parseInt(l[1]));
  }
  const i = n > r ? n : r, c = Number.parseInt(e.toFixed(i).replace(".", "")), s = Number.parseInt(t.toFixed(i).replace(".", ""));
  return c % s / 10 ** i;
}
const an = Symbol("evaluating");
function R(e, t, n) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== an)
        return o === void 0 && (o = an, o = n()), o;
    },
    set(r) {
      Object.defineProperty(e, t, {
        value: r
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function de(e, t, n) {
  Object.defineProperty(e, t, {
    value: n,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function fe(...e) {
  const t = {};
  for (const n of e) {
    const o = Object.getOwnPropertyDescriptors(n);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function un(e) {
  return JSON.stringify(e);
}
const fo = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function Fe(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const ec = Lt(() => {
  var e;
  if (typeof navigator < "u" && ((e = navigator == null ? void 0 : navigator.userAgent) != null && e.includes("Cloudflare")))
    return !1;
  try {
    const t = Function;
    return new t(""), !0;
  } catch {
    return !1;
  }
});
function Se(e) {
  if (Fe(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const n = t.prototype;
  return !(Fe(n) === !1 || Object.prototype.hasOwnProperty.call(n, "isPrototypeOf") === !1);
}
function mo(e) {
  return Se(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const tc = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function Xe(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function ce(e, t, n) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || n != null && n.parent) && (o._zod.parent = e), o;
}
function k(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if ((t == null ? void 0 : t.message) !== void 0) {
    if ((t == null ? void 0 : t.error) !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function nc(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
const oc = {
  safeint: [Number.MIN_SAFE_INTEGER, Number.MAX_SAFE_INTEGER],
  int32: [-2147483648, 2147483647],
  uint32: [0, 4294967295],
  float32: [-34028234663852886e22, 34028234663852886e22],
  float64: [-Number.MAX_VALUE, Number.MAX_VALUE]
};
function rc(e, t) {
  const n = e._zod.def, o = fe(e._zod.def, {
    get shape() {
      const r = {};
      for (const i in t) {
        if (!(i in n.shape))
          throw new Error(`Unrecognized key: "${i}"`);
        t[i] && (r[i] = n.shape[i]);
      }
      return de(this, "shape", r), r;
    },
    checks: []
  });
  return ce(e, o);
}
function ic(e, t) {
  const n = e._zod.def, o = fe(e._zod.def, {
    get shape() {
      const r = { ...e._zod.def.shape };
      for (const i in t) {
        if (!(i in n.shape))
          throw new Error(`Unrecognized key: "${i}"`);
        t[i] && delete r[i];
      }
      return de(this, "shape", r), r;
    },
    checks: []
  });
  return ce(e, o);
}
function cc(e, t) {
  if (!Se(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const n = e._zod.def.checks;
  if (n && n.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const r = fe(e._zod.def, {
    get shape() {
      const i = { ...e._zod.def.shape, ...t };
      return de(this, "shape", i), i;
    },
    checks: []
  });
  return ce(e, r);
}
function lc(e, t) {
  if (!Se(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const n = {
    ...e._zod.def,
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return de(this, "shape", o), o;
    },
    checks: e._zod.def.checks
  };
  return ce(e, n);
}
function sc(e, t) {
  const n = fe(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return de(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return ce(e, n);
}
function ac(e, t, n) {
  const o = fe(t._zod.def, {
    get shape() {
      const r = t._zod.def.shape, i = { ...r };
      if (n)
        for (const c in n) {
          if (!(c in r))
            throw new Error(`Unrecognized key: "${c}"`);
          n[c] && (i[c] = e ? new e({
            type: "optional",
            innerType: r[c]
          }) : r[c]);
        }
      else
        for (const c in r)
          i[c] = e ? new e({
            type: "optional",
            innerType: r[c]
          }) : r[c];
      return de(this, "shape", i), i;
    },
    checks: []
  });
  return ce(t, o);
}
function uc(e, t, n) {
  const o = fe(t._zod.def, {
    get shape() {
      const r = t._zod.def.shape, i = { ...r };
      if (n)
        for (const c in n) {
          if (!(c in i))
            throw new Error(`Unrecognized key: "${c}"`);
          n[c] && (i[c] = new e({
            type: "nonoptional",
            innerType: r[c]
          }));
        }
      else
        for (const c in r)
          i[c] = new e({
            type: "nonoptional",
            innerType: r[c]
          });
      return de(this, "shape", i), i;
    },
    checks: []
  });
  return ce(t, o);
}
function pe(e, t = 0) {
  var n;
  if (e.aborted === !0)
    return !0;
  for (let o = t; o < e.issues.length; o++)
    if (((n = e.issues[o]) == null ? void 0 : n.continue) !== !0)
      return !0;
  return !1;
}
function ho(e, t) {
  return t.map((n) => {
    var o;
    return (o = n).path ?? (o.path = []), n.path.unshift(e), n;
  });
}
function ze(e) {
  return typeof e == "string" ? e : e == null ? void 0 : e.message;
}
function ae(e, t, n) {
  var r, i, c, s, l, u;
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const d = ze((c = (i = (r = e.inst) == null ? void 0 : r._zod.def) == null ? void 0 : i.error) == null ? void 0 : c.call(i, e)) ?? ze((s = t == null ? void 0 : t.error) == null ? void 0 : s.call(t, e)) ?? ze((l = n.customError) == null ? void 0 : l.call(n, e)) ?? ze((u = n.localeError) == null ? void 0 : u.call(n, e)) ?? "Invalid input";
    o.message = d;
  }
  return delete o.inst, delete o.continue, t != null && t.reportInput || delete o.input, o;
}
function Bt(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Ee(...e) {
  const [t, n, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: n,
    inst: o
  } : { ...t };
}
const po = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, Ct, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, go = p("$ZodError", po), bo = p("$ZodError", po, { Parent: Error });
function dc(e, t = (n) => n.message) {
  const n = {}, o = [];
  for (const r of e.issues)
    r.path.length > 0 ? (n[r.path[0]] = n[r.path[0]] || [], n[r.path[0]].push(t(r))) : o.push(t(r));
  return { formErrors: o, fieldErrors: n };
}
function fc(e, t = (n) => n.message) {
  const n = { _errors: [] }, o = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((c) => o({ issues: c }));
      else if (i.code === "invalid_key")
        o({ issues: i.issues });
      else if (i.code === "invalid_element")
        o({ issues: i.issues });
      else if (i.path.length === 0)
        n._errors.push(t(i));
      else {
        let c = n, s = 0;
        for (; s < i.path.length; ) {
          const l = i.path[s];
          s === i.path.length - 1 ? (c[l] = c[l] || { _errors: [] }, c[l]._errors.push(t(i))) : c[l] = c[l] || { _errors: [] }, c = c[l], s++;
        }
      }
  };
  return o(e), n;
}
const Ot = (e) => (t, n, o, r) => {
  const i = o ? Object.assign(o, { async: !1 }) : { async: !1 }, c = t._zod.run({ value: n, issues: [] }, i);
  if (c instanceof Promise)
    throw new ge();
  if (c.issues.length) {
    const s = new ((r == null ? void 0 : r.Err) ?? e)(c.issues.map((l) => ae(l, i, se())));
    throw fo(s, r == null ? void 0 : r.callee), s;
  }
  return c.value;
}, Pt = (e) => async (t, n, o, r) => {
  const i = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let c = t._zod.run({ value: n, issues: [] }, i);
  if (c instanceof Promise && (c = await c), c.issues.length) {
    const s = new ((r == null ? void 0 : r.Err) ?? e)(c.issues.map((l) => ae(l, i, se())));
    throw fo(s, r == null ? void 0 : r.callee), s;
  }
  return c.value;
}, Je = (e) => (t, n, o) => {
  const r = o ? { ...o, async: !1 } : { async: !1 }, i = t._zod.run({ value: n, issues: [] }, r);
  if (i instanceof Promise)
    throw new ge();
  return i.issues.length ? {
    success: !1,
    error: new (e ?? go)(i.issues.map((c) => ae(c, r, se())))
  } : { success: !0, data: i.value };
}, mc = /* @__PURE__ */ Je(bo), Ye = (e) => async (t, n, o) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: n, issues: [] }, r);
  return i instanceof Promise && (i = await i), i.issues.length ? {
    success: !1,
    error: new e(i.issues.map((c) => ae(c, r, se())))
  } : { success: !0, data: i.value };
}, hc = /* @__PURE__ */ Ye(bo), pc = (e) => (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Ot(e)(t, n, r);
}, gc = (e) => (t, n, o) => Ot(e)(t, n, o), bc = (e) => async (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Pt(e)(t, n, r);
}, vc = (e) => async (t, n, o) => Pt(e)(t, n, o), Cc = (e) => (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Je(e)(t, n, r);
}, _c = (e) => (t, n, o) => Je(e)(t, n, o), wc = (e) => async (t, n, o) => {
  const r = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Ye(e)(t, n, r);
}, kc = (e) => async (t, n, o) => Ye(e)(t, n, o), yc = /^[cC][^\s-]{8,}$/, Sc = /^[0-9a-z]+$/, Ec = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, xc = /^[0-9a-vA-V]{20}$/, Tc = /^[A-Za-z0-9]{27}$/, Hc = /^[a-zA-Z0-9_-]{21}$/, Vc = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, Mc = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, dn = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, Zc = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, Ic = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function Lc() {
  return new RegExp(Ic, "u");
}
const zc = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, Rc = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, Bc = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, Oc = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, Pc = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, vo = /^[A-Za-z0-9_-]*$/, Nc = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, Ac = /^\+(?:[0-9]){6,14}[0-9]$/, Co = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", $c = /* @__PURE__ */ new RegExp(`^${Co}$`);
function _o(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function Dc(e) {
  return new RegExp(`^${_o(e)}$`);
}
function Fc(e) {
  const t = _o({ precision: e.precision }), n = ["Z"];
  e.local && n.push(""), e.offset && n.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${n.join("|")})`;
  return new RegExp(`^${Co}T(?:${o})$`);
}
const jc = (e) => {
  const t = e ? `[\\s\\S]{${(e == null ? void 0 : e.minimum) ?? 0},${(e == null ? void 0 : e.maximum) ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Uc = /^-?\d+$/, Gc = /^-?\d+(?:\.\d+)?/, Wc = /^(?:true|false)$/i, Kc = /^[^A-Z]*$/, qc = /^[^a-z]*$/, K = /* @__PURE__ */ p("$ZodCheck", (e, t) => {
  var n;
  e._zod ?? (e._zod = {}), e._zod.def = t, (n = e._zod).onattach ?? (n.onattach = []);
}), wo = {
  number: "number",
  bigint: "bigint",
  object: "date"
}, ko = /* @__PURE__ */ p("$ZodCheckLessThan", (e, t) => {
  K.init(e, t);
  const n = wo[typeof t.value];
  e._zod.onattach.push((o) => {
    const r = o._zod.bag, i = (t.inclusive ? r.maximum : r.exclusiveMaximum) ?? Number.POSITIVE_INFINITY;
    t.value < i && (t.inclusive ? r.maximum = t.value : r.exclusiveMaximum = t.value);
  }), e._zod.check = (o) => {
    (t.inclusive ? o.value <= t.value : o.value < t.value) || o.issues.push({
      origin: n,
      code: "too_big",
      maximum: t.value,
      input: o.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), yo = /* @__PURE__ */ p("$ZodCheckGreaterThan", (e, t) => {
  K.init(e, t);
  const n = wo[typeof t.value];
  e._zod.onattach.push((o) => {
    const r = o._zod.bag, i = (t.inclusive ? r.minimum : r.exclusiveMinimum) ?? Number.NEGATIVE_INFINITY;
    t.value > i && (t.inclusive ? r.minimum = t.value : r.exclusiveMinimum = t.value);
  }), e._zod.check = (o) => {
    (t.inclusive ? o.value >= t.value : o.value > t.value) || o.issues.push({
      origin: n,
      code: "too_small",
      minimum: t.value,
      input: o.value,
      inclusive: t.inclusive,
      inst: e,
      continue: !t.abort
    });
  };
}), Xc = /* @__PURE__ */ p("$ZodCheckMultipleOf", (e, t) => {
  K.init(e, t), e._zod.onattach.push((n) => {
    var o;
    (o = n._zod.bag).multipleOf ?? (o.multipleOf = t.value);
  }), e._zod.check = (n) => {
    if (typeof n.value != typeof t.value)
      throw new Error("Cannot mix number and bigint in multiple_of check.");
    (typeof n.value == "bigint" ? n.value % t.value === BigInt(0) : Qi(n.value, t.value) === 0) || n.issues.push({
      origin: typeof n.value,
      code: "not_multiple_of",
      divisor: t.value,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Jc = /* @__PURE__ */ p("$ZodCheckNumberFormat", (e, t) => {
  var c;
  K.init(e, t), t.format = t.format || "float64";
  const n = (c = t.format) == null ? void 0 : c.includes("int"), o = n ? "int" : "number", [r, i] = oc[t.format];
  e._zod.onattach.push((s) => {
    const l = s._zod.bag;
    l.format = t.format, l.minimum = r, l.maximum = i, n && (l.pattern = Uc);
  }), e._zod.check = (s) => {
    const l = s.value;
    if (n) {
      if (!Number.isInteger(l)) {
        s.issues.push({
          expected: o,
          format: t.format,
          code: "invalid_type",
          continue: !1,
          input: l,
          inst: e
        });
        return;
      }
      if (!Number.isSafeInteger(l)) {
        l > 0 ? s.issues.push({
          input: l,
          code: "too_big",
          maximum: Number.MAX_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          continue: !t.abort
        }) : s.issues.push({
          input: l,
          code: "too_small",
          minimum: Number.MIN_SAFE_INTEGER,
          note: "Integers must be within the safe integer range.",
          inst: e,
          origin: o,
          continue: !t.abort
        });
        return;
      }
    }
    l < r && s.issues.push({
      origin: "number",
      input: l,
      code: "too_small",
      minimum: r,
      inclusive: !0,
      inst: e,
      continue: !t.abort
    }), l > i && s.issues.push({
      origin: "number",
      input: l,
      code: "too_big",
      maximum: i,
      inst: e
    });
  };
}), Yc = /* @__PURE__ */ p("$ZodCheckMaxLength", (e, t) => {
  var n;
  K.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !zt(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < r && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length <= t.maximum)
      return;
    const c = Bt(r);
    o.issues.push({
      origin: c,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), Qc = /* @__PURE__ */ p("$ZodCheckMinLength", (e, t) => {
  var n;
  K.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !zt(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > r && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const r = o.value;
    if (r.length >= t.minimum)
      return;
    const c = Bt(r);
    o.issues.push({
      origin: c,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: r,
      inst: e,
      continue: !t.abort
    });
  };
}), el = /* @__PURE__ */ p("$ZodCheckLengthEquals", (e, t) => {
  var n;
  K.init(e, t), (n = e._zod.def).when ?? (n.when = (o) => {
    const r = o.value;
    return !zt(r) && r.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.minimum = t.length, r.maximum = t.length, r.length = t.length;
  }), e._zod.check = (o) => {
    const r = o.value, i = r.length;
    if (i === t.length)
      return;
    const c = Bt(r), s = i > t.length;
    o.issues.push({
      origin: c,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Qe = /* @__PURE__ */ p("$ZodCheckStringFormat", (e, t) => {
  var n, o;
  K.init(e, t), e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.format = t.format, t.pattern && (i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(t.pattern));
  }), t.pattern ? (n = e._zod).check ?? (n.check = (r) => {
    t.pattern.lastIndex = 0, !t.pattern.test(r.value) && r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: r.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), tl = /* @__PURE__ */ p("$ZodCheckRegex", (e, t) => {
  Qe.init(e, t), e._zod.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: n.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), nl = /* @__PURE__ */ p("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Kc), Qe.init(e, t);
}), ol = /* @__PURE__ */ p("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = qc), Qe.init(e, t);
}), rl = /* @__PURE__ */ p("$ZodCheckIncludes", (e, t) => {
  K.init(e, t);
  const n = Xe(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${n}` : n);
  t.pattern = o, e._zod.onattach.push((r) => {
    const i = r._zod.bag;
    i.patterns ?? (i.patterns = /* @__PURE__ */ new Set()), i.patterns.add(o);
  }), e._zod.check = (r) => {
    r.value.includes(t.includes, t.position) || r.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: r.value,
      inst: e,
      continue: !t.abort
    });
  };
}), il = /* @__PURE__ */ p("$ZodCheckStartsWith", (e, t) => {
  K.init(e, t);
  const n = new RegExp(`^${Xe(t.prefix)}.*`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), cl = /* @__PURE__ */ p("$ZodCheckEndsWith", (e, t) => {
  K.init(e, t);
  const n = new RegExp(`.*${Xe(t.suffix)}$`);
  t.pattern ?? (t.pattern = n), e._zod.onattach.push((o) => {
    const r = o._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(n);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), ll = /* @__PURE__ */ p("$ZodCheckOverwrite", (e, t) => {
  K.init(e, t), e._zod.check = (n) => {
    n.value = t.tx(n.value);
  };
});
class sl {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const o = t.split(`
`).filter((c) => c), r = Math.min(...o.map((c) => c.length - c.trimStart().length)), i = o.map((c) => c.slice(r)).map((c) => " ".repeat(this.indent * 2) + c);
    for (const c of i)
      this.content.push(c);
  }
  compile() {
    const t = Function, n = this == null ? void 0 : this.args, r = [...((this == null ? void 0 : this.content) ?? [""]).map((i) => `  ${i}`)];
    return new t(...n, r.join(`
`));
  }
}
const al = {
  major: 4,
  minor: 1,
  patch: 12
}, A = /* @__PURE__ */ p("$ZodType", (e, t) => {
  var r;
  var n;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = al;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const i of o)
    for (const c of i._zod.onattach)
      c(e);
  if (o.length === 0)
    (n = e._zod).deferred ?? (n.deferred = []), (r = e._zod.deferred) == null || r.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const i = (s, l, u) => {
      let d = pe(s), f;
      for (const m of l) {
        if (m._zod.def.when) {
          if (!m._zod.def.when(s))
            continue;
        } else if (d)
          continue;
        const h = s.issues.length, g = m._zod.check(s);
        if (g instanceof Promise && (u == null ? void 0 : u.async) === !1)
          throw new ge();
        if (f || g instanceof Promise)
          f = (f ?? Promise.resolve()).then(async () => {
            await g, s.issues.length !== h && (d || (d = pe(s, h)));
          });
        else {
          if (s.issues.length === h)
            continue;
          d || (d = pe(s, h));
        }
      }
      return f ? f.then(() => s) : s;
    }, c = (s, l, u) => {
      if (pe(s))
        return s.aborted = !0, s;
      const d = i(l, o, u);
      if (d instanceof Promise) {
        if (u.async === !1)
          throw new ge();
        return d.then((f) => e._zod.parse(f, u));
      }
      return e._zod.parse(d, u);
    };
    e._zod.run = (s, l) => {
      if (l.skipChecks)
        return e._zod.parse(s, l);
      if (l.direction === "backward") {
        const d = e._zod.parse({ value: s.value, issues: [] }, { ...l, skipChecks: !0 });
        return d instanceof Promise ? d.then((f) => c(f, s, l)) : c(d, s, l);
      }
      const u = e._zod.parse(s, l);
      if (u instanceof Promise) {
        if (l.async === !1)
          throw new ge();
        return u.then((d) => i(d, o, l));
      }
      return i(u, o, l);
    };
  }
  e["~standard"] = {
    validate: (i) => {
      var c;
      try {
        const s = mc(e, i);
        return s.success ? { value: s.data } : { issues: (c = s.error) == null ? void 0 : c.issues };
      } catch {
        return hc(e, i).then((l) => {
          var u;
          return l.success ? { value: l.data } : { issues: (u = l.error) == null ? void 0 : u.issues };
        });
      }
    },
    vendor: "zod",
    version: 1
  };
}), Nt = /* @__PURE__ */ p("$ZodString", (e, t) => {
  var n;
  A.init(e, t), e._zod.pattern = [...((n = e == null ? void 0 : e._zod.bag) == null ? void 0 : n.patterns) ?? []].pop() ?? jc(e._zod.bag), e._zod.parse = (o, r) => {
    if (t.coerce)
      try {
        o.value = String(o.value);
      } catch {
      }
    return typeof o.value == "string" || o.issues.push({
      expected: "string",
      code: "invalid_type",
      input: o.value,
      inst: e
    }), o;
  };
}), B = /* @__PURE__ */ p("$ZodStringFormat", (e, t) => {
  Qe.init(e, t), Nt.init(e, t);
}), ul = /* @__PURE__ */ p("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = Mc), B.init(e, t);
}), dl = /* @__PURE__ */ p("$ZodUUID", (e, t) => {
  if (t.version) {
    const o = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (o === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = dn(o));
  } else
    t.pattern ?? (t.pattern = dn());
  B.init(e, t);
}), fl = /* @__PURE__ */ p("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = Zc), B.init(e, t);
}), ml = /* @__PURE__ */ p("$ZodURL", (e, t) => {
  B.init(e, t), e._zod.check = (n) => {
    try {
      const o = n.value.trim(), r = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(r.hostname) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: Nc.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(r.protocol.endsWith(":") ? r.protocol.slice(0, -1) : r.protocol) || n.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: n.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? n.value = r.href : n.value = o;
      return;
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "url",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), hl = /* @__PURE__ */ p("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = Lc()), B.init(e, t);
}), pl = /* @__PURE__ */ p("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = Hc), B.init(e, t);
}), gl = /* @__PURE__ */ p("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = yc), B.init(e, t);
}), bl = /* @__PURE__ */ p("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = Sc), B.init(e, t);
}), vl = /* @__PURE__ */ p("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = Ec), B.init(e, t);
}), Cl = /* @__PURE__ */ p("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = xc), B.init(e, t);
}), _l = /* @__PURE__ */ p("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = Tc), B.init(e, t);
}), wl = /* @__PURE__ */ p("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Fc(t)), B.init(e, t);
}), kl = /* @__PURE__ */ p("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = $c), B.init(e, t);
}), yl = /* @__PURE__ */ p("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = Dc(t)), B.init(e, t);
}), Sl = /* @__PURE__ */ p("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = Vc), B.init(e, t);
}), El = /* @__PURE__ */ p("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = zc), B.init(e, t), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.format = "ipv4";
  });
}), xl = /* @__PURE__ */ p("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = Rc), B.init(e, t), e._zod.onattach.push((n) => {
    const o = n._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (n) => {
    try {
      new URL(`http://[${n.value}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), Tl = /* @__PURE__ */ p("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = Bc), B.init(e, t);
}), Hl = /* @__PURE__ */ p("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = Oc), B.init(e, t), e._zod.check = (n) => {
    const o = n.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [r, i] = o;
      if (!i)
        throw new Error();
      const c = Number(i);
      if (`${c}` !== i)
        throw new Error();
      if (c < 0 || c > 128)
        throw new Error();
      new URL(`http://[${r}]`);
    } catch {
      n.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: n.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function So(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const Vl = /* @__PURE__ */ p("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = Pc), B.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (n) => {
    So(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function Ml(e) {
  if (!vo.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), n = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return So(n);
}
const Zl = /* @__PURE__ */ p("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = vo), B.init(e, t), e._zod.onattach.push((n) => {
    n._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (n) => {
    Ml(n.value) || n.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Il = /* @__PURE__ */ p("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = Ac), B.init(e, t);
});
function Ll(e, t = null) {
  try {
    const n = e.split(".");
    if (n.length !== 3)
      return !1;
    const [o] = n;
    if (!o)
      return !1;
    const r = JSON.parse(atob(o));
    return !("typ" in r && (r == null ? void 0 : r.typ) !== "JWT" || !r.alg || t && (!("alg" in r) || r.alg !== t));
  } catch {
    return !1;
  }
}
const zl = /* @__PURE__ */ p("$ZodJWT", (e, t) => {
  B.init(e, t), e._zod.check = (n) => {
    Ll(n.value, t.alg) || n.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Eo = /* @__PURE__ */ p("$ZodNumber", (e, t) => {
  A.init(e, t), e._zod.pattern = e._zod.bag.pattern ?? Gc, e._zod.parse = (n, o) => {
    if (t.coerce)
      try {
        n.value = Number(n.value);
      } catch {
      }
    const r = n.value;
    if (typeof r == "number" && !Number.isNaN(r) && Number.isFinite(r))
      return n;
    const i = typeof r == "number" ? Number.isNaN(r) ? "NaN" : Number.isFinite(r) ? void 0 : "Infinity" : void 0;
    return n.issues.push({
      expected: "number",
      code: "invalid_type",
      input: r,
      inst: e,
      ...i ? { received: i } : {}
    }), n;
  };
}), Rl = /* @__PURE__ */ p("$ZodNumber", (e, t) => {
  Jc.init(e, t), Eo.init(e, t);
}), Bl = /* @__PURE__ */ p("$ZodBoolean", (e, t) => {
  A.init(e, t), e._zod.pattern = Wc, e._zod.parse = (n, o) => {
    if (t.coerce)
      try {
        n.value = !!n.value;
      } catch {
      }
    const r = n.value;
    return typeof r == "boolean" || n.issues.push({
      expected: "boolean",
      code: "invalid_type",
      input: r,
      inst: e
    }), n;
  };
}), Ol = /* @__PURE__ */ p("$ZodUnknown", (e, t) => {
  A.init(e, t), e._zod.parse = (n) => n;
}), Pl = /* @__PURE__ */ p("$ZodNever", (e, t) => {
  A.init(e, t), e._zod.parse = (n, o) => (n.issues.push({
    expected: "never",
    code: "invalid_type",
    input: n.value,
    inst: e
  }), n);
});
function fn(e, t, n) {
  e.issues.length && t.issues.push(...ho(n, e.issues)), t.value[n] = e.value;
}
const Nl = /* @__PURE__ */ p("$ZodArray", (e, t) => {
  A.init(e, t), e._zod.parse = (n, o) => {
    const r = n.value;
    if (!Array.isArray(r))
      return n.issues.push({
        expected: "array",
        code: "invalid_type",
        input: r,
        inst: e
      }), n;
    n.value = Array(r.length);
    const i = [];
    for (let c = 0; c < r.length; c++) {
      const s = r[c], l = t.element._zod.run({
        value: s,
        issues: []
      }, o);
      l instanceof Promise ? i.push(l.then((u) => fn(u, n, c))) : fn(l, n, c);
    }
    return i.length ? Promise.all(i).then(() => n) : n;
  };
});
function je(e, t, n, o) {
  e.issues.length && t.issues.push(...ho(n, e.issues)), e.value === void 0 ? n in o && (t.value[n] = void 0) : t.value[n] = e.value;
}
function xo(e) {
  var o, r, i, c;
  const t = Object.keys(e.shape);
  for (const s of t)
    if (!((c = (i = (r = (o = e.shape) == null ? void 0 : o[s]) == null ? void 0 : r._zod) == null ? void 0 : i.traits) != null && c.has("$ZodType")))
      throw new Error(`Invalid element at key "${s}": expected a Zod schema`);
  const n = nc(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(n)
  };
}
function To(e, t, n, o, r, i) {
  const c = [], s = r.keySet, l = r.catchall._zod, u = l.def.type;
  for (const d of Object.keys(t)) {
    if (s.has(d))
      continue;
    if (u === "never") {
      c.push(d);
      continue;
    }
    const f = l.run({ value: t[d], issues: [] }, o);
    f instanceof Promise ? e.push(f.then((m) => je(m, n, d, t))) : je(f, n, d, t);
  }
  return c.length && n.issues.push({
    code: "unrecognized_keys",
    keys: c,
    input: t,
    inst: i
  }), e.length ? Promise.all(e).then(() => n) : n;
}
const Al = /* @__PURE__ */ p("$ZodObject", (e, t) => {
  A.init(e, t);
  const n = Object.getOwnPropertyDescriptor(t, "shape");
  if (!(n != null && n.get)) {
    const s = t.shape;
    Object.defineProperty(t, "shape", {
      get: () => {
        const l = { ...s };
        return Object.defineProperty(t, "shape", {
          value: l
        }), l;
      }
    });
  }
  const o = Lt(() => xo(t));
  R(e._zod, "propValues", () => {
    const s = t.shape, l = {};
    for (const u in s) {
      const d = s[u]._zod;
      if (d.values) {
        l[u] ?? (l[u] = /* @__PURE__ */ new Set());
        for (const f of d.values)
          l[u].add(f);
      }
    }
    return l;
  });
  const r = Fe, i = t.catchall;
  let c;
  e._zod.parse = (s, l) => {
    c ?? (c = o.value);
    const u = s.value;
    if (!r(u))
      return s.issues.push({
        expected: "object",
        code: "invalid_type",
        input: u,
        inst: e
      }), s;
    s.value = {};
    const d = [], f = c.shape;
    for (const m of c.keys) {
      const g = f[m]._zod.run({ value: u[m], issues: [] }, l);
      g instanceof Promise ? d.push(g.then((b) => je(b, s, m, u))) : je(g, s, m, u);
    }
    return i ? To(d, u, s, l, o.value, e) : d.length ? Promise.all(d).then(() => s) : s;
  };
}), $l = /* @__PURE__ */ p("$ZodObjectJIT", (e, t) => {
  Al.init(e, t);
  const n = e._zod.parse, o = Lt(() => xo(t)), r = (m) => {
    const h = new sl(["shape", "payload", "ctx"]), g = o.value, b = (I) => {
      const M = un(I);
      return `shape[${M}]._zod.run({ value: input[${M}], issues: [] }, ctx)`;
    };
    h.write("const input = payload.value;");
    const v = /* @__PURE__ */ Object.create(null);
    let S = 0;
    for (const I of g.keys)
      v[I] = `key_${S++}`;
    h.write("const newResult = {};");
    for (const I of g.keys) {
      const M = v[I], U = un(I);
      h.write(`const ${M} = ${b(I)};`), h.write(`
        if (${M}.issues.length) {
          payload.issues = payload.issues.concat(${M}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${U}, ...iss.path] : [${U}]
          })));
        }
        
        
        if (${M}.value === undefined) {
          if (${U} in input) {
            newResult[${U}] = undefined;
          }
        } else {
          newResult[${U}] = ${M}.value;
        }
        
      `);
    }
    h.write("payload.value = newResult;"), h.write("return payload;");
    const $ = h.compile();
    return (I, M) => $(m, I, M);
  };
  let i;
  const c = Fe, s = !uo.jitless, u = s && ec.value, d = t.catchall;
  let f;
  e._zod.parse = (m, h) => {
    f ?? (f = o.value);
    const g = m.value;
    return c(g) ? s && u && (h == null ? void 0 : h.async) === !1 && h.jitless !== !0 ? (i || (i = r(t.shape)), m = i(m, h), d ? To([], g, m, h, f, e) : m) : n(m, h) : (m.issues.push({
      expected: "object",
      code: "invalid_type",
      input: g,
      inst: e
    }), m);
  };
});
function mn(e, t, n, o) {
  for (const i of e)
    if (i.issues.length === 0)
      return t.value = i.value, t;
  const r = e.filter((i) => !pe(i));
  return r.length === 1 ? (t.value = r[0].value, r[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: n,
    errors: e.map((i) => i.issues.map((c) => ae(c, o, se())))
  }), t);
}
const Dl = /* @__PURE__ */ p("$ZodUnion", (e, t) => {
  A.init(e, t), R(e._zod, "optin", () => t.options.some((r) => r._zod.optin === "optional") ? "optional" : void 0), R(e._zod, "optout", () => t.options.some((r) => r._zod.optout === "optional") ? "optional" : void 0), R(e._zod, "values", () => {
    if (t.options.every((r) => r._zod.values))
      return new Set(t.options.flatMap((r) => Array.from(r._zod.values)));
  }), R(e._zod, "pattern", () => {
    if (t.options.every((r) => r._zod.pattern)) {
      const r = t.options.map((i) => i._zod.pattern);
      return new RegExp(`^(${r.map((i) => Rt(i.source)).join("|")})$`);
    }
  });
  const n = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (r, i) => {
    if (n)
      return o(r, i);
    let c = !1;
    const s = [];
    for (const l of t.options) {
      const u = l._zod.run({
        value: r.value,
        issues: []
      }, i);
      if (u instanceof Promise)
        s.push(u), c = !0;
      else {
        if (u.issues.length === 0)
          return u;
        s.push(u);
      }
    }
    return c ? Promise.all(s).then((l) => mn(l, r, e, i)) : mn(s, r, e, i);
  };
}), Fl = /* @__PURE__ */ p("$ZodIntersection", (e, t) => {
  A.init(e, t), e._zod.parse = (n, o) => {
    const r = n.value, i = t.left._zod.run({ value: r, issues: [] }, o), c = t.right._zod.run({ value: r, issues: [] }, o);
    return i instanceof Promise || c instanceof Promise ? Promise.all([i, c]).then(([l, u]) => hn(n, l, u)) : hn(n, i, c);
  };
});
function _t(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Se(e) && Se(t)) {
    const n = Object.keys(t), o = Object.keys(e).filter((i) => n.indexOf(i) !== -1), r = { ...e, ...t };
    for (const i of o) {
      const c = _t(e[i], t[i]);
      if (!c.valid)
        return {
          valid: !1,
          mergeErrorPath: [i, ...c.mergeErrorPath]
        };
      r[i] = c.data;
    }
    return { valid: !0, data: r };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const n = [];
    for (let o = 0; o < e.length; o++) {
      const r = e[o], i = t[o], c = _t(r, i);
      if (!c.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...c.mergeErrorPath]
        };
      n.push(c.data);
    }
    return { valid: !0, data: n };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function hn(e, t, n) {
  if (t.issues.length && e.issues.push(...t.issues), n.issues.length && e.issues.push(...n.issues), pe(e))
    return e;
  const o = _t(t.value, n.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const jl = /* @__PURE__ */ p("$ZodEnum", (e, t) => {
  A.init(e, t);
  const n = Yi(t.entries), o = new Set(n);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${n.filter((r) => tc.has(typeof r)).map((r) => typeof r == "string" ? Xe(r) : r.toString()).join("|")})$`), e._zod.parse = (r, i) => {
    const c = r.value;
    return o.has(c) || r.issues.push({
      code: "invalid_value",
      values: n,
      input: c,
      inst: e
    }), r;
  };
}), Ul = /* @__PURE__ */ p("$ZodTransform", (e, t) => {
  A.init(e, t), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      throw new ao(e.constructor.name);
    const r = t.transform(n.value, n);
    if (o.async)
      return (r instanceof Promise ? r : Promise.resolve(r)).then((c) => (n.value = c, n));
    if (r instanceof Promise)
      throw new ge();
    return n.value = r, n;
  };
});
function pn(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const Gl = /* @__PURE__ */ p("$ZodOptional", (e, t) => {
  A.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", R(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), R(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Rt(n.source)})?$`) : void 0;
  }), e._zod.parse = (n, o) => {
    if (t.innerType._zod.optin === "optional") {
      const r = t.innerType._zod.run(n, o);
      return r instanceof Promise ? r.then((i) => pn(i, n.value)) : pn(r, n.value);
    }
    return n.value === void 0 ? n : t.innerType._zod.run(n, o);
  };
}), Wl = /* @__PURE__ */ p("$ZodNullable", (e, t) => {
  A.init(e, t), R(e._zod, "optin", () => t.innerType._zod.optin), R(e._zod, "optout", () => t.innerType._zod.optout), R(e._zod, "pattern", () => {
    const n = t.innerType._zod.pattern;
    return n ? new RegExp(`^(${Rt(n.source)}|null)$`) : void 0;
  }), R(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (n, o) => n.value === null ? n : t.innerType._zod.run(n, o);
}), At = /* @__PURE__ */ p("$ZodDefault", (e, t) => {
  A.init(e, t), e._zod.optin = "optional", R(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    if (n.value === void 0)
      return n.value = t.defaultValue, n;
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => gn(i, t)) : gn(r, t);
  };
});
function gn(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Kl = /* @__PURE__ */ p("$ZodPrefault", (e, t) => {
  A.init(e, t), e._zod.optin = "optional", R(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => (o.direction === "backward" || n.value === void 0 && (n.value = t.defaultValue), t.innerType._zod.run(n, o));
}), ql = /* @__PURE__ */ p("$ZodNonOptional", (e, t) => {
  A.init(e, t), R(e._zod, "values", () => {
    const n = t.innerType._zod.values;
    return n ? new Set([...n].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (n, o) => {
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => bn(i, e)) : bn(r, e);
  };
});
function bn(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Xl = /* @__PURE__ */ p("$ZodCatch", (e, t) => {
  A.init(e, t), R(e._zod, "optin", () => t.innerType._zod.optin), R(e._zod, "optout", () => t.innerType._zod.optout), R(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => (n.value = i.value, i.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: i.issues.map((c) => ae(c, o, se()))
      },
      input: n.value
    }), n.issues = []), n)) : (n.value = r.value, r.issues.length && (n.value = t.catchValue({
      ...n,
      error: {
        issues: r.issues.map((i) => ae(i, o, se()))
      },
      input: n.value
    }), n.issues = []), n);
  };
}), Jl = /* @__PURE__ */ p("$ZodPipe", (e, t) => {
  A.init(e, t), R(e._zod, "values", () => t.in._zod.values), R(e._zod, "optin", () => t.in._zod.optin), R(e._zod, "optout", () => t.out._zod.optout), R(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (n, o) => {
    if (o.direction === "backward") {
      const i = t.out._zod.run(n, o);
      return i instanceof Promise ? i.then((c) => Re(c, t.in, o)) : Re(i, t.in, o);
    }
    const r = t.in._zod.run(n, o);
    return r instanceof Promise ? r.then((i) => Re(i, t.out, o)) : Re(r, t.out, o);
  };
});
function Re(e, t, n) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, n);
}
const Yl = /* @__PURE__ */ p("$ZodReadonly", (e, t) => {
  A.init(e, t), R(e._zod, "propValues", () => t.innerType._zod.propValues), R(e._zod, "values", () => t.innerType._zod.values), R(e._zod, "optin", () => t.innerType._zod.optin), R(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(n, o);
    const r = t.innerType._zod.run(n, o);
    return r instanceof Promise ? r.then(vn) : vn(r);
  };
});
function vn(e) {
  return e.value = Object.freeze(e.value), e;
}
const Ql = /* @__PURE__ */ p("$ZodCustom", (e, t) => {
  K.init(e, t), A.init(e, t), e._zod.parse = (n, o) => n, e._zod.check = (n) => {
    const o = n.value, r = t.fn(o);
    if (r instanceof Promise)
      return r.then((i) => Cn(i, n, o, e));
    Cn(r, n, o, e);
  };
});
function Cn(e, t, n, o) {
  if (!e) {
    const r = {
      code: "custom",
      input: n,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (r.params = o._zod.def.params), t.issues.push(Ee(r));
  }
}
class es {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...n) {
    const o = n[0];
    if (this._map.set(t, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const n = this._map.get(t);
    return n && typeof n == "object" && "id" in n && this._idmap.delete(n.id), this._map.delete(t), this;
  }
  get(t) {
    const n = t._zod.parent;
    if (n) {
      const o = { ...this.get(n) ?? {} };
      delete o.id;
      const r = { ...o, ...this._map.get(t) };
      return Object.keys(r).length ? r : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function ts() {
  return new es();
}
const Be = /* @__PURE__ */ ts();
function ns(e, t) {
  return new e({
    type: "string",
    ...k(t)
  });
}
function os(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function _n(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function rs(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function is(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...k(t)
  });
}
function cs(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...k(t)
  });
}
function ls(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...k(t)
  });
}
function ss(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function as(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function us(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function ds(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function fs(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function ms(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function hs(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function ps(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function gs(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function bs(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function vs(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function Cs(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function _s(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function ws(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function ks(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function ys(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...k(t)
  });
}
function Ss(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...k(t)
  });
}
function Es(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...k(t)
  });
}
function xs(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...k(t)
  });
}
function Ts(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...k(t)
  });
}
function Hs(e, t) {
  return new e({
    type: "number",
    checks: [],
    ...k(t)
  });
}
function Vs(e, t) {
  return new e({
    type: "number",
    check: "number_format",
    abort: !1,
    format: "safeint",
    ...k(t)
  });
}
function Ms(e, t) {
  return new e({
    type: "boolean",
    ...k(t)
  });
}
function Zs(e) {
  return new e({
    type: "unknown"
  });
}
function Is(e, t) {
  return new e({
    type: "never",
    ...k(t)
  });
}
function wn(e, t) {
  return new ko({
    check: "less_than",
    ...k(t),
    value: e,
    inclusive: !1
  });
}
function st(e, t) {
  return new ko({
    check: "less_than",
    ...k(t),
    value: e,
    inclusive: !0
  });
}
function kn(e, t) {
  return new yo({
    check: "greater_than",
    ...k(t),
    value: e,
    inclusive: !1
  });
}
function at(e, t) {
  return new yo({
    check: "greater_than",
    ...k(t),
    value: e,
    inclusive: !0
  });
}
function yn(e, t) {
  return new Xc({
    check: "multiple_of",
    ...k(t),
    value: e
  });
}
function Ho(e, t) {
  return new Yc({
    check: "max_length",
    ...k(t),
    maximum: e
  });
}
function Ue(e, t) {
  return new Qc({
    check: "min_length",
    ...k(t),
    minimum: e
  });
}
function Vo(e, t) {
  return new el({
    check: "length_equals",
    ...k(t),
    length: e
  });
}
function Ls(e, t) {
  return new tl({
    check: "string_format",
    format: "regex",
    ...k(t),
    pattern: e
  });
}
function zs(e) {
  return new nl({
    check: "string_format",
    format: "lowercase",
    ...k(e)
  });
}
function Rs(e) {
  return new ol({
    check: "string_format",
    format: "uppercase",
    ...k(e)
  });
}
function Bs(e, t) {
  return new rl({
    check: "string_format",
    format: "includes",
    ...k(t),
    includes: e
  });
}
function Os(e, t) {
  return new il({
    check: "string_format",
    format: "starts_with",
    ...k(t),
    prefix: e
  });
}
function Ps(e, t) {
  return new cl({
    check: "string_format",
    format: "ends_with",
    ...k(t),
    suffix: e
  });
}
function He(e) {
  return new ll({
    check: "overwrite",
    tx: e
  });
}
function Ns(e) {
  return He((t) => t.normalize(e));
}
function As() {
  return He((e) => e.trim());
}
function $s() {
  return He((e) => e.toLowerCase());
}
function Ds() {
  return He((e) => e.toUpperCase());
}
function Fs(e, t, n) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...k(n)
  });
}
function js(e, t, n) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...k(n)
  });
}
function Us(e) {
  const t = Gs((n) => (n.addIssue = (o) => {
    if (typeof o == "string")
      n.issues.push(Ee(o, n.value, t._zod.def));
    else {
      const r = o;
      r.fatal && (r.continue = !1), r.code ?? (r.code = "custom"), r.input ?? (r.input = n.value), r.inst ?? (r.inst = t), r.continue ?? (r.continue = !t._zod.def.abort), n.issues.push(Ee(r));
    }
  }, e(n.value, n)));
  return t;
}
function Gs(e, t) {
  const n = new K({
    check: "custom",
    ...k(t)
  });
  return n._zod.check = e, n;
}
const Ws = /* @__PURE__ */ p("ZodISODateTime", (e, t) => {
  wl.init(e, t), N.init(e, t);
});
function Ks(e) {
  return Ss(Ws, e);
}
const qs = /* @__PURE__ */ p("ZodISODate", (e, t) => {
  kl.init(e, t), N.init(e, t);
});
function Xs(e) {
  return Es(qs, e);
}
const Js = /* @__PURE__ */ p("ZodISOTime", (e, t) => {
  yl.init(e, t), N.init(e, t);
});
function Ys(e) {
  return xs(Js, e);
}
const Qs = /* @__PURE__ */ p("ZodISODuration", (e, t) => {
  Sl.init(e, t), N.init(e, t);
});
function ea(e) {
  return Ts(Qs, e);
}
const ta = (e, t) => {
  go.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (n) => fc(e, n)
      // enumerable: false,
    },
    flatten: {
      value: (n) => dc(e, n)
      // enumerable: false,
    },
    addIssue: {
      value: (n) => {
        e.issues.push(n), e.message = JSON.stringify(e.issues, Ct, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (n) => {
        e.issues.push(...n), e.message = JSON.stringify(e.issues, Ct, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, J = p("ZodError", ta, {
  Parent: Error
}), na = /* @__PURE__ */ Ot(J), oa = /* @__PURE__ */ Pt(J), ra = /* @__PURE__ */ Je(J), ia = /* @__PURE__ */ Ye(J), ca = /* @__PURE__ */ pc(J), la = /* @__PURE__ */ gc(J), sa = /* @__PURE__ */ bc(J), aa = /* @__PURE__ */ vc(J), ua = /* @__PURE__ */ Cc(J), da = /* @__PURE__ */ _c(J), fa = /* @__PURE__ */ wc(J), ma = /* @__PURE__ */ kc(J), D = /* @__PURE__ */ p("ZodType", (e, t) => (A.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...n) => e.clone(fe(t, {
  checks: [
    ...t.checks ?? [],
    ...n.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
  ]
})), e.clone = (n, o) => ce(e, n, o), e.brand = () => e, e.register = (n, o) => (n.add(e, o), e), e.parse = (n, o) => na(e, n, o, { callee: e.parse }), e.safeParse = (n, o) => ra(e, n, o), e.parseAsync = async (n, o) => oa(e, n, o, { callee: e.parseAsync }), e.safeParseAsync = async (n, o) => ia(e, n, o), e.spa = e.safeParseAsync, e.encode = (n, o) => ca(e, n, o), e.decode = (n, o) => la(e, n, o), e.encodeAsync = async (n, o) => sa(e, n, o), e.decodeAsync = async (n, o) => aa(e, n, o), e.safeEncode = (n, o) => ua(e, n, o), e.safeDecode = (n, o) => da(e, n, o), e.safeEncodeAsync = async (n, o) => fa(e, n, o), e.safeDecodeAsync = async (n, o) => ma(e, n, o), e.refine = (n, o) => e.check(lu(n, o)), e.superRefine = (n) => e.check(su(n)), e.overwrite = (n) => e.check(He(n)), e.optional = () => Tn(e), e.nullable = () => Hn(e), e.nullish = () => Tn(Hn(e)), e.nonoptional = (n) => eu(e, n), e.array = () => Aa(e), e.or = (n) => Fa([e, n]), e.and = (n) => Ua(e, n), e.transform = (n) => Vn(e, Ka(n)), e.default = (n) => Ja(e, n), e.prefault = (n) => Qa(e, n), e.catch = (n) => nu(e, n), e.pipe = (n) => Vn(e, n), e.readonly = () => iu(e), e.describe = (n) => {
  const o = e.clone();
  return Be.add(o, { description: n }), o;
}, Object.defineProperty(e, "description", {
  get() {
    var n;
    return (n = Be.get(e)) == null ? void 0 : n.description;
  },
  configurable: !0
}), e.meta = (...n) => {
  if (n.length === 0)
    return Be.get(e);
  const o = e.clone();
  return Be.add(o, n[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), Mo = /* @__PURE__ */ p("_ZodString", (e, t) => {
  Nt.init(e, t), D.init(e, t);
  const n = e._zod.bag;
  e.format = n.format ?? null, e.minLength = n.minimum ?? null, e.maxLength = n.maximum ?? null, e.regex = (...o) => e.check(Ls(...o)), e.includes = (...o) => e.check(Bs(...o)), e.startsWith = (...o) => e.check(Os(...o)), e.endsWith = (...o) => e.check(Ps(...o)), e.min = (...o) => e.check(Ue(...o)), e.max = (...o) => e.check(Ho(...o)), e.length = (...o) => e.check(Vo(...o)), e.nonempty = (...o) => e.check(Ue(1, ...o)), e.lowercase = (o) => e.check(zs(o)), e.uppercase = (o) => e.check(Rs(o)), e.trim = () => e.check(As()), e.normalize = (...o) => e.check(Ns(...o)), e.toLowerCase = () => e.check($s()), e.toUpperCase = () => e.check(Ds());
}), ha = /* @__PURE__ */ p("ZodString", (e, t) => {
  Nt.init(e, t), Mo.init(e, t), e.email = (n) => e.check(os(pa, n)), e.url = (n) => e.check(ss(ga, n)), e.jwt = (n) => e.check(ys(Za, n)), e.emoji = (n) => e.check(as(ba, n)), e.guid = (n) => e.check(_n(Sn, n)), e.uuid = (n) => e.check(rs(Oe, n)), e.uuidv4 = (n) => e.check(is(Oe, n)), e.uuidv6 = (n) => e.check(cs(Oe, n)), e.uuidv7 = (n) => e.check(ls(Oe, n)), e.nanoid = (n) => e.check(us(va, n)), e.guid = (n) => e.check(_n(Sn, n)), e.cuid = (n) => e.check(ds(Ca, n)), e.cuid2 = (n) => e.check(fs(_a, n)), e.ulid = (n) => e.check(ms(wa, n)), e.base64 = (n) => e.check(_s(Ha, n)), e.base64url = (n) => e.check(ws(Va, n)), e.xid = (n) => e.check(hs(ka, n)), e.ksuid = (n) => e.check(ps(ya, n)), e.ipv4 = (n) => e.check(gs(Sa, n)), e.ipv6 = (n) => e.check(bs(Ea, n)), e.cidrv4 = (n) => e.check(vs(xa, n)), e.cidrv6 = (n) => e.check(Cs(Ta, n)), e.e164 = (n) => e.check(ks(Ma, n)), e.datetime = (n) => e.check(Ks(n)), e.date = (n) => e.check(Xs(n)), e.time = (n) => e.check(Ys(n)), e.duration = (n) => e.check(ea(n));
});
function wt(e) {
  return ns(ha, e);
}
const N = /* @__PURE__ */ p("ZodStringFormat", (e, t) => {
  B.init(e, t), Mo.init(e, t);
}), pa = /* @__PURE__ */ p("ZodEmail", (e, t) => {
  fl.init(e, t), N.init(e, t);
}), Sn = /* @__PURE__ */ p("ZodGUID", (e, t) => {
  ul.init(e, t), N.init(e, t);
}), Oe = /* @__PURE__ */ p("ZodUUID", (e, t) => {
  dl.init(e, t), N.init(e, t);
}), ga = /* @__PURE__ */ p("ZodURL", (e, t) => {
  ml.init(e, t), N.init(e, t);
}), ba = /* @__PURE__ */ p("ZodEmoji", (e, t) => {
  hl.init(e, t), N.init(e, t);
}), va = /* @__PURE__ */ p("ZodNanoID", (e, t) => {
  pl.init(e, t), N.init(e, t);
}), Ca = /* @__PURE__ */ p("ZodCUID", (e, t) => {
  gl.init(e, t), N.init(e, t);
}), _a = /* @__PURE__ */ p("ZodCUID2", (e, t) => {
  bl.init(e, t), N.init(e, t);
}), wa = /* @__PURE__ */ p("ZodULID", (e, t) => {
  vl.init(e, t), N.init(e, t);
}), ka = /* @__PURE__ */ p("ZodXID", (e, t) => {
  Cl.init(e, t), N.init(e, t);
}), ya = /* @__PURE__ */ p("ZodKSUID", (e, t) => {
  _l.init(e, t), N.init(e, t);
}), Sa = /* @__PURE__ */ p("ZodIPv4", (e, t) => {
  El.init(e, t), N.init(e, t);
}), Ea = /* @__PURE__ */ p("ZodIPv6", (e, t) => {
  xl.init(e, t), N.init(e, t);
}), xa = /* @__PURE__ */ p("ZodCIDRv4", (e, t) => {
  Tl.init(e, t), N.init(e, t);
}), Ta = /* @__PURE__ */ p("ZodCIDRv6", (e, t) => {
  Hl.init(e, t), N.init(e, t);
}), Ha = /* @__PURE__ */ p("ZodBase64", (e, t) => {
  Vl.init(e, t), N.init(e, t);
}), Va = /* @__PURE__ */ p("ZodBase64URL", (e, t) => {
  Zl.init(e, t), N.init(e, t);
}), Ma = /* @__PURE__ */ p("ZodE164", (e, t) => {
  Il.init(e, t), N.init(e, t);
}), Za = /* @__PURE__ */ p("ZodJWT", (e, t) => {
  zl.init(e, t), N.init(e, t);
}), Zo = /* @__PURE__ */ p("ZodNumber", (e, t) => {
  Eo.init(e, t), D.init(e, t), e.gt = (o, r) => e.check(kn(o, r)), e.gte = (o, r) => e.check(at(o, r)), e.min = (o, r) => e.check(at(o, r)), e.lt = (o, r) => e.check(wn(o, r)), e.lte = (o, r) => e.check(st(o, r)), e.max = (o, r) => e.check(st(o, r)), e.int = (o) => e.check(En(o)), e.safe = (o) => e.check(En(o)), e.positive = (o) => e.check(kn(0, o)), e.nonnegative = (o) => e.check(at(0, o)), e.negative = (o) => e.check(wn(0, o)), e.nonpositive = (o) => e.check(st(0, o)), e.multipleOf = (o, r) => e.check(yn(o, r)), e.step = (o, r) => e.check(yn(o, r)), e.finite = () => e;
  const n = e._zod.bag;
  e.minValue = Math.max(n.minimum ?? Number.NEGATIVE_INFINITY, n.exclusiveMinimum ?? Number.NEGATIVE_INFINITY) ?? null, e.maxValue = Math.min(n.maximum ?? Number.POSITIVE_INFINITY, n.exclusiveMaximum ?? Number.POSITIVE_INFINITY) ?? null, e.isInt = (n.format ?? "").includes("int") || Number.isSafeInteger(n.multipleOf ?? 0.5), e.isFinite = !0, e.format = n.format ?? null;
});
function Ia(e) {
  return Hs(Zo, e);
}
const La = /* @__PURE__ */ p("ZodNumberFormat", (e, t) => {
  Rl.init(e, t), Zo.init(e, t);
});
function En(e) {
  return Vs(La, e);
}
const za = /* @__PURE__ */ p("ZodBoolean", (e, t) => {
  Bl.init(e, t), D.init(e, t);
});
function Ra(e) {
  return Ms(za, e);
}
const Ba = /* @__PURE__ */ p("ZodUnknown", (e, t) => {
  Ol.init(e, t), D.init(e, t);
});
function xn() {
  return Zs(Ba);
}
const Oa = /* @__PURE__ */ p("ZodNever", (e, t) => {
  Pl.init(e, t), D.init(e, t);
});
function Pa(e) {
  return Is(Oa, e);
}
const Na = /* @__PURE__ */ p("ZodArray", (e, t) => {
  Nl.init(e, t), D.init(e, t), e.element = t.element, e.min = (n, o) => e.check(Ue(n, o)), e.nonempty = (n) => e.check(Ue(1, n)), e.max = (n, o) => e.check(Ho(n, o)), e.length = (n, o) => e.check(Vo(n, o)), e.unwrap = () => e.element;
});
function Aa(e, t) {
  return Fs(Na, e, t);
}
const $a = /* @__PURE__ */ p("ZodObject", (e, t) => {
  $l.init(e, t), D.init(e, t), R(e, "shape", () => t.shape), e.keyof = () => Ga(Object.keys(e._zod.def.shape)), e.catchall = (n) => e.clone({ ...e._zod.def, catchall: n }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: xn() }), e.loose = () => e.clone({ ...e._zod.def, catchall: xn() }), e.strict = () => e.clone({ ...e._zod.def, catchall: Pa() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (n) => cc(e, n), e.safeExtend = (n) => lc(e, n), e.merge = (n) => sc(e, n), e.pick = (n) => rc(e, n), e.omit = (n) => ic(e, n), e.partial = (...n) => ac(Lo, e, n[0]), e.required = (...n) => uc(zo, e, n[0]);
});
function Io(e, t) {
  const n = {
    type: "object",
    shape: e ?? {},
    ...k(t)
  };
  return new $a(n);
}
const Da = /* @__PURE__ */ p("ZodUnion", (e, t) => {
  Dl.init(e, t), D.init(e, t), e.options = t.options;
});
function Fa(e, t) {
  return new Da({
    type: "union",
    options: e,
    ...k(t)
  });
}
const ja = /* @__PURE__ */ p("ZodIntersection", (e, t) => {
  Fl.init(e, t), D.init(e, t);
});
function Ua(e, t) {
  return new ja({
    type: "intersection",
    left: e,
    right: t
  });
}
const kt = /* @__PURE__ */ p("ZodEnum", (e, t) => {
  jl.init(e, t), D.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const n = new Set(Object.keys(t.entries));
  e.extract = (o, r) => {
    const i = {};
    for (const c of o)
      if (n.has(c))
        i[c] = t.entries[c];
      else
        throw new Error(`Key ${c} not found in enum`);
    return new kt({
      ...t,
      checks: [],
      ...k(r),
      entries: i
    });
  }, e.exclude = (o, r) => {
    const i = { ...t.entries };
    for (const c of o)
      if (n.has(c))
        delete i[c];
      else
        throw new Error(`Key ${c} not found in enum`);
    return new kt({
      ...t,
      checks: [],
      ...k(r),
      entries: i
    });
  };
});
function Ga(e, t) {
  const n = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new kt({
    type: "enum",
    entries: n,
    ...k(t)
  });
}
const Wa = /* @__PURE__ */ p("ZodTransform", (e, t) => {
  Ul.init(e, t), D.init(e, t), e._zod.parse = (n, o) => {
    if (o.direction === "backward")
      throw new ao(e.constructor.name);
    n.addIssue = (i) => {
      if (typeof i == "string")
        n.issues.push(Ee(i, n.value, t));
      else {
        const c = i;
        c.fatal && (c.continue = !1), c.code ?? (c.code = "custom"), c.input ?? (c.input = n.value), c.inst ?? (c.inst = e), n.issues.push(Ee(c));
      }
    };
    const r = t.transform(n.value, n);
    return r instanceof Promise ? r.then((i) => (n.value = i, n)) : (n.value = r, n);
  };
});
function Ka(e) {
  return new Wa({
    type: "transform",
    transform: e
  });
}
const Lo = /* @__PURE__ */ p("ZodOptional", (e, t) => {
  Gl.init(e, t), D.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Tn(e) {
  return new Lo({
    type: "optional",
    innerType: e
  });
}
const qa = /* @__PURE__ */ p("ZodNullable", (e, t) => {
  Wl.init(e, t), D.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Hn(e) {
  return new qa({
    type: "nullable",
    innerType: e
  });
}
const Xa = /* @__PURE__ */ p("ZodDefault", (e, t) => {
  At.init(e, t), D.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function Ja(e, t) {
  return new Xa({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : mo(t);
    }
  });
}
const Ya = /* @__PURE__ */ p("ZodPrefault", (e, t) => {
  Kl.init(e, t), D.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Qa(e, t) {
  return new Ya({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : mo(t);
    }
  });
}
const zo = /* @__PURE__ */ p("ZodNonOptional", (e, t) => {
  ql.init(e, t), D.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function eu(e, t) {
  return new zo({
    type: "nonoptional",
    innerType: e,
    ...k(t)
  });
}
const tu = /* @__PURE__ */ p("ZodCatch", (e, t) => {
  Xl.init(e, t), D.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function nu(e, t) {
  return new tu({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const ou = /* @__PURE__ */ p("ZodPipe", (e, t) => {
  Jl.init(e, t), D.init(e, t), e.in = t.in, e.out = t.out;
});
function Vn(e, t) {
  return new ou({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const ru = /* @__PURE__ */ p("ZodReadonly", (e, t) => {
  Yl.init(e, t), D.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function iu(e) {
  return new ru({
    type: "readonly",
    innerType: e
  });
}
const cu = /* @__PURE__ */ p("ZodCustom", (e, t) => {
  Ql.init(e, t), D.init(e, t);
});
function lu(e, t = {}) {
  return js(cu, e, t);
}
function su(e) {
  return Us(e);
}
const xe = Io({
  caption: wt().default(""),
  // TODO: "" as defaults?
  name: wt().default("")
}), et = Io({
  // URL is optional, as we also want to accept files with no URL, but for example ids
  // (ids can be used for files that are resolved on the backend)
  url: wt().default(""),
  // Whether to show the file preview or the name only.
  // This is useful for some file blocks, but not all
  // (e.g.: not relevant for default "file" block which doesn;'t show previews)
  showPreview: Ra().default(!0),
  // File preview width in px.
  previewWidth: Ia().optional()
}), au = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: l }) => {
      var f;
      if (!l.isEditable)
        return;
      const u = ((f = l.getSelection()) == null ? void 0 : f.blocks) || [
        l.getTextCursorPosition().block
      ];
      if (u.length !== 1)
        return;
      const d = u[0];
      if (!(Ce(l, d.type) && ve(
        d,
        l,
        xe.pick({ caption: !0 })
      )))
        return d;
    }
  }), [r, i] = V();
  x(() => {
    o !== void 0 && i(o.props.caption);
  }, [o]);
  const c = y(
    (l) => i(l.currentTarget.value),
    []
  ), s = y(
    (l) => {
      o !== void 0 && ve(
        o,
        n,
        xe.pick({ caption: !0 })
      ) && l.key === "Enter" && (l.preventDefault(), n.updateBlock(o.id, {
        props: {
          caption: r
        }
      }));
    },
    [o, r, n]
  );
  return o === void 0 ? null : /* @__PURE__ */ E(t.Generic.Popover.Root, { children: [
    /* @__PURE__ */ a(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ a(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.file_caption.tooltip,
        mainTooltip: e.formatting_toolbar.file_caption.tooltip,
        icon: /* @__PURE__ */ a(rn, {})
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ a(t.Generic.Form.Root, { children: /* @__PURE__ */ a(
          t.Generic.Form.TextInput,
          {
            name: "file-caption",
            icon: /* @__PURE__ */ a(rn, {}),
            value: r || "",
            autoFocus: !0,
            placeholder: e.formatting_toolbar.file_caption.input_placeholder,
            onKeyDown: s,
            onChange: c
          }
        ) })
      }
    )
  ] });
}, uu = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: i }) => {
      var l;
      if (!i.isEditable)
        return;
      const c = ((l = i.getSelection()) == null ? void 0 : l.blocks) || [
        i.getTextCursorPosition().block
      ];
      if (c.length !== 1)
        return;
      const s = c[0];
      if (Ce(i, s.type))
        return s;
    }
  }), r = y(() => {
    o !== void 0 && (n.focus(), n.removeBlocks([o.id]));
  }, [o, n]);
  return o === void 0 ? null : /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.file_delete.tooltip[o.type] || e.formatting_toolbar.file_delete.tooltip.file,
      mainTooltip: e.formatting_toolbar.file_delete.tooltip[o.type] || e.formatting_toolbar.file_delete.tooltip.file,
      icon: /* @__PURE__ */ a(Ai, {}),
      onClick: r
    }
  );
}, du = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: l }) => {
      var f;
      if (!l.isEditable)
        return;
      const u = ((f = l.getSelection()) == null ? void 0 : f.blocks) || [
        l.getTextCursorPosition().block
      ];
      if (u.length !== 1)
        return;
      const d = u[0];
      if (Ce(l, d.type))
        return d;
    }
  }), [r, i] = V();
  x(() => {
    o !== void 0 && i(o.props.name);
  }, [o]);
  const c = y(
    (l) => i(l.currentTarget.value),
    []
  ), s = y(
    (l) => {
      o !== void 0 && l.key === "Enter" && (l.preventDefault(), n.updateBlock(o.id, {
        props: {
          name: r
        }
      }));
    },
    [o, r, n]
  );
  return o === void 0 ? null : /* @__PURE__ */ E(t.Generic.Popover.Root, { children: [
    /* @__PURE__ */ a(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ a(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.file_rename.tooltip[o.type] || e.formatting_toolbar.file_rename.tooltip.file,
        mainTooltip: e.formatting_toolbar.file_rename.tooltip[o.type] || e.formatting_toolbar.file_rename.tooltip.file,
        icon: /* @__PURE__ */ a(on, {})
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ a(t.Generic.Form.Root, { children: /* @__PURE__ */ a(
          t.Generic.Form.TextInput,
          {
            name: "file-name",
            icon: /* @__PURE__ */ a(on, {}),
            value: r || "",
            autoFocus: !0,
            placeholder: e.formatting_toolbar.file_rename.input_placeholder[o.type] || e.formatting_toolbar.file_rename.input_placeholder.file,
            onKeyDown: s,
            onChange: c
          }
        ) })
      }
    )
  ] });
}, fu = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: r }) => {
      var s;
      if (!r.isEditable)
        return;
      const i = ((s = r.getSelection()) == null ? void 0 : s.blocks) || [
        r.getTextCursorPosition().block
      ];
      if (i.length !== 1)
        return;
      const c = i[0];
      if (Ce(r, c.type))
        return c;
    }
  });
  return o === void 0 ? null : /* @__PURE__ */ E(t.Generic.Popover.Root, { position: "bottom", children: [
    /* @__PURE__ */ a(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ a(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        mainTooltip: e.formatting_toolbar.file_replace.tooltip[o.type] || e.formatting_toolbar.file_replace.tooltip.file,
        label: e.formatting_toolbar.file_replace.tooltip[o.type] || e.formatting_toolbar.file_replace.tooltip.file,
        icon: /* @__PURE__ */ a(Bi, {})
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-panel-popover",
        variant: "panel-popover",
        children: /* @__PURE__ */ a(Un, { blockId: o.id })
      }
    )
  ] });
}, mu = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: i }) => {
      var c;
      if (
        // The editor is read-only.
        !(!i.isEditable || // None of the selected blocks have inline content
        !(((c = i.getSelection()) == null ? void 0 : c.blocks) || [
          i.getTextCursorPosition().block
        ]).find((s) => s.content !== void 0))
      )
        return {
          canNestBlock: i.canNestBlock()
        };
    }
  }), r = y(() => {
    o !== void 0 && o.canNestBlock && (n.focus(), n.nestBlock());
  }, [n, o]);
  return o === void 0 ? null : /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": "nestBlock",
      onClick: r,
      isDisabled: !o.canNestBlock,
      label: e.formatting_toolbar.nest.tooltip,
      mainTooltip: e.formatting_toolbar.nest.tooltip,
      secondaryTooltip: Ke(
        e.formatting_toolbar.nest.secondary_tooltip,
        e.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ a(xi, {})
    }
  );
}, hu = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: i }) => {
      var c;
      if (
        // The editor is read-only.
        !(!i.isEditable || // None of the selected blocks have inline content
        !(((c = i.getSelection()) == null ? void 0 : c.blocks) || [
          i.getTextCursorPosition().block
        ]).find((s) => s.content !== void 0))
      )
        return {
          canUnnestBlock: i.canUnnestBlock()
        };
    }
  }), r = y(() => {
    o !== void 0 && o.canUnnestBlock && (n.focus(), n.unnestBlock());
  }, [n, o]);
  return o === void 0 ? null : /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": "unnestBlock",
      onClick: r,
      isDisabled: !o.canUnnestBlock,
      label: e.formatting_toolbar.unnest.tooltip,
      mainTooltip: e.formatting_toolbar.unnest.tooltip,
      secondaryTooltip: Ke(
        e.formatting_toolbar.unnest.secondary_tooltip,
        e.generic.ctrl_shortcut
      ),
      icon: /* @__PURE__ */ a(Ei, {})
    }
  );
}, pu = (e) => {
  const t = [];
  t.push({
    name: e.dictionary.slash_menu.paragraph.title,
    type: "paragraph",
    icon: It
  });
  const n = [pt, gt, bt, Jn, Yn, Qn];
  if (Bn(e, "heading", {
    level: 1,
    isToggleable: !1
  }))
    for (const o of [1, 2, 3, 4, 5, 6])
      t.push({
        name: e.dictionary.slash_menu[`heading_${o}`].title,
        type: "heading",
        props: { level: o, isToggleable: !1 },
        icon: n[o - 1]
      });
  else
    for (const o of [1, 2, 3, 4, 5, 6])
      t.push({
        name: e.dictionary.slash_menu[`heading_${o}`].title,
        type: "heading",
        props: { level: o },
        icon: n[o - 1]
      });
  for (const o of [1, 2, 3])
    t.push({
      name: e.dictionary.slash_menu[`toggle_heading_${o}`].title,
      type: "heading",
      props: { level: o, isToggleable: !0 },
      icon: n[o - 1]
    });
  return t.push(
    {
      name: e.dictionary.slash_menu.quote.title,
      type: "quote",
      icon: ro
    },
    {
      name: e.dictionary.slash_menu.toggle_list.title,
      type: "toggleListItem",
      icon: co
    },
    {
      name: e.dictionary.slash_menu.bullet_list.title,
      type: "bulletListItem",
      icon: oo
    },
    {
      name: e.dictionary.slash_menu.numbered_list.title,
      type: "numberedListItem",
      icon: no
    },
    {
      name: e.dictionary.slash_menu.check_list.title,
      type: "checkListItem",
      icon: to
    }
  ), t;
}, gu = (e) => {
  const t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: l }) => {
      var u;
      return ((u = l.getSelection()) == null ? void 0 : u.blocks) || [l.getTextCursorPosition().block];
    }
  }), r = o[0], i = T(
    () => (e.items || pu(n)).filter(
      (l) => l.props ? Bn(n, l.type, l.props) : hr(n, l.type)
    ),
    [n, e.items]
  ), c = T(() => i.map((l) => {
    const u = l.icon, d = l.type === r.type, f = Object.entries(l.props || {}).filter(
      ([m, h]) => h !== r.props[m]
    ).length === 0;
    return {
      text: l.name,
      icon: /* @__PURE__ */ a(u, { size: 16 }),
      onClick: () => {
        n.focus(), n.transact(() => {
          for (const m of o)
            n.updateBlock(m, {
              type: l.type,
              props: l.props
            });
        });
      },
      isSelected: d && f
    };
  }), [
    n,
    i,
    r.props,
    r.type,
    o
  ]);
  return !T(
    () => c.find((l) => l.isSelected) !== void 0,
    [c]
  ) || !n.isEditable ? null : /* @__PURE__ */ a(
    t.FormattingToolbar.Select,
    {
      className: "bn-select",
      items: c
    }
  );
}, bu = () => {
  const e = H(), t = _(), n = Z("comments"), { store: o } = Z(be), r = y(() => {
    n.startPendingComment(), o.setState(!1);
  }, [n, o]);
  return /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.comment.tooltip,
      mainTooltip: e.formatting_toolbar.comment.tooltip,
      icon: /* @__PURE__ */ a(Xn, {}),
      onClick: r
    }
  );
}, vu = () => C().getExtension("comments") ? /* @__PURE__ */ a(bu, {}) : null, Cu = () => {
  const e = H(), t = _(), n = C(), o = y(() => {
    n._tiptapEditor.chain().focus().addPendingComment().run();
  }, [n]);
  return (
    // We manually check if a comment extension (like liveblocks) is installed
    // By adding default support for this, the user doesn't need to customize the formatting toolbar
    !n._tiptapEditor.commands.addPendingComment || !n.isEditable ? null : /* @__PURE__ */ a(
      t.FormattingToolbar.Button,
      {
        className: "bn-button",
        label: e.formatting_toolbar.comment.tooltip,
        mainTooltip: e.formatting_toolbar.comment.tooltip,
        icon: /* @__PURE__ */ a(Xn, {}),
        onClick: o
      }
    )
  );
};
function yt(e, t) {
  try {
    const n = new URL(e, t);
    if (n.protocol !== "javascript:")
      return n.href;
  } catch {
  }
  return "#";
}
const _u = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: i }) => {
      var l;
      const c = ((l = i.getSelection()) == null ? void 0 : l.blocks) || [
        i.getTextCursorPosition().block
      ];
      if (c.length !== 1)
        return;
      const s = c[0];
      if (Ce(i, s.type))
        return s;
    }
  }), r = y(() => {
    o !== void 0 && (n.focus(), n.resolveFileUrl ? n.resolveFileUrl(o.props.url).then(
      (i) => window.open(yt(i, window.location.href))
    ) : window.open(yt(o.props.url, window.location.href)));
  }, [o, n]);
  return o === void 0 ? null : /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.file_download.tooltip[o.type] || e.formatting_toolbar.file_download.tooltip.file,
      mainTooltip: e.formatting_toolbar.file_download.tooltip[o.type] || e.formatting_toolbar.file_download.tooltip.file,
      icon: /* @__PURE__ */ a(Di, {}),
      onClick: r
    }
  );
}, wu = () => {
  const e = H(), t = _(), n = C(), o = P({
    editor: n,
    selector: ({ editor: i }) => {
      var l;
      if (!i.isEditable)
        return;
      const c = ((l = i.getSelection()) == null ? void 0 : l.blocks) || [
        i.getTextCursorPosition().block
      ];
      if (c.length !== 1)
        return;
      const s = c[0];
      if (!(!Ce(i, s.type) || !ve(
        s,
        i,
        et.pick({ url: !0, showPreview: !0 })
      )))
        return s;
    }
  }), r = y(() => {
    o !== void 0 && n.updateBlock(o.id, {
      props: {
        showPreview: !o.props.showPreview
      }
    });
  }, [o, n]);
  return o === void 0 ? null : /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: "Toggle preview",
      mainTooltip: e.formatting_toolbar.file_preview_toggle.tooltip,
      icon: /* @__PURE__ */ a(Ri, {}),
      isSelected: o.props.showPreview,
      onClick: r
    }
  );
}, ku = () => {
  const e = H(), t = _(), n = C(), o = Z(O), r = P({
    editor: n,
    selector: ({ editor: c }) => {
      var u;
      if (!c.isEditable || !c.settings.tables.splitCells)
        return;
      const s = ((u = c.getSelection()) == null ? void 0 : u.blocks) || [
        c.getTextCursorPosition().block
      ];
      if (s.length !== 1)
        return;
      const l = s[0];
      if (l.type === "table")
        return {
          mergeDirection: o.getMergeDirection(l)
        };
    }
  }), i = y(() => {
    o == null || o.mergeCells();
  }, [o]);
  return r === void 0 ? null : /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      label: e.formatting_toolbar.table_cell_merge.tooltip,
      mainTooltip: e.formatting_toolbar.table_cell_merge.tooltip,
      icon: r.mergeDirection === "horizontal" ? /* @__PURE__ */ a(Vi, {}) : /* @__PURE__ */ a(Mi, {}),
      onClick: i
    }
  );
}, yu = {
  left: wi,
  center: Ci,
  right: ki,
  justify: _i
}, ut = (e) => {
  const t = _(), n = H(), o = C(), r = Z(O), i = P({
    editor: o,
    selector: ({ editor: l }) => {
      var f;
      if (!l.isEditable)
        return;
      const u = ((f = l.getSelection()) == null ? void 0 : f.blocks) || [
        l.getTextCursorPosition().block
      ], d = u[0];
      if (ve(
        d,
        l,
        le.pick({ textAlignment: !0 })
      ))
        return {
          textAlignment: d.props.textAlignment,
          blocks: u
        };
      if (u.length === 1 && d.type === "table")
        return r.getCellSelection() ? {
          textAlignment: ke(
            d.content.rows[0].cells[0]
          ).props.textAlignment,
          blocks: [d]
        } : void 0;
    }
  }), c = y(
    (l) => {
      if (i !== void 0) {
        o.focus();
        for (const u of i.blocks)
          if (ve(
            u,
            o,
            le.pick({ textAlignment: !0 })
          ))
            o.updateBlock(u, {
              props: { textAlignment: l }
            });
          else if (u.type === "table") {
            const d = r.getCellSelection();
            if (!d)
              continue;
            const f = u.content.rows.map(
              (m) => ({
                ...m,
                cells: m.cells.map((h) => ke(h))
              })
            );
            d.cells.forEach(({ row: m, col: h }) => {
              f[m].cells[h].props.textAlignment = l;
            }), o.updateBlock(u, {
              type: "table",
              content: {
                ...u.content,
                type: "tableContent",
                rows: f
              }
            }), o.setTextCursorPosition(u);
          }
      }
    },
    [o, i, r]
  );
  if (i === void 0)
    return null;
  const s = yu[e.textAlignment];
  return /* @__PURE__ */ a(
    t.FormattingToolbar.Button,
    {
      className: "bn-button",
      "data-test": `alignText${e.textAlignment.slice(0, 1).toUpperCase() + e.textAlignment.slice(1)}`,
      onClick: () => c(e.textAlignment),
      isSelected: i.textAlignment === e.textAlignment,
      label: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
      mainTooltip: n.formatting_toolbar[`align_${e.textAlignment}`].tooltip,
      icon: /* @__PURE__ */ a(s, {})
    }
  );
}, Su = (e) => [
  /* @__PURE__ */ a(gu, { items: e }, "blockTypeSelect"),
  /* @__PURE__ */ a(ku, {}, "tableCellMergeButton"),
  /* @__PURE__ */ a(au, {}, "fileCaptionButton"),
  /* @__PURE__ */ a(fu, {}, "replaceFileButton"),
  /* @__PURE__ */ a(du, {}, "fileRenameButton"),
  /* @__PURE__ */ a(uu, {}, "fileDeleteButton"),
  /* @__PURE__ */ a(_u, {}, "fileDownloadButton"),
  /* @__PURE__ */ a(wu, {}, "filePreviewButton"),
  /* @__PURE__ */ a(Ie, { basicTextStyle: "bold" }, "boldStyleButton"),
  /* @__PURE__ */ a(Ie, { basicTextStyle: "italic" }, "italicStyleButton"),
  /* @__PURE__ */ a(
    Ie,
    {
      basicTextStyle: "underline"
    },
    "underlineStyleButton"
  ),
  /* @__PURE__ */ a(Ie, { basicTextStyle: "strike" }, "strikeStyleButton"),
  /* @__PURE__ */ a(ut, { textAlignment: "left" }, "textAlignLeftButton"),
  /* @__PURE__ */ a(ut, { textAlignment: "center" }, "textAlignCenterButton"),
  /* @__PURE__ */ a(ut, { textAlignment: "right" }, "textAlignRightButton"),
  /* @__PURE__ */ a(qi, {}, "colorStyleButton"),
  /* @__PURE__ */ a(mu, {}, "nestBlockButton"),
  /* @__PURE__ */ a(hu, {}, "unnestBlockButton"),
  /* @__PURE__ */ a(Ji, {}, "createLinkButton"),
  /* @__PURE__ */ a(vu, {}, "addCommentButton"),
  /* @__PURE__ */ a(Cu, {}, "addTiptapCommentButton")
], Ro = (e) => {
  const t = _();
  return /* @__PURE__ */ a(
    t.FormattingToolbar.Root,
    {
      className: "bn-toolbar bn-formatting-toolbar",
      children: e.children || Su(e.blockTypeSelectItems)
    }
  );
}, Eu = (e) => {
  switch (e) {
    case "left":
      return "top-start";
    case "center":
      return "top";
    case "right":
      return "top-end";
    default:
      return "top-start";
  }
}, xu = (e) => {
  const t = C(), n = Z(be, {
    editor: t
  }), o = L(be, {
    editor: t
  }), r = P({
    editor: t,
    selector: ({ editor: l }) => n.store.state ? {
      from: l.prosemirrorState.selection.from,
      to: l.prosemirrorState.selection.to
    } : void 0
  }), i = P({
    editor: t,
    selector: ({ editor: l }) => {
      const u = l.getTextCursorPosition().block;
      return ve(u, l, le.pick({
        textAlignment: !0
      })) ? Eu(u.props.textAlignment) : "top-start";
    }
  }), c = T(
    () => ({
      useFloatingOptions: {
        open: o,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (l, u, d) => {
          n.store.setState(l), d === "escape-key" && t.focus();
        },
        placement: i,
        middleware: [ee(10), Te(), ue()]
      },
      elementProps: {
        style: {
          zIndex: 40
        }
      },
      ...e.floatingUIOptions
    }),
    [o, i, e.floatingUIOptions, n.store, t]
  ), s = e.formattingToolbar || Ro;
  return /* @__PURE__ */ a(Mt, { position: r, ...c, children: o && /* @__PURE__ */ a(s, {}) });
}, Tu = (e) => {
  const t = _(), n = H(), { deleteLink: o } = Z(We);
  return /* @__PURE__ */ a(
    t.LinkToolbar.Button,
    {
      className: "bn-button",
      label: n.link_toolbar.delete.tooltip,
      mainTooltip: n.link_toolbar.delete.tooltip,
      isSelected: !1,
      onClick: () => {
        var r;
        o(e.range.from), (r = e.setToolbarOpen) == null || r.call(e, !1);
      },
      icon: /* @__PURE__ */ a(Hi, {})
    }
  );
}, Hu = (e) => {
  const t = _(), n = H();
  return /* @__PURE__ */ E(t.Generic.Popover.Root, { onOpenChange: e.setToolbarFrozen, children: [
    /* @__PURE__ */ a(t.Generic.Popover.Trigger, { children: /* @__PURE__ */ a(
      t.LinkToolbar.Button,
      {
        className: "bn-button",
        mainTooltip: n.link_toolbar.edit.tooltip,
        isSelected: !1,
        children: n.link_toolbar.edit.text
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Popover.Content,
      {
        className: "bn-popover-content bn-form-popover",
        variant: "form-popover",
        children: /* @__PURE__ */ a(
          so,
          {
            url: e.url,
            text: e.text,
            range: e.range,
            setToolbarOpen: e.setToolbarOpen,
            setToolbarFrozen: e.setToolbarFrozen
          }
        )
      }
    )
  ] });
}, Vu = (e) => {
  const t = _(), n = H();
  return /* @__PURE__ */ a(
    t.LinkToolbar.Button,
    {
      className: "bn-button",
      mainTooltip: n.link_toolbar.open.tooltip,
      label: n.link_toolbar.open.tooltip,
      isSelected: !1,
      onClick: () => {
        window.open(yt(e.url, window.location.href), "_blank");
      },
      icon: /* @__PURE__ */ a(Fi, {})
    }
  );
}, Mu = (e) => {
  const t = _();
  return /* @__PURE__ */ a(t.LinkToolbar.Root, { className: "bn-toolbar bn-link-toolbar", children: e.children || /* @__PURE__ */ E(j, { children: [
    /* @__PURE__ */ a(
      Hu,
      {
        url: e.url,
        text: e.text,
        range: e.range,
        setToolbarFrozen: e.setToolbarFrozen,
        setToolbarOpen: e.setToolbarOpen
      }
    ),
    /* @__PURE__ */ a(Vu, { url: e.url }),
    /* @__PURE__ */ a(
      Tu,
      {
        range: e.range,
        setToolbarOpen: e.setToolbarOpen
      }
    )
  ] }) });
}, Zu = (e) => {
  const t = C(), [n, o] = V(!1), [r, i] = V(!1), c = Z(We), s = P({
    editor: t,
    selector: () => {
      const g = c.getLinkAtSelection();
      if (g)
        return {
          url: g.mark.attrs.href,
          text: g.text,
          range: g.range,
          element: c.getLinkElementAtPos(g.range.from)
        };
    }
  });
  x(() => {
    r || (o(!!s), s && u(void 0));
  }, [r, s]);
  const [l, u] = V(void 0);
  x(() => {
    const g = (b) => {
      if (s || !(b.target instanceof HTMLElement))
        return;
      const v = c.getLinkAtElement(b.target);
      v && u({
        url: v.mark.attrs.href,
        text: v.text,
        range: v.range,
        element: c.getLinkElementAtPos(v.range.from)
      });
    };
    return document.body.addEventListener("mouseover", g), () => {
      document.body.removeEventListener("mouseover", g);
    };
  }, [r, c, l == null ? void 0 : l.url, s]);
  const d = s || l, f = T(
    () => ({
      useFloatingOptions: {
        open: n,
        onOpenChange: (g, b, v) => {
          r || s && v === "hover" || (v === "escape-key" && t.focus(), o(g));
        },
        placement: "top-start",
        middleware: [ee(10), ue()]
      },
      useHoverProps: {
        // `useHover` hook only enabled when a link is hovered with the
        // mouse.
        enabled: !s && !!l,
        delay: {
          open: 250,
          close: 250
        },
        handleClose: fr()
      },
      elementProps: {
        style: {
          zIndex: 50
        }
      },
      ...e.floatingUIOptions
    }),
    [
      t,
      r,
      l,
      n,
      e.floatingUIOptions,
      s
    ]
  ), m = T(
    () => d != null && d.element ? { element: d.element } : void 0,
    [d == null ? void 0 : d.element]
  );
  if (!t.isEditable)
    return null;
  const h = e.linkToolbar || Mu;
  return /* @__PURE__ */ a(Q, { reference: m, ...f, children: d && /* @__PURE__ */ a(
    h,
    {
      url: d.url,
      text: d.text,
      range: d.range,
      setToolbarFrozen: i,
      setToolbarOpen: o
    }
  ) });
};
function Iu(e) {
  return w({ attr: { viewBox: "0 0 1024 1024" }, child: [{ tag: "path", attr: { d: "M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8Z" }, child: [] }, { tag: "path", attr: { d: "M192 474h672q8 0 8 8v60q0 8-8 8H160q-8 0-8-8v-60q0-8 8-8Z" }, child: [] }] })(e);
}
const Lu = () => {
  const e = _(), t = H(), n = C(), o = Z(re), r = L(te, {
    editor: n,
    selector: (c) => c == null ? void 0 : c.block
  }), i = y(() => {
    if (r === void 0)
      return;
    const c = r.content;
    if (c !== void 0 && Array.isArray(c) && c.length === 0)
      n.setTextCursorPosition(r), o.openSuggestionMenu("/");
    else {
      const l = n.insertBlocks(
        [{ type: "paragraph" }],
        r,
        "after"
      )[0];
      n.setTextCursorPosition(l), o.openSuggestionMenu("/");
    }
  }, [r, n, o]);
  return r === void 0 ? null : /* @__PURE__ */ a(
    e.SideMenu.Button,
    {
      className: "bn-button",
      label: t.side_menu.add_block_label,
      icon: /* @__PURE__ */ a(Iu, { size: 24, onClick: i, "data-test": "dragHandleAdd" })
    }
  );
};
function Bo(e) {
  return w({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0V0z" }, child: [] }, { tag: "path", attr: { d: "M11 18c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2zm-2-8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 4c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" }, child: [] }] })(e);
}
function zu(e) {
  return w({ attr: { viewBox: "0 0 24 24" }, child: [{ tag: "path", attr: { fill: "none", d: "M0 0h24v24H0z" }, child: [] }, { tag: "path", attr: { d: "m7 10 5 5 5-5z" }, child: [] }] })(e);
}
const Ru = (e) => {
  const t = _(), n = C(), o = L(te, {
    editor: n,
    selector: (r) => r == null ? void 0 : r.block
  });
  return o === void 0 || !Ve(
    n,
    o.type,
    le.pick({ textColor: !0 })
  ) && !Ve(
    n,
    o.type,
    le.pick({ backgroundColor: !0 })
  ) ? null : /* @__PURE__ */ E(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ a(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ a(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ a(
          qe,
          {
            iconSize: 18,
            text: Ve(
              n,
              o.type,
              le.pick({ textColor: !0 })
            ) ? {
              color: o.props.textColor,
              setColor: (r) => n.updateBlock(o, {
                type: o.type,
                props: { textColor: r }
              })
            } : void 0,
            background: Ve(
              n,
              o.type,
              le.pick({ backgroundColor: !0 })
            ) ? {
              color: o.props.backgroundColor,
              setColor: (r) => n.updateBlock(o, {
                props: { backgroundColor: r }
              })
            } : void 0
          }
        )
      }
    )
  ] });
}, Bu = (e) => {
  const t = _(), n = C(), o = L(te, {
    editor: n,
    selector: (r) => r == null ? void 0 : r.block
  });
  return o === void 0 ? null : /* @__PURE__ */ a(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      onClick: () => n.removeBlocks([o]),
      children: e.children
    }
  );
}, Ou = (e) => {
  const t = _(), n = C(), o = L(te, {
    editor: n,
    selector: (i) => i == null ? void 0 : i.block
  });
  if (o === void 0 || o.type !== "table" || !n.settings.tables.headers)
    return null;
  const r = !!o.content.headerRows;
  return /* @__PURE__ */ a(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: r,
      onClick: () => {
        n.updateBlock(o, {
          content: {
            ...o.content,
            headerRows: r ? void 0 : 1
          }
        });
      },
      children: e.children
    }
  );
}, Pu = (e) => {
  const t = _(), n = C(), o = L(te, {
    editor: n,
    selector: (i) => i == null ? void 0 : i.block
  });
  if (o === void 0 || o.type !== "table" || !n.settings.tables.headers)
    return null;
  const r = !!o.content.headerCols;
  return /* @__PURE__ */ a(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: r,
      onClick: () => {
        n.updateBlock(o, {
          content: {
            ...o.content,
            headerCols: r ? void 0 : 1
          }
        });
      },
      children: e.children
    }
  );
}, Nu = (e) => {
  const t = _(), n = H();
  return /* @__PURE__ */ a(
    t.Generic.Menu.Dropdown,
    {
      className: "bn-menu-dropdown bn-drag-handle-menu",
      children: e.children || /* @__PURE__ */ E(j, { children: [
        /* @__PURE__ */ a(Bu, { children: n.drag_handle.delete_menuitem }),
        /* @__PURE__ */ a(Ru, { children: n.drag_handle.colors_menuitem }),
        /* @__PURE__ */ a(Ou, { children: n.drag_handle.header_row_menuitem }),
        /* @__PURE__ */ a(Pu, { children: n.drag_handle.header_column_menuitem })
      ] })
    }
  );
}, Au = (e) => {
  const t = _(), n = H(), o = Z(te), r = L(te, {
    selector: (c) => c == null ? void 0 : c.block
  });
  if (r === void 0)
    return null;
  const i = e.dragHandleMenu || Nu;
  return /* @__PURE__ */ E(
    t.Generic.Menu.Root,
    {
      onOpenChange: (c) => {
        c ? o.freezeMenu() : o.unfreezeMenu();
      },
      position: "left",
      children: [
        /* @__PURE__ */ a(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ a(
          t.SideMenu.Button,
          {
            label: n.side_menu.drag_handle_label,
            draggable: !0,
            onDragStart: (c) => o.blockDragStart(c, r),
            onDragEnd: o.blockDragEnd,
            className: "bn-button",
            icon: /* @__PURE__ */ a(Bo, { size: 24, "data-test": "dragHandle" })
          }
        ) }),
        /* @__PURE__ */ a(i, { children: e.children })
      ]
    }
  );
}, $u = (e) => {
  const t = _(), n = C(), o = L(te, {
    editor: n,
    selector: (i) => i == null ? void 0 : i.block
  }), r = T(() => {
    var c;
    if (o === void 0)
      return {};
    const i = {
      "data-block-type": o.type
    };
    return o.type === "heading" && (i["data-level"] = o.props.level.toString()), (c = n.schema.blockSpecs[o.type].implementation.meta) != null && c.fileBlockAccept && (o.props.url ? i["data-url"] = "true" : i["data-url"] = "false"), i;
  }, [o, n.schema.blockSpecs]);
  return /* @__PURE__ */ a(t.SideMenu.Root, { className: "bn-side-menu", ...r, children: e.children || /* @__PURE__ */ E(j, { children: [
    /* @__PURE__ */ a(Lu, {}),
    /* @__PURE__ */ a(Au, {})
  ] }) });
}, Du = (e) => {
  const t = L(te, {
    selector: (c) => c !== void 0 ? {
      show: c.show,
      block: c.block
    } : void 0
  }), { show: n, block: o } = t || {}, r = T(
    () => ({
      useFloatingOptions: {
        open: n,
        placement: "left-start"
      },
      useDismissProps: {
        enabled: !1
      },
      elementProps: {
        style: {
          zIndex: 20
        }
      },
      ...e.floatingUIOptions
    }),
    [e.floatingUIOptions, n]
  ), i = e.sideMenu || $u;
  return /* @__PURE__ */ a(Gn, { blockId: n ? o == null ? void 0 : o.id : void 0, ...r, children: (o == null ? void 0 : o.id) && /* @__PURE__ */ a(i, {}) });
};
async function Fu(e, t) {
  return (await or(e, t)).map(
    ({ id: n, onItemClick: o }) => ({
      id: n,
      onItemClick: o,
      icon: n
    })
  );
}
function ju(e) {
  const t = _(), n = H(), { items: o, loadingState: r, selectedIndex: i, onItemClick: c, columns: s } = e, l = r === "loading-initial" || r === "loading" ? /* @__PURE__ */ a(
    t.GridSuggestionMenu.Loader,
    {
      className: "bn-grid-suggestion-menu-loader",
      columns: s
    }
  ) : null, u = T(() => {
    const d = [];
    for (let f = 0; f < o.length; f++) {
      const m = o[f];
      d.push(
        /* @__PURE__ */ a(
          t.GridSuggestionMenu.Item,
          {
            className: "bn-grid-suggestion-menu-item",
            item: m,
            id: `bn-grid-suggestion-menu-item-${f}`,
            isSelected: f === i,
            onClick: () => c == null ? void 0 : c(m)
          },
          m.id
        )
      );
    }
    return d;
  }, [t, o, c, i]);
  return /* @__PURE__ */ E(
    t.GridSuggestionMenu.Root,
    {
      id: "bn-grid-suggestion-menu",
      columns: s,
      className: "bn-grid-suggestion-menu",
      children: [
        l,
        u,
        u.length === 0 && e.loadingState === "loaded" && /* @__PURE__ */ a(
          t.GridSuggestionMenu.EmptyItem,
          {
            className: "bn-grid-suggestion-menu-empty-item",
            columns: s,
            children: n.suggestion_menu.no_items_title
          }
        )
      ]
    }
  );
}
function Oo(e, t, n, o = 3) {
  const r = q(0);
  x(() => {
    t !== void 0 && (e.length > 0 ? r.current = t.length : t.length - r.current > o && n());
  }, [n, o, e.length, t]);
}
function Po(e, t) {
  const [n, o] = V([]), [r, i] = V(!1), c = q(void 0), s = q(void 0);
  return x(() => {
    const l = e;
    c.current = e, i(!0), t(e).then((u) => {
      c.current === l && (o(u), i(!1), s.current = l);
    });
  }, [e, t]), {
    items: n || [],
    // The query that was used to retrieve the last set of items may not be the
    // same as the current query as the items from the current query may not
    // have been retrieved yet. This is useful when using the returns of this
    // hook in other hooks.
    usedQuery: s.current,
    loadingState: s.current === void 0 ? "loading-initial" : r ? "loading" : "loaded"
  };
}
function Uu(e, t, n, o, r) {
  const [i, c] = V(0), s = o !== void 0 && o > 1;
  return x(() => {
    var u;
    const l = (d) => (d.key === "ArrowLeft" && (d.preventDefault(), n.length && c((i - 1 + n.length) % n.length)), d.key === "ArrowRight" && (d.preventDefault(), n.length && c((i + 1 + n.length) % n.length)), d.key === "ArrowUp" ? (d.preventDefault(), n.length && c(
      (i - o + n.length) % n.length
    ), !0) : d.key === "ArrowDown" ? (d.preventDefault(), n.length && c((i + o) % n.length), !0) : d.key === "Enter" && !d.isComposing ? (d.stopPropagation(), d.preventDefault(), n.length && (r == null || r(n[i])), !0) : !1);
    return (u = e.domElement) == null || u.addEventListener(
      "keydown",
      l,
      !0
    ), () => {
      var d;
      (d = e.domElement) == null || d.removeEventListener(
        "keydown",
        l,
        !0
      );
    };
  }, [e.domElement, n, i, r, o, s]), x(() => {
    c(0);
  }, [t]), {
    selectedIndex: n.length === 0 ? void 0 : i
  };
}
function Gu(e) {
  const n = ne().setContentEditableProps, o = C(), {
    getItems: r,
    gridSuggestionMenuComponent: i,
    query: c,
    clearQuery: s,
    closeMenu: l,
    onItemClick: u,
    columns: d
  } = e, f = y(
    (S) => {
      l(), s(), u == null || u(S);
    },
    [u, l, s]
  ), { items: m, usedQuery: h, loadingState: g } = Po(
    c,
    r
  );
  Oo(m, h, l);
  const { selectedIndex: b } = Uu(
    o,
    c,
    m,
    d,
    f
  );
  return x(() => (n((S) => ({
    ...S,
    "aria-expanded": !0,
    "aria-controls": "bn-suggestion-menu"
  })), () => {
    n((S) => ({
      ...S,
      "aria-expanded": !1,
      "aria-controls": void 0
    }));
  }), [n]), x(() => (n((S) => ({
    ...S,
    "aria-activedescendant": b ? "bn-suggestion-menu-item-" + b : void 0
  })), () => {
    n((S) => ({
      ...S,
      "aria-activedescendant": void 0
    }));
  }), [n, b]), /* @__PURE__ */ a(
    i,
    {
      items: m,
      onItemClick: f,
      loadingState: g,
      selectedIndex: b,
      columns: d
    }
  );
}
function Wu(e) {
  var b;
  const t = C(), {
    triggerCharacter: n,
    gridSuggestionMenuComponent: o,
    columns: r,
    minQueryLength: i,
    onItemClick: c,
    getItems: s
  } = e, l = T(() => c || ((v) => {
    v.onItemClick(t);
  }), [t, c]), u = T(() => s || (async (v) => await Fu(
    t,
    v
  )), [t, s]), d = Z(re);
  x(() => {
    d.addTriggerCharacter(n);
  }, [d, n]);
  const f = L(re), m = L(re, {
    selector: (v) => (v == null ? void 0 : v.referencePos) || new DOMRect()
  }), h = T(
    () => {
      var v;
      return {
        // Use first child as the editor DOM element may itself be scrollable.
        // For FloatingUI to auto-update the position during scrolling, the
        // `contextElement` must be a descendant of the scroll container.
        element: ((v = t.domElement) == null ? void 0 : v.firstChild) || void 0,
        getBoundingClientRect: () => m
      };
    },
    [(b = t.domElement) == null ? void 0 : b.firstChild, m]
  ), g = T(
    () => ({
      useFloatingOptions: {
        open: (f == null ? void 0 : f.show) && (f == null ? void 0 : f.triggerCharacter) === n,
        onOpenChange: (v) => {
          v || d.closeMenu();
        },
        placement: "bottom-start",
        middleware: [
          ee(10),
          // Flips the menu placement to maximize the space available, and prevents
          // the menu from being cut off by the confines of the screen.
          ue({
            mainAxis: !0,
            crossAxis: !1
          }),
          Te(),
          we({
            apply({ availableHeight: v, elements: S }) {
              Object.assign(S.floating.style, {
                maxHeight: `${v - 10}px`
              });
            }
          })
        ]
      },
      elementProps: {
        // Prevents editor blurring when clicking the scroll bar.
        onMouseDownCapture: (v) => v.preventDefault(),
        style: {
          zIndex: 70
        }
      },
      ...e.floatingUIOptions
    }),
    [
      e.floatingUIOptions,
      f == null ? void 0 : f.show,
      f == null ? void 0 : f.triggerCharacter,
      d,
      n
    ]
  );
  return !f || !f.ignoreQueryLength && i && (f.query.startsWith(" ") || f.query.length < i) ? null : /* @__PURE__ */ a(Q, { reference: h, ...g, children: n && /* @__PURE__ */ a(
    Gu,
    {
      query: f.query,
      closeMenu: d.closeMenu,
      clearQuery: d.clearQuery,
      getItems: u,
      columns: r,
      gridSuggestionMenuComponent: o || ju,
      onItemClick: l
    }
  ) });
}
function Ku(e) {
  const t = _(), n = H(), { items: o, loadingState: r, selectedIndex: i, onItemClick: c } = e, s = r === "loading-initial" || r === "loading" ? /* @__PURE__ */ a(
    t.SuggestionMenu.Loader,
    {
      className: "bn-suggestion-menu-loader"
    }
  ) : null, l = T(() => {
    let u;
    const d = [];
    for (let f = 0; f < o.length; f++) {
      const m = o[f];
      m.group !== u && (u = m.group, d.push(
        /* @__PURE__ */ a(
          t.SuggestionMenu.Label,
          {
            className: "bn-suggestion-menu-label",
            children: u
          },
          u
        )
      )), d.push(
        /* @__PURE__ */ a(
          t.SuggestionMenu.Item,
          {
            className: G(
              "bn-suggestion-menu-item",
              m.size === "small" ? "bn-suggestion-menu-item-small" : ""
            ),
            item: m,
            id: `bn-suggestion-menu-item-${f}`,
            isSelected: f === i,
            onClick: () => c == null ? void 0 : c(m)
          },
          m.title
        )
      );
    }
    return d;
  }, [t, o, c, i]);
  return /* @__PURE__ */ E(
    t.SuggestionMenu.Root,
    {
      id: "bn-suggestion-menu",
      className: "bn-suggestion-menu",
      children: [
        l,
        l.length === 0 && (e.loadingState === "loading" || e.loadingState === "loaded") && /* @__PURE__ */ a(
          t.SuggestionMenu.EmptyItem,
          {
            className: "bn-suggestion-menu-item",
            children: n.suggestion_menu.no_items_title
          }
        ),
        s
      ]
    }
  );
}
function qu(e, t) {
  const [n, o] = V(0);
  return {
    selectedIndex: n,
    setSelectedIndex: o,
    handler: (r) => {
      if (r.key === "ArrowUp")
        return r.preventDefault(), e.length && o((n - 1 + e.length) % e.length), !0;
      if (r.key === "ArrowDown")
        return r.preventDefault(), e.length && o((n + 1) % e.length), !0;
      const i = Xu(r) ? r.nativeEvent.isComposing : r.isComposing;
      return r.key === "Enter" && !i ? (r.preventDefault(), r.stopPropagation(), e.length && (t == null || t(e[n])), !0) : !1;
    }
  };
}
function Xu(e) {
  return e.nativeEvent !== void 0;
}
function Ju(e, t, n, o, r) {
  const { selectedIndex: i, setSelectedIndex: c, handler: s } = qu(n, o);
  return x(() => {
    var l;
    return (l = r || e.domElement) == null || l.addEventListener("keydown", s, !0), () => {
      var u;
      (u = r || e.domElement) == null || u.removeEventListener(
        "keydown",
        s,
        !0
      );
    };
  }, [e.domElement, n, i, o, r, s]), x(() => {
    c(0);
  }, [t, c]), {
    selectedIndex: n.length === 0 ? void 0 : i
  };
}
function Yu(e) {
  const n = ne().setContentEditableProps, o = C(), {
    getItems: r,
    suggestionMenuComponent: i,
    query: c,
    clearQuery: s,
    closeMenu: l,
    onItemClick: u
  } = e, d = y(
    (v) => {
      l(), s(), u == null || u(v);
    },
    [u, l, s]
  ), { items: f, usedQuery: m, loadingState: h } = Po(
    c,
    r
  );
  Oo(f, m, l);
  const { selectedIndex: g } = Ju(
    o,
    c,
    f,
    d
  );
  return x(() => (n((v) => ({
    ...v,
    "aria-expanded": !0,
    "aria-controls": "bn-suggestion-menu"
  })), () => {
    n((v) => ({
      ...v,
      "aria-expanded": !1,
      "aria-controls": void 0
    }));
  }), [n]), x(() => (n((v) => ({
    ...v,
    "aria-activedescendant": g ? "bn-suggestion-menu-item-" + g : void 0
  })), () => {
    n((v) => ({
      ...v,
      "aria-activedescendant": void 0
    }));
  }), [n, g]), /* @__PURE__ */ a(
    i,
    {
      items: f,
      onItemClick: d,
      loadingState: h,
      selectedIndex: g
    }
  );
}
const Qu = {
  heading_1: pt,
  heading_2: gt,
  heading_3: bt,
  heading_4: Jn,
  heading_5: Yn,
  heading_6: Qn,
  toggle_heading_1: pt,
  toggle_heading_2: gt,
  toggle_heading_3: bt,
  quote: ro,
  toggle_list: co,
  numbered_list: no,
  bullet_list: oo,
  check_list: to,
  paragraph: It,
  table: Ii,
  image: io,
  video: zi,
  audio: lo,
  file: Zt,
  emoji: Gi,
  code_block: Si,
  divider: Ui
};
function ed(e) {
  return rr(e).map((t) => {
    const n = Qu[t.key];
    return {
      ...t,
      icon: /* @__PURE__ */ a(n, { size: 18 })
    };
  });
}
function td(e) {
  var g;
  const t = C(), {
    triggerCharacter: n,
    suggestionMenuComponent: o,
    minQueryLength: r,
    onItemClick: i,
    getItems: c
  } = e, s = T(() => i || ((b) => {
    b.onItemClick(t);
  }), [t, i]), l = T(() => c || (async (b) => ir(
    ed(t),
    b
  )), [t, c]), u = Z(re);
  x(() => {
    u.addTriggerCharacter(n);
  }, [u, n]);
  const d = L(re), f = L(re, {
    selector: (b) => (b == null ? void 0 : b.referencePos) || new DOMRect()
  }), m = T(
    () => {
      var b;
      return {
        // Use first child as the editor DOM element may itself be scrollable.
        // For FloatingUI to auto-update the position during scrolling, the
        // `contextElement` must be a descendant of the scroll container.
        element: ((b = t.domElement) == null ? void 0 : b.firstChild) || void 0,
        getBoundingClientRect: () => f
      };
    },
    [(g = t.domElement) == null ? void 0 : g.firstChild, f]
  ), h = T(
    () => ({
      useFloatingOptions: {
        open: (d == null ? void 0 : d.show) && (d == null ? void 0 : d.triggerCharacter) === n,
        onOpenChange: (b) => {
          b || u.closeMenu();
        },
        placement: "bottom-start",
        middleware: [
          ee(10),
          // Flips the menu placement to maximize the space available, and prevents
          // the menu from being cut off by the confines of the screen.
          ue({
            mainAxis: !0,
            crossAxis: !1
          }),
          Te(),
          we({
            apply({ availableHeight: b, elements: v }) {
              Object.assign(v.floating.style, {
                maxHeight: `${b - 10}px`,
                minHeight: "300px"
              });
            }
          })
        ]
      },
      elementProps: {
        // Prevents editor blurring when clicking the scroll bar.
        onMouseDownCapture: (b) => b.preventDefault(),
        style: {
          zIndex: 80
        }
      },
      ...e.floatingUIOptions
    }),
    [
      e.floatingUIOptions,
      d == null ? void 0 : d.show,
      d == null ? void 0 : d.triggerCharacter,
      u,
      n
    ]
  );
  return !d || !d.ignoreQueryLength && r && (d.query.startsWith(" ") || d.query.length < r) ? null : /* @__PURE__ */ a(Q, { reference: m, ...h, children: n && /* @__PURE__ */ a(
    Yu,
    {
      query: d.query,
      closeMenu: u.closeMenu,
      clearQuery: u.clearQuery,
      getItems: l,
      suggestionMenuComponent: o || Ku,
      onItemClick: s
    }
  ) });
}
const nd = (e, t = 0.3) => {
  const n = Math.floor(e) + t, o = Math.ceil(e) - t;
  return e >= n && e <= o ? Math.round(e) : e < n ? Math.floor(e) : Math.ceil(e);
}, od = (e) => {
  const t = _(), n = C(), o = Z(O), r = L(O, {
    selector: (d) => d == null ? void 0 : d.block
  }), i = q(!1), [c, s] = V(), l = y(
    (d) => {
      o.freezeHandles(), e.hideOtherElements(!0), r && (s({
        originalContent: r.content,
        originalCroppedContent: {
          rows: o.cropEmptyRowsOrColumns(
            r,
            e.orientation === "addOrRemoveColumns" ? "columns" : "rows"
          )
        },
        startPos: e.orientation === "addOrRemoveColumns" ? d.clientX : d.clientY
      }), i.current = !1, d.preventDefault());
    },
    [r, e, o]
  ), u = y(() => {
    !r || i.current || n.updateBlock(r, {
      type: "table",
      content: {
        ...r.content,
        rows: e.orientation === "addOrRemoveColumns" ? o.addRowsOrColumns(r, "columns", 1) : o.addRowsOrColumns(r, "rows", 1)
      }
    });
  }, [r, n, e.orientation, o]);
  return x(() => {
    const d = (f) => {
      var S, $;
      if (!r)
        return;
      if (!c)
        throw new Error("editingState is undefined");
      i.current = !0;
      const m = (e.orientation === "addOrRemoveColumns" ? f.clientX : f.clientY) - c.startPos, h = e.orientation === "addOrRemoveColumns" ? ((S = c.originalCroppedContent.rows[0]) == null ? void 0 : S.cells.length) ?? 0 : c.originalCroppedContent.rows.length, g = e.orientation === "addOrRemoveColumns" ? (($ = c.originalContent.rows[0]) == null ? void 0 : $.cells.length) ?? 0 : c.originalContent.rows.length, b = e.orientation === "addOrRemoveColumns" ? r.content.rows[0].cells.length : r.content.rows.length, v = g + nd(
        m / (e.orientation === "addOrRemoveColumns" ? pr : gr),
        0.3
      );
      v >= h && v > 0 && v !== b && (n.updateBlock(r, {
        type: "table",
        content: {
          ...r.content,
          rows: e.orientation === "addOrRemoveColumns" ? o.addRowsOrColumns(
            {
              type: "table",
              content: c.originalCroppedContent
            },
            "columns",
            v - h
          ) : o.addRowsOrColumns(
            {
              type: "table",
              content: c.originalCroppedContent
            },
            "rows",
            v - h
          )
        }
      }), r.content && n.setTextCursorPosition(r));
    };
    return c && window.addEventListener("mousemove", d), () => {
      window.removeEventListener("mousemove", d);
    };
  }, [r, c, n, e.orientation, o]), x(() => {
    const d = () => {
      e.hideOtherElements(!1), o.unfreezeHandles(), s(void 0);
    };
    return c && window.addEventListener("mouseup", d), () => {
      window.removeEventListener("mouseup", d);
    };
  }, [c, e, o]), n.isEditable ? /* @__PURE__ */ a(
    t.TableHandle.ExtendButton,
    {
      className: G(
        "bn-extend-button",
        e.orientation === "addOrRemoveColumns" ? "bn-extend-button-add-remove-columns" : "bn-extend-button-add-remove-rows",
        c !== null ? "bn-extend-button-editing" : ""
      ),
      onClick: u,
      onMouseDown: l,
      children: e.children || /* @__PURE__ */ a(Pi, { size: 18, "data-test": "extendButton" })
    }
  ) : null;
}, Mn = (e) => {
  const t = _(), n = H(), o = Z(O), r = L(O, {
    selector: (i) => e.orientation === "column" ? i == null ? void 0 : i.colIndex : i == null ? void 0 : i.rowIndex
  });
  return o === void 0 || r === void 0 ? null : /* @__PURE__ */ a(
    t.Generic.Menu.Item,
    {
      onClick: () => {
        o.addRowOrColumn(
          r,
          e.orientation === "row" ? { orientation: "row", side: e.side } : { orientation: "column", side: e.side }
        );
      },
      children: n.table_handle[`add_${e.side}_menuitem`]
    }
  );
}, rd = (e) => {
  const t = _(), n = H(), o = Z(O), r = L(O, {
    selector: (i) => e.orientation === "column" ? i == null ? void 0 : i.colIndex : i == null ? void 0 : i.rowIndex
  });
  return o === void 0 || r === void 0 ? null : /* @__PURE__ */ a(
    t.Generic.Menu.Item,
    {
      onClick: () => o.removeRowOrColumn(r, e.orientation),
      children: e.orientation === "row" ? n.table_handle.delete_row_menuitem : n.table_handle.delete_column_menuitem
    }
  );
}, id = (e) => {
  const t = _(), n = H(), o = C(), r = Z(O), { block: i, index: c } = L(O, {
    selector: (d) => ({
      block: d == null ? void 0 : d.block,
      index: e.orientation === "column" ? d == null ? void 0 : d.colIndex : d == null ? void 0 : d.rowIndex
    })
  }), s = T(() => r === void 0 || i === void 0 || c === void 0 ? [] : e.orientation === "row" ? r.getCellsAtRowHandle(i, c) : r.getCellsAtColumnHandle(i, c), [i, c, e.orientation, r]), l = (d, f) => {
    if (i === void 0)
      return;
    const m = i.content.rows.map((h) => ({
      ...h,
      cells: h.cells.map((g) => ke(g))
    }));
    s.forEach(({ row: h, col: g }) => {
      f === "text" ? m[h].cells[g].props.textColor = d : m[h].cells[g].props.backgroundColor = d;
    }), o.updateBlock(i, {
      type: "table",
      content: {
        ...i.content,
        rows: m
      }
    }), o.setTextCursorPosition(i);
  };
  if (!s || !s[0] || !r || o.settings.tables.cellTextColor === !1 && o.settings.tables.cellBackgroundColor === !1)
    return null;
  const u = ke(s[0].cell);
  return /* @__PURE__ */ E(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ a(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ a(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children || n.drag_handle.colors_menuitem
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ a(
          qe,
          {
            iconSize: 18,
            text: o.settings.tables.cellTextColor ? {
              // All cells have the same text color
              color: s.every(
                ({ cell: d }) => ye(d) && d.props.textColor === u.props.textColor
              ) ? u.props.textColor : "default",
              setColor: (d) => {
                l(d, "text");
              }
            } : void 0,
            background: o.settings.tables.cellBackgroundColor ? {
              color: s.every(
                ({ cell: d }) => ye(d) && d.props.backgroundColor === u.props.backgroundColor
              ) ? u.props.backgroundColor : "default",
              setColor: (d) => l(d, "background")
            } : void 0
          }
        )
      }
    )
  ] });
}, cd = (e) => {
  const t = _(), n = H(), o = C(), r = Z(O), { block: i, index: c } = L(O, {
    selector: (l) => ({
      block: l == null ? void 0 : l.block,
      index: e.orientation === "column" ? l == null ? void 0 : l.colIndex : l == null ? void 0 : l.rowIndex
    })
  });
  if (r === void 0 || i === void 0 || c !== 0 || e.orientation !== "row" || !o.settings.tables.headers)
    return null;
  const s = !!i.content.headerRows;
  return /* @__PURE__ */ a(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: s,
      onClick: () => {
        o.updateBlock(i, {
          ...i,
          content: {
            ...i.content,
            headerRows: s ? void 0 : 1
          }
        });
      },
      children: n.drag_handle.header_row_menuitem
    }
  );
}, ld = (e) => {
  const t = _(), n = H(), o = C(), r = Z(O), i = L(O, {
    selector: (l) => l == null ? void 0 : l.block
  }), c = L(O, {
    selector: (l) => e.orientation === "column" ? l == null ? void 0 : l.colIndex : l == null ? void 0 : l.rowIndex
  });
  if (!r || c !== 0 || !i || e.orientation !== "column" || !o.settings.tables.headers)
    return null;
  const s = !!i.content.headerCols;
  return /* @__PURE__ */ a(
    t.Generic.Menu.Item,
    {
      className: "bn-menu-item",
      checked: s,
      onClick: () => {
        o.updateBlock(i, {
          ...i,
          content: {
            ...i.content,
            headerCols: s ? void 0 : 1
          }
        });
      },
      children: n.drag_handle.header_column_menuitem
    }
  );
}, sd = (e) => {
  const t = _();
  return /* @__PURE__ */ a(t.Generic.Menu.Dropdown, { className: "bn-table-handle-menu", children: e.children || /* @__PURE__ */ E(j, { children: [
    /* @__PURE__ */ a(rd, { orientation: e.orientation }),
    /* @__PURE__ */ a(
      Mn,
      {
        orientation: e.orientation,
        side: e.orientation === "row" ? "above" : "left"
      }
    ),
    /* @__PURE__ */ a(
      Mn,
      {
        orientation: e.orientation,
        side: e.orientation === "row" ? "below" : "right"
      }
    ),
    /* @__PURE__ */ a(cd, { orientation: e.orientation }),
    /* @__PURE__ */ a(ld, { orientation: e.orientation }),
    /* @__PURE__ */ a(id, { orientation: e.orientation })
  ] }) });
}, ad = (e) => {
  const t = C(), n = _(), [o, r] = V(!1), i = e.tableHandleMenu || sd, c = Z(O), s = L(O), l = T(() => !c || !s || !s.block || s.block.type !== "table" ? !1 : e.orientation === "column" ? c.getCellsAtColumnHandle(s.block, s.colIndex).every(({ cell: u }) => On(u) === 1) : c.getCellsAtRowHandle(s.block, s.rowIndex).every(({ cell: u }) => Pn(u) === 1), [e.orientation, s, c]);
  return s ? /* @__PURE__ */ E(
    n.Generic.Menu.Root,
    {
      onOpenChange: (u) => {
        u ? (c.freezeHandles(), e.hideOtherElements(!0)) : (c.unfreezeHandles(), e.hideOtherElements(!1), t.focus());
      },
      position: "right",
      children: [
        /* @__PURE__ */ a(n.Generic.Menu.Trigger, { children: /* @__PURE__ */ a(
          n.TableHandle.Root,
          {
            className: G(
              "bn-table-handle",
              o ? "bn-table-handle-dragging" : "",
              l ? "" : "bn-table-handle-not-draggable"
            ),
            draggable: l,
            onDragStart: (u) => {
              r(!0), e.hideOtherElements(!0), e.orientation === "column" ? c.colDragStart(u) : c.rowDragStart(u);
            },
            onDragEnd: () => {
              c.dragEnd(), e.hideOtherElements(!1), r(!1);
            },
            style: e.orientation === "column" ? { transform: "rotate(0.25turn)" } : void 0,
            children: e.children || /* @__PURE__ */ a(Bo, { size: 24, "data-test": "tableHandle" })
          }
        ) }),
        /* @__PURE__ */ a(i, { orientation: e.orientation })
      ]
    }
  ) : null;
}, ud = (e) => {
  var u, d;
  const t = _(), n = H(), o = C(), { block: r, colIndex: i, rowIndex: c } = L(
    O,
    {
      selector: (f) => ({
        block: f == null ? void 0 : f.block,
        colIndex: f == null ? void 0 : f.colIndex,
        rowIndex: f == null ? void 0 : f.rowIndex
      })
    }
  ), s = (f, m) => {
    if (r === void 0 || i === void 0 || c === void 0)
      return;
    const h = r.content.rows.map((g) => ({
      ...g,
      cells: g.cells.map((b) => ke(b))
    }));
    m === "text" ? h[c].cells[i].props.textColor = f : h[c].cells[i].props.backgroundColor = f, o.updateBlock(r, {
      type: "table",
      content: {
        ...r.content,
        rows: h
      }
    }), o.setTextCursorPosition(r);
  };
  if (r === void 0 || i === void 0 || c === void 0)
    return null;
  const l = (d = (u = r.content.rows[c]) == null ? void 0 : u.cells) == null ? void 0 : d[i];
  return !l || o.settings.tables.cellTextColor === !1 && o.settings.tables.cellBackgroundColor === !1 ? null : /* @__PURE__ */ E(t.Generic.Menu.Root, { position: "right", sub: !0, children: [
    /* @__PURE__ */ a(t.Generic.Menu.Trigger, { sub: !0, children: /* @__PURE__ */ a(
      t.Generic.Menu.Item,
      {
        className: "bn-menu-item",
        subTrigger: !0,
        children: e.children || n.drag_handle.colors_menuitem
      }
    ) }),
    /* @__PURE__ */ a(
      t.Generic.Menu.Dropdown,
      {
        sub: !0,
        className: "bn-menu-dropdown bn-color-picker-dropdown",
        children: /* @__PURE__ */ a(
          qe,
          {
            iconSize: 18,
            text: o.settings.tables.cellTextColor ? {
              color: ye(l) ? l.props.textColor : "default",
              setColor: (f) => s(f, "text")
            } : void 0,
            background: o.settings.tables.cellBackgroundColor ? {
              color: ye(l) ? l.props.backgroundColor : "default",
              setColor: (f) => s(f, "background")
            } : void 0
          }
        )
      }
    )
  ] });
}, dd = () => {
  var l, u;
  const e = _(), t = H(), n = C(), o = Z(O), { block: r, colIndex: i, rowIndex: c } = L(
    O,
    {
      selector: (d) => ({
        block: d == null ? void 0 : d.block,
        colIndex: d == null ? void 0 : d.colIndex,
        rowIndex: d == null ? void 0 : d.rowIndex
      })
    }
  );
  if (r === void 0 || i === void 0 || c === void 0)
    return null;
  const s = (u = (l = r.content.rows[c]) == null ? void 0 : l.cells) == null ? void 0 : u[i];
  return !s || !ye(s) || Pn(s) === 1 && On(s) === 1 || !n.settings.tables.splitCells ? null : /* @__PURE__ */ a(
    e.Generic.Menu.Item,
    {
      onClick: () => {
        o.splitCell({
          row: c,
          col: i
        });
      },
      children: t.table_handle.split_cell_menuitem
    }
  );
}, fd = (e) => {
  const t = _();
  return /* @__PURE__ */ a(
    t.Generic.Menu.Dropdown,
    {
      className: "bn-menu-dropdown bn-table-handle-menu",
      children: e.children || /* @__PURE__ */ E(j, { children: [
        /* @__PURE__ */ a(dd, {}),
        /* @__PURE__ */ a(ud, {})
      ] })
    }
  );
}, md = (e) => {
  const t = _(), n = C(), o = Z(O), r = e.tableCellMenu || fd;
  return !n.settings.tables.splitCells && !n.settings.tables.cellBackgroundColor && !n.settings.tables.cellTextColor ? null : /* @__PURE__ */ E(
    t.Generic.Menu.Root,
    {
      onOpenChange: (i) => {
        i ? (o.freezeHandles(), e.hideOtherElements(!0)) : (o.unfreezeHandles(), e.hideOtherElements(!1), n.focus());
      },
      position: "right",
      children: [
        /* @__PURE__ */ a(t.Generic.Menu.Trigger, { children: /* @__PURE__ */ a(t.Generic.Menu.Button, { className: "bn-table-cell-handle", children: e.children || /* @__PURE__ */ a(zu, { size: 12, "data-test": "tableCellHandle" }) }) }),
        /* @__PURE__ */ a(r, {})
      ]
    }
  );
}, hd = (e) => {
  const t = C(), [n, o] = V(), r = L(O), i = T(() => {
    if (r === void 0 || r.rowIndex === void 0 || r.colIndex === void 0)
      return {};
    const u = Ht(
      r.block.id,
      t.prosemirrorState.doc
    );
    if (!u)
      return {};
    const d = u.posBeforeNode + 1, f = t.prosemirrorView.domAtPos(
      d + 1
    ).node;
    if (!(f instanceof Element))
      return {};
    const m = { element: f }, h = t.prosemirrorState.doc.resolve(d + 1).posAtIndex(r.rowIndex), g = t.prosemirrorState.doc.resolve(h + 1).posAtIndex(r.colIndex), b = t.prosemirrorView.domAtPos(g + 1).node;
    return b instanceof Element ? {
      tableReference: m,
      cellReference: { element: b },
      rowReference: {
        element: f,
        getBoundingClientRect: () => {
          const I = f.getBoundingClientRect(), M = b.getBoundingClientRect();
          return new DOMRect(
            I.x,
            r.draggingState && r.draggingState.draggedCellOrientation === "row" ? r.draggingState.mousePos - M.height / 2 : M.y,
            I.width,
            M.height
          );
        }
      },
      columnReference: {
        element: f,
        getBoundingClientRect: () => {
          const I = f.getBoundingClientRect(), M = b.getBoundingClientRect();
          return new DOMRect(
            r.draggingState && r.draggingState.draggedCellOrientation === "col" ? r.draggingState.mousePos - M.width / 2 : M.x,
            I.y,
            M.width,
            I.height
          );
        }
      }
    } : {};
  }, [t, r]);
  if (!r)
    return null;
  const c = e.tableHandle || ad, s = e.extendButton || od, l = e.tableCellHandle || md;
  return /* @__PURE__ */ E(j, { children: [
    /* @__PURE__ */ a(
      Q,
      {
        reference: i == null ? void 0 : i.rowReference,
        useFloatingOptions: {
          open: r.show && r.rowIndex !== void 0 && (!n || n === "rowTableHandle"),
          placement: "left",
          middleware: [ee(-10)]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.rowIndex !== void 0 && (!n || n === "rowTableHandle") && /* @__PURE__ */ a(
          c,
          {
            orientation: "row",
            hideOtherElements: (u) => o(u ? "rowTableHandle" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ a(
      Q,
      {
        reference: i == null ? void 0 : i.columnReference,
        useFloatingOptions: {
          open: r.show && r.colIndex !== void 0 && (!n || n === "columnTableHandle"),
          placement: "top",
          middleware: [ee(-12)]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.colIndex !== void 0 && (!n || n === "columnTableHandle") && /* @__PURE__ */ a(
          c,
          {
            orientation: "column",
            hideOtherElements: (u) => o(u ? "columnTableHandle" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ a(
      Q,
      {
        reference: i == null ? void 0 : i.cellReference,
        useFloatingOptions: {
          open: r.show && r.rowIndex !== void 0 && r.colIndex !== void 0 && (!n || n === "tableCellHandle"),
          placement: "top-end",
          middleware: [ee({ mainAxis: -15, crossAxis: -1 })]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.rowIndex !== void 0 && r.colIndex !== void 0 && (!n || n === "tableCellHandle") && /* @__PURE__ */ a(
          l,
          {
            hideOtherElements: (u) => o(u ? "tableCellHandle" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ a(
      Q,
      {
        reference: i == null ? void 0 : i.tableReference,
        useFloatingOptions: {
          open: r.show && r.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton"),
          placement: "bottom",
          middleware: [
            we({
              apply({ rects: u, elements: d }) {
                Object.assign(d.floating.style, {
                  width: `${u.reference.width}px`
                });
              }
            })
          ]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.showAddOrRemoveRowsButton && (!n || n === "extendRowsButton") && /* @__PURE__ */ a(
          s,
          {
            orientation: "addOrRemoveRows",
            hideOtherElements: (u) => o(u ? "extendRowsButton" : void 0)
          }
        )
      }
    ),
    /* @__PURE__ */ a(
      Q,
      {
        reference: i == null ? void 0 : i.tableReference,
        useFloatingOptions: {
          open: r.show && r.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton"),
          placement: "right",
          middleware: [
            we({
              apply({ rects: u, elements: d }) {
                Object.assign(d.floating.style, {
                  height: `${u.reference.height}px`
                });
              }
            })
          ]
        },
        elementProps: {
          style: {
            zIndex: 10
          }
        },
        children: r.show && r.showAddOrRemoveColumnsButton && (!n || n === "extendColumnsButton") && /* @__PURE__ */ a(
          s,
          {
            orientation: "addOrRemoveColumns",
            hideOtherElements: (u) => o(u ? "extendColumnsButton" : void 0)
          }
        )
      }
    )
  ] });
}, pd = Rn(
  () => Promise.resolve().then(() => o1)
), gd = Rn(
  () => Promise.resolve().then(() => i1)
);
function bd(e) {
  const t = C();
  if (!t)
    throw new Error(
      "BlockNoteDefaultUI must be used within a BlockNoteContext.Provider"
    );
  return /* @__PURE__ */ E(j, { children: [
    t.getExtension(be) && e.formattingToolbar !== !1 && /* @__PURE__ */ a(xu, {}),
    t.getExtension(We) && e.linkToolbar !== !1 && /* @__PURE__ */ a(Zu, {}),
    t.getExtension(re) && e.slashMenu !== !1 && /* @__PURE__ */ a(td, { triggerCharacter: "/" }),
    t.getExtension(re) && e.emojiPicker !== !1 && /* @__PURE__ */ a(
      Wu,
      {
        triggerCharacter: ":",
        columns: 10,
        minQueryLength: 2
      }
    ),
    t.getExtension(te) && e.sideMenu !== !1 && /* @__PURE__ */ a(Du, {}),
    t.getExtension(Ne) && e.filePanel !== !1 && /* @__PURE__ */ a(Yr, {}),
    t.getExtension(O) && e.tableHandles !== !1 && /* @__PURE__ */ a(hd, {}),
    t.getExtension(X) && e.comments !== !1 && /* @__PURE__ */ E(Xo, { children: [
      /* @__PURE__ */ a(pd, {}),
      /* @__PURE__ */ a(gd, {})
    ] })
  ] });
}
function vd(e, t) {
  const n = ne();
  t || (t = n == null ? void 0 : n.editor), x(() => {
    if (!t)
      throw new Error(
        "'editor' is required, either from BlockNoteContext or as a function argument"
      );
    return t.onChange(e);
  }, [e, t]);
}
function Cd(e, t, n) {
  const o = ne();
  t || (t = o == null ? void 0 : o.editor), x(() => {
    if (!t)
      throw new Error(
        "'editor' is required, either from BlockNoteContext or as a function argument"
      );
    return t.onSelectionChange(e, n);
  }, [e, t, n]);
}
const _d = () => {
  const e = T(
    () => {
      var c;
      return (c = window.matchMedia) == null ? void 0 : c.call(window, "(prefers-color-scheme: dark)");
    },
    []
  ), t = T(
    () => {
      var c;
      return (c = window.matchMedia) == null ? void 0 : c.call(window, "(prefers-color-scheme: light)");
    },
    []
  ), n = e == null ? void 0 : e.matches, o = t == null ? void 0 : t.matches, [r, i] = V(n ? "dark" : o ? "light" : "no-preference");
  return x(() => {
    i(n ? "dark" : o ? "light" : "no-preference");
  }, [n, o]), x(() => {
    if (typeof (e == null ? void 0 : e.addEventListener) == "function") {
      const c = ({ matches: l }) => l && i("dark"), s = ({ matches: l }) => l && i("light");
      return e == null || e.addEventListener("change", c), t == null || t.addEventListener("change", s), () => {
        e == null || e.removeEventListener("change", c), t == null || t.removeEventListener("change", s);
      };
    } else {
      const c = () => i(
        e.matches ? "dark" : t.matches ? "light" : "no-preference"
      );
      return e == null || e.addEventListener("change", c), t == null || t.addEventListener("change", c), () => {
        e == null || e.removeEventListener("change", c), t == null || t.removeEventListener("change", c);
      };
    }
  }, [e, t]), typeof window.matchMedia != "function", r;
}, No = St(void 0);
function wd() {
  return Ge(No);
}
function kd() {
  const e = /* @__PURE__ */ new Set();
  let t = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return e.add(n), () => {
        e.delete(n);
      };
    },
    getSnapshot() {
      return t;
    },
    getServerSnapshot() {
      return t;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, o) {
      t = {
        ...t,
        [n]: Vt(o.reactElement, o.element, n)
      }, e.forEach((r) => r());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const o = { ...t };
      delete o[n], t = o, e.forEach((r) => r());
    }
  };
}
const yd = ({
  contentComponent: e
}) => {
  const t = Et(
    e.subscribe,
    e.getSnapshot,
    e.getServerSnapshot
  );
  return /* @__PURE__ */ a(j, { children: Object.values(t) });
}, Sd = Jo((e, t) => {
  const [n, o] = V();
  return Yo(t, () => (r, i) => {
    An(() => {
      o({ node: r, container: i });
    }), o(void 0);
  }, []), /* @__PURE__ */ a(j, { children: n && Vt(n.node, n.container) });
}), Zn = () => {
};
function Ed(e, t) {
  const {
    editor: n,
    className: o,
    theme: r,
    children: i,
    editable: c,
    onSelectionChange: s,
    onChange: l,
    formattingToolbar: u,
    linkToolbar: d,
    slashMenu: f,
    emojiPicker: m,
    sideMenu: h,
    filePanel: g,
    tableHandles: b,
    comments: v,
    autoFocus: S,
    renderEditor: $ = !0,
    ...I
  } = e, [M, U] = V(), z = ne(), F = _d(), oe = (z == null ? void 0 : z.colorSchemePreference) || F, _e = r || (oe === "dark" ? "dark" : "light");
  vd(l || Zn, n), Cd(s || Zn, n), x(() => {
    n.isEditable = c !== !1;
  }, [c, n]);
  const Y = y(
    (Uo) => {
      n.elementRenderer = Uo;
    },
    [n]
  ), me = T(() => ({
    ...z,
    editor: n,
    setContentEditableProps: U,
    colorSchemePreference: _e
  }), [z, n, _e]), jo = T(() => ({
    editorProps: {
      autoFocus: S,
      contentEditableProps: M
    },
    defaultUIProps: {
      formattingToolbar: u,
      linkToolbar: d,
      slashMenu: f,
      emojiPicker: m,
      sideMenu: h,
      filePanel: g,
      tableHandles: b,
      comments: v
    }
  }), [
    S,
    M,
    u,
    d,
    f,
    m,
    h,
    g,
    b,
    v
  ]);
  return /* @__PURE__ */ a(jn.Provider, { value: me, children: /* @__PURE__ */ E(No.Provider, { value: jo, children: [
    /* @__PURE__ */ a(Sd, { ref: Y }),
    /* @__PURE__ */ a(
      xd,
      {
        className: o,
        renderEditor: $,
        editable: c,
        editorColorScheme: _e,
        ref: t,
        ...I,
        children: i
      }
    )
  ] }) });
}
const xd = W.forwardRef(
  ({ className: e, renderEditor: t, editable: n, editorColorScheme: o, children: r, ...i }, c) => /* @__PURE__ */ a(
    "div",
    {
      className: G("bn-container", o, e),
      "data-color-scheme": o,
      ...i,
      ref: c,
      children: t ? /* @__PURE__ */ a(Td, { editable: n, children: r }) : r
    }
  )
), w1 = W.forwardRef(Ed), Td = (e) => {
  const t = wd(), n = C(), o = T(() => kd(), []), r = y(
    (i) => {
      e.editable !== void 0 && e.editable !== n.isEditable && (n.isEditable = e.editable), n._tiptapEditor.contentComponent = o, i ? n.mount(i) : n.unmount();
    },
    [n, o, e.editable]
  );
  return /* @__PURE__ */ E(j, { children: [
    /* @__PURE__ */ a(yd, { contentComponent: o }),
    /* @__PURE__ */ a(Hd, { ...t.editorProps, ...e, mount: r }),
    /* @__PURE__ */ a(bd, { ...t.defaultUIProps }),
    e.children
  ] });
}, Hd = (e) => {
  const { autoFocus: t, mount: n, contentEditableProps: o } = e;
  return /* @__PURE__ */ a(
    "div",
    {
      "aria-autocomplete": "list",
      "aria-haspopup": "listbox",
      "data-bn-autofocus": t,
      ref: n,
      ...o
    }
  );
};
function ie(e, t) {
  let n;
  const o = document.createElement("div");
  let r;
  if (t != null && t.elementRenderer)
    t.elementRenderer(
      e((l) => n = l || void 0),
      o
    );
  else {
    if (!(t != null && t.headless))
      throw new Error(
        "elementRenderer not available, expected headless editor"
      );
    r = Wr(o), An(() => {
      r.render(e((l) => n = l || void 0));
    });
  }
  if (!o.childElementCount)
    return console.warn("ReactInlineContentSpec: renderHTML() failed"), {
      dom: document.createElement("span")
    };
  n == null || n.setAttribute("data-tmp-find", "true");
  const i = o.cloneNode(!0), c = i.firstElementChild, s = i.querySelector(
    "[data-tmp-find]"
  );
  return s == null || s.removeAttribute("data-tmp-find"), r == null || r.unmount(), {
    dom: c,
    contentDOM: s || void 0
  };
}
function dt(e) {
  var t;
  return (
    // Creates `blockContent` element
    /* @__PURE__ */ a(
      Fn,
      {
        onDragOver: (n) => n.preventDefault(),
        ...Object.fromEntries(
          Object.entries(e.domAttributes || {}).filter(
            ([n]) => n !== "class"
          )
        ),
        className: G(
          "bn-block-content",
          ((t = e.domAttributes) == null ? void 0 : t.class) || ""
        ),
        "data-content-type": e.blockType,
        ...Object.fromEntries(
          Object.entries(e.blockProps).filter(([n, o]) => {
            const r = e.propSchema._zodSource._zod.def.shape[n], i = r instanceof At ? r._zod.def.defaultValue : void 0;
            return o !== i;
          }).map(([n, o]) => typeof o == "object" ? [Ae(n), JSON.stringify(o)] : [Ae(n), o])
        ),
        "data-file-block": e.isFileBlock === !0 || void 0,
        children: e.children
      }
    )
  );
}
function tt(e, t, n) {
  return (o = {}) => {
    const r = typeof e == "function" ? e(o) : e, i = typeof t == "function" ? t(o) : t, c = n ? typeof n == "function" ? n(o) : n : void 0;
    return {
      config: r,
      implementation: {
        ...i,
        toExternalHTML(s, l) {
          const u = i.toExternalHTML || i.render;
          return ie((f) => /* @__PURE__ */ a(
            dt,
            {
              blockType: s.type,
              blockProps: s.props,
              propSchema: r.propSchema,
              domAttributes: this.blockContentDOMAttributes,
              children: /* @__PURE__ */ a(
                u,
                {
                  block: s,
                  editor: l,
                  contentRef: (m) => {
                    f(m), m && (m.className = G(
                      "bn-inline-content",
                      m.className
                    ));
                  }
                }
              )
            }
          ), l);
        },
        render(s, l) {
          if (this.renderType === "nodeView")
            return $n(
              (u) => {
                var h;
                const d = br(u.getPos, l, u.editor, r.type), f = Dn().nodeViewContentRef;
                if (!f)
                  throw new Error("nodeViewContentRef is not set");
                const m = i.render;
                return /* @__PURE__ */ a(
                  dt,
                  {
                    blockType: d.type,
                    blockProps: d.props,
                    propSchema: r.propSchema,
                    isFileBlock: !!((h = i.meta) != null && h.fileBlockAccept),
                    domAttributes: this.blockContentDOMAttributes,
                    children: /* @__PURE__ */ a(
                      m,
                      {
                        block: d,
                        editor: l,
                        contentRef: (g) => {
                          f(g), g && (g.className = G(
                            "bn-inline-content",
                            g.className
                          ), g.dataset.nodeViewContent = "");
                        }
                      }
                    )
                  }
                );
              },
              {
                className: "bn-react-node-view-renderer"
              }
            )(this.props);
          {
            const u = i.render;
            return ie((f) => /* @__PURE__ */ a(
              dt,
              {
                blockType: s.type,
                blockProps: s.props,
                propSchema: r.propSchema,
                domAttributes: this.blockContentDOMAttributes,
                children: /* @__PURE__ */ a(
                  u,
                  {
                    block: s,
                    editor: l,
                    contentRef: (m) => {
                      f(m), m && (m.className = G(
                        "bn-inline-content",
                        m.className
                      ));
                    }
                  }
                )
              }
            ), l);
          }
        }
      },
      extensions: c
    };
  };
}
function $t(e) {
  const t = C(), [n, o] = V("loading"), [r, i] = V();
  if (x(() => {
    let c = !0;
    return (async () => {
      let s = "";
      o("loading");
      try {
        s = t.resolveFileUrl ? await t.resolveFileUrl(e) : e;
      } catch {
        o("error");
        return;
      }
      c && (o("loaded"), i(s));
    })(), () => {
      c = !1;
    };
  }, [t, e]), n !== "loaded")
    return {
      loadingState: n
    };
  if (!r)
    throw new Error("Finished fetching file but did not get download URL.");
  return {
    loadingState: n,
    downloadUrl: r
  };
}
const Dt = (e) => /* @__PURE__ */ E("figure", { children: [
  e.children,
  /* @__PURE__ */ a("figcaption", { children: e.caption })
] });
function Vd(e) {
  const t = C();
  x(() => t.onUploadEnd(e), [e, t]);
}
function Md(e) {
  const t = C();
  x(() => t.onUploadStart(e), [e, t]);
}
function Ao(e) {
  const [t, n] = V(!1);
  return Md((o) => {
    o === e && n(!0);
  }), Vd((o) => {
    o === e && n(!1);
  }), t;
}
xe.extend({
  ...et.pick({ url: !0 }).shape
});
const Zd = (e) => {
  const t = C(), n = H(), o = Z(Ne), r = y(
    (c) => {
      c.preventDefault();
    },
    []
  ), i = y(() => {
    t.isEditable && e.editor.transact(() => o.showMenu(e.block.id));
  }, [t.isEditable, o, e.block.id, e.editor]);
  return /* @__PURE__ */ E(
    "div",
    {
      className: "bn-add-file-button",
      onMouseDown: r,
      onClick: i,
      children: [
        /* @__PURE__ */ a("div", { className: "bn-add-file-button-icon", children: e.buttonIcon || /* @__PURE__ */ a(Zt, { size: 24 }) }),
        /* @__PURE__ */ a("div", { className: "bn-add-file-button-text", children: e.block.type in n.file_blocks.add_button_text ? n.file_blocks.add_button_text[e.block.type] : n.file_blocks.add_button_text.file })
      ]
    }
  );
}, Id = (e) => /* @__PURE__ */ E(
  "div",
  {
    className: "bn-file-name-with-icon",
    contentEditable: !1,
    draggable: !1,
    children: [
      /* @__PURE__ */ a("div", { className: "bn-file-icon", children: /* @__PURE__ */ a(Zt, { size: 24 }) }),
      /* @__PURE__ */ a("p", { className: "bn-file-name", children: e.block.props.name })
    ]
  }
);
xe.extend({
  ...et.pick({ url: !0 }).shape
});
const Ft = (e) => {
  const t = Ao(e.block.id);
  return /* @__PURE__ */ a(
    "div",
    {
      className: "bn-file-block-content-wrapper",
      onMouseEnter: e.onMouseEnter,
      onMouseLeave: e.onMouseLeave,
      style: e.style,
      children: t ? (
        // Show loader while a file is being uploaded.
        /* @__PURE__ */ a("div", { className: "bn-file-loading-preview", children: "Loading..." })
      ) : e.block.props.url === "" ? (
        // Show the add file button if the file has not been uploaded yet.
        /* @__PURE__ */ a(Zd, { ...e })
      ) : (
        // Show the file preview, or the file name and icon.
        /* @__PURE__ */ E(j, { children: [
          e.block.props.showPreview === !1 || !e.children ? (
            // Show file name and icon.
            /* @__PURE__ */ a(Id, { ...e })
          ) : (
            // Show preview.
            e.children
          ),
          e.block.props.caption && // Show the caption if there is one.
          /* @__PURE__ */ a("p", { className: "bn-file-caption", children: e.block.props.caption })
        ] })
      )
    }
  );
}, nt = (e) => /* @__PURE__ */ E("div", { children: [
  e.children,
  /* @__PURE__ */ a("p", { children: e.caption })
] }), Ld = (e) => {
  const t = $t(e.block.props.url);
  return /* @__PURE__ */ a(
    "audio",
    {
      className: "bn-audio",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      controls: !0,
      contentEditable: !1,
      draggable: !1
    }
  );
}, zd = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ a("p", { children: "Add audio" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ a("audio", { src: e.block.props.url }) : /* @__PURE__ */ a("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ a(Dt, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ a(nt, { caption: e.block.props.caption, children: t }) : t;
}, Rd = (e) => /* @__PURE__ */ a(
  Ft,
  {
    ...e,
    buttonIcon: /* @__PURE__ */ a(lo, { size: 24 }),
    children: /* @__PURE__ */ a(Ld, { ...e })
  }
), k1 = tt(
  Cr,
  (e) => ({
    render: Rd,
    parse: vr(e),
    toExternalHTML: zd,
    runsBefore: ["file"]
  })
), y1 = tt(wr, {
  render: (e) => /* @__PURE__ */ a(Ft, { ...e }),
  parse: _r(),
  toExternalHTML: (e) => {
    if (!e.block.props.url)
      return /* @__PURE__ */ a("p", { children: "Add file" });
    const t = /* @__PURE__ */ a("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
    return e.block.props.caption ? /* @__PURE__ */ a(nt, { caption: e.block.props.caption, children: t }) : t;
  }
});
xe.extend({
  ...et.pick({
    url: !0,
    previewWidth: !0,
    showPreview: !0
  }).shape
});
const $o = (e) => {
  const [t, n] = V(void 0), [o, r] = V(
    e.block.props.previewWidth
  ), [i, c] = V(!1), s = q(null);
  x(() => {
    const h = (b) => {
      var I, M;
      let v;
      const S = "touches" in b ? b.touches[0].clientX : b.clientX;
      e.block.props.textAlignment === "center" ? t.handleUsed === "left" ? v = t.initialWidth + (t.initialClientX - S) * 2 : v = t.initialWidth + (S - t.initialClientX) * 2 : t.handleUsed === "left" ? v = t.initialWidth + t.initialClientX - S : v = t.initialWidth + S - t.initialClientX, r(
        Math.min(
          Math.max(v, 64),
          ((M = (I = e.editor.domElement) == null ? void 0 : I.firstElementChild) == null ? void 0 : M.clientWidth) || Number.MAX_VALUE
        )
      );
    }, g = () => {
      n(void 0), e.editor.updateBlock(e.block, {
        props: {
          previewWidth: o
        }
      });
    };
    return t && (window.addEventListener("mousemove", h), window.addEventListener("touchmove", h), window.addEventListener("mouseup", g), window.addEventListener("touchend", g)), () => {
      window.removeEventListener("mousemove", h), window.removeEventListener("touchmove", h), window.removeEventListener("mouseup", g), window.removeEventListener("touchend", g);
    };
  }, [e, t, o]);
  const l = y(() => {
    e.editor.isEditable && c(!0);
  }, [e.editor.isEditable]), u = y(() => {
    c(!1);
  }, []), d = y(
    (h) => {
      h.preventDefault();
      const g = "touches" in h ? h.touches[0].clientX : h.clientX;
      n({
        handleUsed: "left",
        initialWidth: s.current.clientWidth,
        initialClientX: g
      });
    },
    []
  ), f = y(
    (h) => {
      h.preventDefault();
      const g = "touches" in h ? h.touches[0].clientX : h.clientX;
      n({
        handleUsed: "right",
        initialWidth: s.current.clientWidth,
        initialClientX: g
      });
    },
    []
  ), m = Ao(e.block.id);
  return /* @__PURE__ */ a(
    Ft,
    {
      ...e,
      onMouseEnter: l,
      onMouseLeave: u,
      style: e.block.props.url && !m && e.block.props.showPreview ? {
        width: o ? `${o}px` : "fit-content"
      } : void 0,
      children: /* @__PURE__ */ E(
        "div",
        {
          className: "bn-visual-media-wrapper",
          style: { position: "relative" },
          ref: s,
          children: [
            e.children,
            (i || t) && /* @__PURE__ */ E(j, { children: [
              /* @__PURE__ */ a(
                "div",
                {
                  className: "bn-resize-handle",
                  style: { left: "4px" },
                  onMouseDown: d,
                  onTouchStart: d
                }
              ),
              /* @__PURE__ */ a(
                "div",
                {
                  className: "bn-resize-handle",
                  style: { right: "4px" },
                  onMouseDown: f,
                  onTouchStart: f
                }
              )
            ] }),
            t && /* @__PURE__ */ a(
              "div",
              {
                style: {
                  position: "absolute",
                  height: "100%",
                  width: "100%"
                }
              }
            )
          ]
        }
      )
    }
  );
}, Bd = (e) => {
  const t = $t(e.block.props.url);
  return /* @__PURE__ */ a(
    "img",
    {
      className: "bn-visual-media",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      alt: e.block.props.caption || "BlockNote image",
      contentEditable: !1,
      draggable: !1
    }
  );
}, Od = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ a("p", { children: "Add image" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ a(
    "img",
    {
      src: e.block.props.url,
      alt: e.block.props.name || e.block.props.caption || "BlockNote image",
      width: e.block.props.previewWidth
    }
  ) : /* @__PURE__ */ a("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ a(Dt, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ a(nt, { caption: e.block.props.caption, children: t }) : t;
}, Pd = (e) => /* @__PURE__ */ a(
  $o,
  {
    ...e,
    buttonIcon: /* @__PURE__ */ a(io, { size: 24 }),
    children: /* @__PURE__ */ a(Bd, { ...e })
  }
), S1 = tt(
  yr,
  (e) => ({
    render: Pd,
    parse: kr(e),
    toExternalHTML: Od
  })
);
function Nd(e) {
  return w({ attr: { viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round" }, child: [{ tag: "path", attr: { d: "M14 3v4a1 1 0 0 0 1 1h4" }, child: [] }, { tag: "path", attr: { d: "M19 18v1a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-1" }, child: [] }, { tag: "path", attr: { d: "M3 14h3m4.5 0h3m4.5 0h3" }, child: [] }, { tag: "path", attr: { d: "M5 10v-5a2 2 0 0 1 2 -2h7l5 5v2" }, child: [] }] })(e);
}
const Ad = {
  page_break: Nd
};
function E1(e) {
  return Sr(e).map((t) => {
    const n = Ad[t.key];
    return {
      ...t,
      icon: /* @__PURE__ */ a(n, { size: 18 })
    };
  });
}
const $d = (e) => {
  const t = $t(e.block.props.url);
  return /* @__PURE__ */ a(
    "video",
    {
      className: "bn-visual-media",
      src: t.loadingState === "loading" ? e.block.props.url : t.downloadUrl,
      controls: !0,
      contentEditable: !1,
      draggable: !1
    }
  );
}, Dd = (e) => {
  if (!e.block.props.url)
    return /* @__PURE__ */ a("p", { children: "Add video" });
  const t = e.block.props.showPreview ? /* @__PURE__ */ a("video", { src: e.block.props.url }) : /* @__PURE__ */ a("a", { href: e.block.props.url, children: e.block.props.name || e.block.props.url });
  return e.block.props.caption ? e.block.props.showPreview ? /* @__PURE__ */ a(Dt, { caption: e.block.props.caption, children: t }) : /* @__PURE__ */ a(nt, { caption: e.block.props.caption, children: t }) : t;
}, Fd = (e) => /* @__PURE__ */ a(
  $o,
  {
    ...e,
    buttonIcon: /* @__PURE__ */ a(Oi, { size: 24 }),
    children: /* @__PURE__ */ a($d, { ...e })
  }
), x1 = tt(
  xr,
  (e) => ({
    render: Fd,
    parse: Er(e),
    toExternalHTML: Dd
  })
), jd = (e, t) => {
  if (t.type === "toggled")
    return !e;
  if (t.type === "childAdded")
    return !0;
  if (t.type === "lastChildRemoved")
    return !1;
  throw new Nn(t);
}, T1 = (e) => {
  const { block: t, editor: n, children: o, toggledState: r } = e, [i, c] = Qo(
    jd,
    (r || Me).get(t)
  ), s = (f) => {
    (r || Me).set(
      n.getBlock(f),
      !i
    ), c({
      type: "toggled"
    });
  }, l = (f) => {
    (r || Me).set(f, !0), c({
      type: "childAdded"
    });
  }, u = (f) => {
    (r || Me).set(f, !1), c({
      type: "lastChildRemoved"
    });
  }, d = P({
    editor: n,
    selector: ({ editor: f }) => {
      if (!("isToggleable" in t.props) || !t.props.isToggleable)
        return 0;
      const m = f.getBlock(t), h = m.children.length || 0;
      return h > d ? i || l(m) : h === 0 && h < d && i && u(m), h;
    }
  });
  return "isToggleable" in t.props && !t.props.isToggleable ? o : /* @__PURE__ */ E("div", { children: [
    /* @__PURE__ */ E("div", { className: "bn-toggle-wrapper", "data-show-children": i, children: [
      /* @__PURE__ */ a(
        "button",
        {
          className: "bn-toggle-button",
          type: "button",
          onMouseDown: (f) => f.preventDefault(),
          onClick: () => s(n.getBlock(t)),
          children: /* @__PURE__ */ a(
            "svg",
            {
              xmlns: "http://www.w3.org/2000/svg",
              height: "1em",
              viewBox: "0 -960 960 960",
              width: "1em",
              fill: "currentcolor",
              children: /* @__PURE__ */ a("path", { d: "M472-480 332-620q-18-18-18-44t18-44q18-18 44-18t44 18l183 183q9 9 14 21t5 24q0 12-5 24t-14 21L420-252q-18 18-44 18t-44-18q-18-18-18-44t18-44l140-140Z" })
            }
          )
        }
      ),
      o
    ] }),
    n.isEditable && i && d === 0 && /* @__PURE__ */ a(
      "button",
      {
        className: "bn-toggle-add-block-button",
        type: "button",
        onClick: () => {
          const f = n.updateBlock(t, {
            // Single empty block with default type.
            children: [{}]
          });
          n.setTextCursorPosition(f.children[0].id, "end"), n.focus();
        },
        children: n.dictionary.toggle_blocks.add_block_button
      }
    )
  ] });
}, H1 = (e) => {
  const [t, n] = V("none"), o = q(null), r = C(), i = L(be, {
    editor: r
  }), c = T(() => ({
    display: "flex",
    position: "fixed",
    bottom: 0,
    zIndex: "calc(var(--bn-ui-base-z-index) + 40)",
    transform: t
  }), [t]);
  if (x(() => {
    const l = window.visualViewport;
    function u() {
      const d = document.body, f = l.offsetLeft, m = l.height - d.getBoundingClientRect().height + l.offsetTop;
      n(
        `translate(${f}px, ${m}px) scale(${1 / l.scale})`
      );
    }
    return window.visualViewport.addEventListener("scroll", u), window.visualViewport.addEventListener("resize", u), u(), () => {
      window.visualViewport.removeEventListener("scroll", u), window.visualViewport.removeEventListener("resize", u);
    };
  }, []), !i && o.current)
    return /* @__PURE__ */ a(
      "div",
      {
        ref: o,
        style: c,
        dangerouslySetInnerHTML: { __html: o.current.innerHTML }
      }
    );
  const s = e.formattingToolbar || Ro;
  return /* @__PURE__ */ a("div", { ref: o, style: c, children: /* @__PURE__ */ a(s, {}) });
}, V1 = (e) => {
  const { blockId: t, colIndex: n, rowIndex: o, children: r, ...i } = e, c = C(), s = T(() => {
    if (t === void 0 || n === void 0 || o === void 0)
      return;
    const l = Ht(t, c.prosemirrorState.doc);
    if (!l)
      return;
    const u = l.posBeforeNode + 1, d = c.prosemirrorState.doc.resolve(u + 1).posAtIndex(o || 0), f = c.prosemirrorState.doc.resolve(d + 1).posAtIndex(n || 0), { node: m } = c.prosemirrorView.domAtPos(f + 1);
    if (m instanceof Element)
      return m;
  }, [c, t, n, o]);
  return /* @__PURE__ */ a(Q, { reference: s, ...i, children: r });
};
function In(e, t, n) {
  const { refs: o, update: r, context: i, floatingStyles: c } = xt({
    open: t,
    placement: e === "addOrRemoveColumns" ? "right" : "bottom",
    middleware: [
      we({
        apply({ rects: u, elements: d }) {
          Object.assign(
            d.floating.style,
            e === "addOrRemoveColumns" ? {
              height: `${u.reference.height}px`
            } : {
              width: `${u.reference.width}px`
            }
          );
        }
      })
    ]
  }), { isMounted: s, styles: l } = Tt(i);
  return x(() => {
    r();
  }, [n, r]), x(() => {
    n !== null && o.setReference({
      getBoundingClientRect: () => n
    });
  }, [e, n, o]), T(
    () => ({
      isMounted: s,
      ref: o.setFloating,
      style: {
        display: "flex",
        ...l,
        ...c
      }
    }),
    [c, s, o.setFloating, l]
  );
}
function M1(e, t, n) {
  const o = In(
    "addOrRemoveRows",
    t,
    n
  ), r = In(
    "addOrRemoveColumns",
    e,
    n
  );
  return T(
    () => ({
      addOrRemoveRowsButton: o,
      addOrRemoveColumnsButton: r
    }),
    [r, o]
  );
}
function Ud(e, t, n) {
  return n && n.draggedCellOrientation === "row" ? new DOMRect(
    t.x,
    n.mousePos,
    t.width,
    0
  ) : new DOMRect(
    t.x,
    e.y,
    t.width,
    e.height
  );
}
function Gd(e, t, n) {
  return n && n.draggedCellOrientation === "col" ? new DOMRect(
    n.mousePos,
    t.y,
    0,
    t.height
  ) : new DOMRect(
    e.x,
    t.y,
    e.width,
    t.height
  );
}
function Wd(e) {
  return new DOMRect(
    e.x,
    e.y,
    e.width,
    0
  );
}
function ft(e, t, n, o, r) {
  const { refs: i, update: c, context: s, floatingStyles: l } = xt({
    open: t,
    placement: e === "row" ? "left" : e === "col" ? "top" : "bottom-end",
    middleware: [
      ee(
        e === "row" ? -10 : e === "col" ? -12 : { mainAxis: 1, crossAxis: -1 }
      )
    ]
  }), { isMounted: u, styles: d } = Tt(s);
  return x(() => {
    c();
  }, [n, o, c]), x(() => {
    n === null || o === null || // Ignore cell handle when dragging
    r && e === "cell" || i.setReference({
      getBoundingClientRect: () => (e === "row" ? Ud : e === "col" ? Gd : Wd)(n, o, r)
    });
  }, [r, e, n, o, i]), T(
    () => ({
      isMounted: u,
      ref: i.setFloating,
      style: {
        display: "flex",
        ...d,
        ...l
      }
    }),
    [l, u, i.setFloating, d]
  );
}
function Z1(e, t, n, o) {
  const r = ft(
    "row",
    e,
    t,
    n,
    o
  ), i = ft(
    "col",
    e,
    t,
    n,
    o
  ), c = ft(
    "cell",
    e,
    t,
    n,
    o
  );
  return T(
    () => ({
      rowHandle: r,
      colHandle: i,
      cellHandle: c
    }),
    [i, r, c]
  );
}
const jt = (e = {}, t = []) => T(() => {
  const n = Tr.create(e);
  return window && (window.ProseMirror = n._tiptapEditor), n;
}, t), Ut = (e) => {
  const [t, n] = V(!1), o = P({
    editor: e.editor,
    selector: ({ editor: s }) => s.isEmpty
  }), r = _(), i = y(() => {
    n(!0);
  }, []), c = y(() => {
    n(!1);
  }, []);
  return x(() => {
    e.editable && e.autoFocus && e.editor.focus();
  }, [e.autoFocus, e.editable, e.editor]), /* @__PURE__ */ E(j, { children: [
    /* @__PURE__ */ a(
      r.Comments.Editor,
      {
        autoFocus: e.autoFocus,
        className: "bn-comment-editor",
        editor: e.editor,
        onFocus: i,
        onBlur: c,
        editable: e.editable
      }
    ),
    e.actions && /* @__PURE__ */ a("div", { className: "bn-comment-actions-wrapper", children: /* @__PURE__ */ a(e.actions, { isFocused: t, isEmpty: o }) })
  ] });
};
let Pe;
async function Kd() {
  return Pe || (Pe = (async () => {
    const [e, t] = await Promise.all([
      import("emoji-mart"),
      // use a dynamic import to encourage bundle-splitting
      // and a smaller initial client bundle size
      import("@emoji-mart/data")
    ]), n = "default" in e ? e.default : e, o = "default" in t ? t.default : t;
    return await n.init({ data: o }), { emojiMart: n, emojiData: o };
  })(), Pe);
}
function qd(e) {
  const t = q(null), n = q(null);
  return n.current && n.current.update(e), x(() => ((async () => {
    const { emojiMart: o } = await Kd();
    n.current = new o.Picker({ ...e, ref: t });
  })(), () => {
    n.current = null;
  }), []), W.createElement("div", { ref: t });
}
const Ln = (e) => {
  const [t, n] = V(!1), o = _(), r = C(), i = ne();
  return /* @__PURE__ */ E(o.Generic.Popover.Root, { open: t, children: [
    /* @__PURE__ */ a(o.Generic.Popover.Trigger, { children: /* @__PURE__ */ a(
      "div",
      {
        onClick: (c) => {
          var s;
          c.preventDefault(), c.stopPropagation(), n(!t), (s = e.onOpenChange) == null || s.call(e, !t);
        },
        style: {
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        children: e.children
      }
    ) }),
    Vt(
      /* @__PURE__ */ a(
        o.Generic.Popover.Content,
        {
          className: "bn-emoji-picker-popover",
          variant: "panel-popover",
          children: /* @__PURE__ */ a(
            qd,
            {
              perLine: 7,
              onClickOutside: () => {
                var c;
                n(!1), (c = e.onOpenChange) == null || c.call(e, !1);
              },
              onEmojiSelect: (c) => {
                var s;
                e.onEmojiSelect(c), n(!1), (s = e.onOpenChange) == null || s.call(e, !1);
              },
              theme: i == null ? void 0 : i.colorSchemePreference
            }
          )
        }
      ),
      r.domElement.parentElement
    )
  ] });
};
function Xd(e) {
  return Gt([e]).get(e);
}
function Gt(e) {
  const n = Z(X).userStore, o = y(() => {
    const c = /* @__PURE__ */ new Map();
    for (const s of e) {
      const l = n.getUser(s);
      l && c.set(s, l);
    }
    return c;
  }, [n, e]), r = T(() => ({
    current: o()
  }), [o]), i = y(
    (c) => {
      const s = n.subscribe((l) => {
        r.current = o(), c();
      });
      return n.loadUsers(e), s;
    },
    [n, o, e, r]
  );
  return Et(i, () => r.current);
}
const Jd = (e) => {
  const t = _(), n = H(), o = Z(X), r = e.comment.reactions.find(
    (l) => l.emoji === e.emoji
  );
  if (!r)
    throw new Error(
      "Trying to render reaction badge for non-existing reaction"
    );
  const [i, c] = V([]), s = Gt(i);
  return /* @__PURE__ */ a(
    t.Generic.Badge.Root,
    {
      className: G("bn-badge", "bn-comment-reaction"),
      text: r.userIds.length.toString(),
      icon: r.emoji,
      isSelected: o.threadStore.auth.canDeleteReaction(
        e.comment,
        r.emoji
      ),
      onClick: () => e.onReactionSelect(r.emoji),
      onMouseEnter: () => c(r.userIds),
      mainTooltip: n.comments.reactions.reacted_by,
      secondaryTooltip: `${Array.from(s.values()).map((l) => l.username).join(`
`)}`
    },
    r.emoji
  );
}, { textColor: I1, backgroundColor: L1, ...Yd } = Vr, Wt = Hr.create({
  blockSpecs: {
    paragraph: Mr()
  },
  styleSpecs: Yd
}), Qd = ({
  comment: e,
  thread: t,
  showResolveButton: n
}) => {
  const o = Z(X), r = H(), i = jt({
    initialContent: e.body,
    trailingBlock: !1,
    dictionary: {
      ...r,
      placeholders: {
        emptyDocument: r.placeholders.edit_comment
      }
    },
    schema: o.commentEditorSchema || Wt
  }), c = _(), [s, l] = V(!1), [u, d] = V(!1), f = o.threadStore, m = y(() => {
    l(!0);
  }, []), h = y(() => {
    i.replaceBlocks(i.document, e.body), l(!1);
  }, [i, e.body]), g = y(
    async (Y) => {
      await f.updateComment({
        commentId: e.id,
        comment: {
          body: i.document
        },
        threadId: t.id
      }), l(!1);
    },
    [e, t.id, i, f]
  ), b = y(async () => {
    await f.deleteComment({
      commentId: e.id,
      threadId: t.id
    });
  }, [e, t.id, f]), v = y(
    async (Y) => {
      f.auth.canAddReaction(e, Y) ? await f.addReaction({
        threadId: t.id,
        commentId: e.id,
        emoji: Y
      }) : f.auth.canDeleteReaction(e, Y) && await f.deleteReaction({
        threadId: t.id,
        commentId: e.id,
        emoji: Y
      });
    },
    [f, e, t.id]
  ), S = y(async () => {
    await f.resolveThread({
      threadId: t.id
    });
  }, [t.id, f]), $ = y(async () => {
    await f.unresolveThread({
      threadId: t.id
    });
  }, [t.id, f]), I = Xd(e.userId);
  if (!e.body)
    return null;
  let M;
  const U = f.auth.canAddReaction(e), z = f.auth.canDeleteComment(e), F = f.auth.canUpdateComment(e), oe = n && (t.resolved ? f.auth.canUnresolveThread(t) : f.auth.canResolveThread(t));
  s || (M = /* @__PURE__ */ E(
    c.Generic.Toolbar.Root,
    {
      className: G("bn-action-toolbar", "bn-comment-actions"),
      variant: "action-toolbar",
      children: [
        U && /* @__PURE__ */ a(
          Ln,
          {
            onEmojiSelect: (Y) => v(Y.native),
            onOpenChange: d,
            children: /* @__PURE__ */ a(
              c.Generic.Toolbar.Button,
              {
                mainTooltip: r.comments.actions.add_reaction,
                variant: "compact",
                children: /* @__PURE__ */ a(cn, { size: 16 })
              },
              "add-reaction"
            )
          }
        ),
        oe && (t.resolved ? /* @__PURE__ */ a(
          c.Generic.Toolbar.Button,
          {
            mainTooltip: "Re-open",
            variant: "compact",
            onClick: $,
            children: /* @__PURE__ */ a(gi, { size: 16 })
          },
          "reopen"
        ) : /* @__PURE__ */ a(
          c.Generic.Toolbar.Button,
          {
            mainTooltip: r.comments.actions.resolve,
            variant: "compact",
            onClick: S,
            children: /* @__PURE__ */ a(Ni, { size: 16 })
          },
          "resolve"
        )),
        (z || F) && /* @__PURE__ */ E(c.Generic.Menu.Root, { position: "bottom-start", children: [
          /* @__PURE__ */ a(c.Generic.Menu.Trigger, { children: /* @__PURE__ */ a(
            c.Generic.Toolbar.Button,
            {
              mainTooltip: r.comments.actions.more_actions,
              variant: "compact",
              children: /* @__PURE__ */ a(ji, { size: 16 })
            },
            "more-actions"
          ) }),
          /* @__PURE__ */ E(c.Generic.Menu.Dropdown, { className: "bn-menu-dropdown", children: [
            F && /* @__PURE__ */ a(
              c.Generic.Menu.Item,
              {
                icon: /* @__PURE__ */ a(bi, {}),
                onClick: m,
                children: r.comments.actions.edit_comment
              },
              "edit-comment"
            ),
            z && /* @__PURE__ */ a(
              c.Generic.Menu.Item,
              {
                icon: /* @__PURE__ */ a($i, {}),
                onClick: b,
                children: r.comments.actions.delete_comment
              },
              "delete-comment"
            )
          ] })
        ] })
      ]
    }
  ));
  const _e = e.createdAt.toLocaleDateString(void 0, {
    month: "short",
    day: "numeric"
  });
  if (!e.body)
    throw new Error("soft deletes are not yet supported");
  return /* @__PURE__ */ a(
    c.Comments.Comment,
    {
      authorInfo: I ?? "loading",
      timeString: _e,
      edited: e.updatedAt.getTime() !== e.createdAt.getTime(),
      showActions: "hover",
      actions: M,
      className: "bn-thread-comment",
      emojiPickerOpen: u,
      children: /* @__PURE__ */ a(
        Ut,
        {
          autoFocus: s,
          editor: i,
          editable: s,
          actions: e.reactions.length > 0 || s ? ({ isEmpty: Y }) => /* @__PURE__ */ E(j, { children: [
            e.reactions.length > 0 && !s && /* @__PURE__ */ E(
              c.Generic.Badge.Group,
              {
                className: G(
                  "bn-badge-group",
                  "bn-comment-reactions"
                ),
                children: [
                  e.reactions.map((me) => /* @__PURE__ */ a(
                    Jd,
                    {
                      comment: e,
                      emoji: me.emoji,
                      onReactionSelect: v
                    },
                    me.emoji
                  )),
                  U && /* @__PURE__ */ a(
                    Ln,
                    {
                      onEmojiSelect: (me) => v(me.native),
                      onOpenChange: d,
                      children: /* @__PURE__ */ a(
                        c.Generic.Badge.Root,
                        {
                          className: G(
                            "bn-badge",
                            "bn-comment-add-reaction"
                          ),
                          text: "+",
                          icon: /* @__PURE__ */ a(cn, { size: 16 }),
                          mainTooltip: r.comments.actions.add_reaction
                        }
                      )
                    }
                  )
                ]
              }
            ),
            s && /* @__PURE__ */ E(
              c.Generic.Toolbar.Root,
              {
                variant: "action-toolbar",
                className: G(
                  "bn-action-toolbar",
                  "bn-comment-actions"
                ),
                children: [
                  /* @__PURE__ */ a(
                    c.Generic.Toolbar.Button,
                    {
                      mainTooltip: r.comments.save_button_text,
                      variant: "compact",
                      onClick: g,
                      isDisabled: Y,
                      children: r.comments.save_button_text
                    }
                  ),
                  /* @__PURE__ */ a(
                    c.Generic.Toolbar.Button,
                    {
                      className: "bn-button",
                      mainTooltip: r.comments.cancel_button_text,
                      variant: "compact",
                      onClick: h,
                      children: r.comments.cancel_button_text
                    }
                  )
                ]
              }
            )
          ] }) : void 0
        }
      )
    }
  );
}, e1 = ({
  thread: e,
  maxCommentsBeforeCollapse: t
}) => {
  const n = _(), o = H(), r = Gt(e.resolvedBy ? [e.resolvedBy] : []), i = e.comments.map((c, s) => /* @__PURE__ */ a(
    Qd,
    {
      thread: e,
      comment: c,
      showResolveButton: s === 0
    },
    c.id + JSON.stringify(c.body || "{}")
  ));
  if (e.resolved && e.resolvedUpdatedAt && e.resolvedBy) {
    if (!r.get(e.resolvedBy))
      throw new Error(
        `User ${e.resolvedBy} resolved thread ${e.id}, but their data could not be found.`
      );
    const s = e.comments.findLastIndex(
      (l) => e.resolvedUpdatedAt.getTime() > l.createdAt.getTime()
    ) + 1;
    i.splice(
      s,
      0,
      /* @__PURE__ */ a(
        n.Comments.Comment,
        {
          className: "bn-thread-comment",
          authorInfo: e.resolvedBy && r.get(e.resolvedBy) || "loading",
          timeString: e.resolvedUpdatedAt.toLocaleDateString(void 0, {
            month: "short",
            day: "numeric"
          }),
          edited: !1,
          showActions: !1,
          children: /* @__PURE__ */ a("div", { className: "bn-resolved-text", children: o.comments.sidebar.marked_as_resolved })
        },
        "resolved-comment"
      )
    );
  }
  return t && i.length > t && i.splice(
    1,
    i.length - 2,
    /* @__PURE__ */ a(
      n.Comments.ExpandSectionsPrompt,
      {
        className: "bn-thread-expand-prompt",
        children: o.comments.sidebar.more_replies(e.comments.length - 2)
      },
      "expand-prompt"
    )
  ), i;
};
function t1() {
  const e = Z(X), t = _(), n = H(), o = jt({
    trailingBlock: !1,
    dictionary: {
      ...n,
      placeholders: {
        emptyDocument: n.placeholders.new_comment
      }
    },
    schema: e.commentEditorSchema || Wt
  });
  return /* @__PURE__ */ a(t.Comments.Card, { className: "bn-thread", children: /* @__PURE__ */ a(
    Ut,
    {
      autoFocus: !0,
      editable: !0,
      editor: o,
      actions: ({ isEmpty: r }) => /* @__PURE__ */ a(
        t.Generic.Toolbar.Root,
        {
          className: G(
            "bn-action-toolbar",
            "bn-comment-actions"
          ),
          variant: "action-toolbar",
          children: /* @__PURE__ */ a(
            t.Generic.Toolbar.Button,
            {
              className: "bn-button",
              mainTooltip: "Save",
              variant: "compact",
              isDisabled: r,
              onClick: async () => {
                await e.createThread({
                  initialComment: {
                    body: o.document
                  }
                }), e.stopPendingComment();
              },
              children: "Save"
            }
          )
        }
      )
    }
  ) });
}
function n1(e) {
  const [t, n] = V(!1), o = C(), r = Z(X), i = L(X, {
    editor: o,
    selector: (u) => u.pendingComment
  });
  x(() => {
    n(i);
  }, [i]);
  const c = P({
    editor: o,
    selector: ({ editor: u }) => i ? {
      from: u.prosemirrorState.selection.from,
      to: u.prosemirrorState.selection.to
    } : void 0
  }), s = T(
    () => ({
      useFloatingOptions: {
        open: t,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (u) => {
          u || (r.stopPendingComment(), o.focus()), n(u);
        },
        placement: "bottom",
        middleware: [ee(10), Te(), ue()]
      },
      elementProps: {
        style: {
          zIndex: 60
        }
      },
      ...e.floatingUIOptions
    }),
    [r, o, t, e.floatingUIOptions]
  ), l = e.floatingComposer || t1;
  return /* @__PURE__ */ a(Mt, { position: c, ...s, children: /* @__PURE__ */ a(l, {}) });
}
const o1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: n1
}, Symbol.toStringTag, { value: "Module" })), Do = ({
  thread: e,
  selected: t,
  referenceText: n,
  maxCommentsBeforeCollapse: o,
  onFocus: r,
  onBlur: i,
  tabIndex: c
}) => {
  const s = _(), l = H(), u = Z(X), d = jt({
    trailingBlock: !1,
    dictionary: {
      ...l,
      placeholders: {
        emptyDocument: l.placeholders.comment_reply
      }
    },
    schema: u.commentEditorSchema || Wt
  }), f = y(async () => {
    await u.threadStore.addComment({
      comment: {
        body: d.document
      },
      threadId: e.id
    }), d.removeBlocks(d.document);
  }, [u, d, e.id]);
  return /* @__PURE__ */ E(
    s.Comments.Card,
    {
      className: "bn-thread",
      headerText: n,
      onFocus: r,
      onBlur: i,
      selected: t,
      tabIndex: c,
      children: [
        /* @__PURE__ */ a(s.Comments.CardSection, { className: "bn-thread-comments", children: /* @__PURE__ */ a(
          e1,
          {
            thread: e,
            maxCommentsBeforeCollapse: t ? void 0 : o || 5
          }
        ) }),
        t && /* @__PURE__ */ a(s.Comments.CardSection, { className: "bn-thread-composer", children: /* @__PURE__ */ a(
          Ut,
          {
            autoFocus: !1,
            editable: !0,
            editor: d,
            actions: ({ isEmpty: m }) => m ? null : /* @__PURE__ */ a(
              s.Generic.Toolbar.Root,
              {
                variant: "action-toolbar",
                className: G(
                  "bn-action-toolbar",
                  "bn-comment-actions"
                ),
                children: /* @__PURE__ */ a(
                  s.Generic.Toolbar.Button,
                  {
                    mainTooltip: l.comments.save_button_text,
                    variant: "compact",
                    isDisabled: m,
                    onClick: f,
                    children: l.comments.save_button_text
                  }
                )
              }
            )
          }
        ) })
      ]
    }
  );
};
function Fo() {
  const t = Z(X).threadStore, n = q(void 0);
  n.current || (n.current = t.getThreads());
  const o = y(
    (r) => t.subscribe((i) => {
      n.current = i, r();
    }),
    [t]
  );
  return Et(o, () => n.current);
}
function r1(e) {
  const t = C(), [n, o] = V(!1), r = Z(X), i = L(X, {
    editor: t,
    selector: (d) => d.selectedThreadId ? {
      id: d.selectedThreadId,
      position: d.threadPositions.get(d.selectedThreadId)
    } : void 0
  });
  x(() => {
    o(!!i);
  }, [i]);
  const c = Fo(), s = T(
    () => i ? c.get(i.id) : void 0,
    [i, c]
  ), l = T(
    () => ({
      useFloatingOptions: {
        open: n,
        // Needed as hooks like `useDismiss` call `onOpenChange` to change the
        // open state.
        onOpenChange: (d, f, m) => {
          m === "escape-key" && t.focus(), d || r.selectThread(void 0), o(d);
        },
        placement: "bottom",
        middleware: [ee(10), Te(), ue()]
      },
      elementProps: {
        style: {
          zIndex: 30
        }
      },
      ...e.floatingUIOptions
    }),
    [r, t, n, e.floatingUIOptions]
  ), u = e.floatingThread || Do;
  return /* @__PURE__ */ a(Mt, { position: i == null ? void 0 : i.position, ...l, children: s && /* @__PURE__ */ a(u, { thread: s, selected: !0 }) });
}
const i1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: r1
}, Symbol.toStringTag, { value: "Module" })), c1 = W.memo(
  ({
    thread: e,
    selectedThreadId: t,
    maxCommentsBeforeCollapse: n,
    referenceText: o
  }) => {
    const r = Z(X), i = y(
      (s) => {
        s.target.closest(".bn-action-toolbar") || r.selectThread(e.id);
      },
      [r, e.id]
    ), c = y(
      (s) => {
        if (!s.relatedTarget || s.relatedTarget.closest(".bn-action-toolbar"))
          return;
        const l = s.target instanceof Node ? s.target : null, u = s.relatedTarget instanceof Node ? s.relatedTarget.closest(".bn-thread") : null;
        (!l || !u || !u.contains(l)) && r.selectThread(void 0);
      },
      [r]
    );
    return /* @__PURE__ */ a(
      Do,
      {
        thread: e,
        selected: e.id === t,
        referenceText: o,
        maxCommentsBeforeCollapse: n,
        onFocus: i,
        onBlur: c,
        tabIndex: 0
      }
    );
  }
);
function l1(e, t, n) {
  if (t === "recent-activity")
    return e.sort(
      (o, r) => r.comments[r.comments.length - 1].createdAt.getTime() - o.comments[o.comments.length - 1].createdAt.getTime()
    );
  if (t === "oldest")
    return e.sort(
      (o, r) => o.createdAt.getTime() - r.createdAt.getTime()
    );
  if (t === "position")
    return e.sort((o, r) => {
      var s, l;
      const i = ((s = n == null ? void 0 : n.get(o.id)) == null ? void 0 : s.from) || Number.MAX_VALUE, c = ((l = n == null ? void 0 : n.get(r.id)) == null ? void 0 : l.from) || Number.MAX_VALUE;
      return i - c;
    });
  throw new Nn(t);
}
function zn(e, t) {
  return e.transact((n) => {
    if (!t)
      return "Original content deleted";
    if (n.doc.nodeSize < t.to)
      return "";
    const o = n.doc.textBetween(
      t.from,
      t.to
    );
    return o.length > 15 ? `${o.slice(0, 15)}…` : o;
  });
}
function z1(e) {
  const t = C(), { selectedThreadId: n, threadPositions: o } = L(X), r = Fo(), i = T(() => {
    const c = Array.from(r.values()), s = l1(
      c,
      e.sort || "position",
      o
    ), l = [];
    for (const u of s)
      u.resolved ? (e.filter === "resolved" || e.filter === "all") && l.push({
        thread: u,
        referenceText: zn(
          t,
          o.get(u.id)
        )
      }) : (e.filter === "open" || e.filter === "all") && l.push({
        thread: u,
        referenceText: zn(
          t,
          o.get(u.id)
        )
      });
    return l;
  }, [r, e.sort, e.filter, o, t]);
  return /* @__PURE__ */ a("div", { className: "bn-threads-sidebar", children: i.map((c) => /* @__PURE__ */ a(
    c1,
    {
      thread: c.thread,
      selectedThreadId: n,
      editor: t,
      referenceText: c.referenceText,
      maxCommentsBeforeCollapse: e.maxCommentsBeforeCollapse
    },
    c.thread.id
  )) });
}
function R1(e) {
  const t = ne();
  if (e || (e = t == null ? void 0 : t.editor), !e)
    throw new Error(
      "'editor' is required, either from BlockNoteContext or as a function argument"
    );
  return P({
    editor: e,
    selector: ({ editor: o }) => o.getActiveStyles()
  });
}
function B1(e, t) {
  return P({
    editor: t,
    selector: ({ editor: n }) => e ? n.getSelectionBoundingBox() : void 0
  });
}
function s1(e) {
  return e.currentTarget instanceof HTMLElement && e.relatedTarget instanceof HTMLElement ? e.currentTarget.contains(e.relatedTarget) : !1;
}
function O1({
  onBlur: e,
  onFocus: t
} = {}) {
  const n = q(null), [o, r] = V(!1), i = q(!1), c = (u) => {
    r(u), i.current = u;
  }, s = (u) => {
    i.current || (c(!0), t == null || t(u));
  }, l = (u) => {
    i.current && !s1(u) && (c(!1), e == null || e(u));
  };
  return x(() => {
    const u = n.current;
    if (u)
      return u.addEventListener("focusin", s), u.addEventListener("focusout", l), () => {
        u == null || u.removeEventListener("focusin", s), u == null || u.removeEventListener("focusout", l);
      };
  }, [s, l]), { ref: n, focused: o };
}
function P1(e) {
  return P({
    editor: e,
    selector: ({ editor: t }) => {
      var n;
      return ((n = t.getSelection()) == null ? void 0 : n.blocks) || [t.getTextCursorPosition().block];
    }
  });
}
function mt(e) {
  return (
    // Creates inline content section element
    /* @__PURE__ */ a(
      Fn,
      {
        as: "span",
        className: "bn-inline-content-section",
        "data-inline-content-type": e.inlineContentType,
        ...Object.fromEntries(
          Object.entries(e.inlineContentProps).filter(([t, n]) => {
            const o = e.propSchema._zodSource._zod.def.shape[t], r = o instanceof At ? o._zod.def.defaultValue : void 0;
            return n !== r;
          }).map(([t, n]) => typeof n == "object" ? [Ae(t), JSON.stringify(n)] : [Ae(t), n])
        ),
        children: e.children
      }
    )
  );
}
function N1(e, t) {
  var o;
  const n = Fr.create({
    name: e.type,
    inline: !0,
    group: "inline",
    selectable: e.content === "styled",
    atom: e.content === "none",
    draggable: (o = t.meta) == null ? void 0 : o.draggable,
    content: e.content === "styled" ? "inline*" : "",
    addAttributes() {
      return Br(e.propSchema);
    },
    addKeyboardShortcuts() {
      return Rr(e);
    },
    parseHTML() {
      return zr(
        e,
        t.parse
      );
    },
    renderHTML({ node: r }) {
      const i = this.options.editor, c = qt(
        r,
        i.schema.inlineContentSchema,
        i.schema.styleSchema
      ), s = t.toExternalHTML || t.render, l = ie(
        (u) => /* @__PURE__ */ a(
          s,
          {
            contentRef: (d) => {
              u(d), d && (d.dataset.editable = "");
            },
            inlineContent: c,
            updateInlineContent: () => {
            },
            editor: i
          }
        ),
        i
      );
      return Lr(
        l,
        e.type,
        r.attrs,
        e.propSchema
      );
    },
    addNodeView() {
      const r = this.options.editor;
      return (i) => $n(
        (c) => {
          const s = Dn().nodeViewContentRef;
          if (!s)
            throw new Error("nodeViewContentRef is not set");
          const l = t.render;
          return /* @__PURE__ */ a(
            mt,
            {
              inlineContentProps: c.node.attrs,
              inlineContentType: e.type,
              propSchema: e.propSchema,
              children: /* @__PURE__ */ a(
                l,
                {
                  contentRef: (u) => {
                    s(u), u && (u.dataset.editable = "");
                  },
                  editor: r,
                  inlineContent: qt(
                    c.node,
                    r.schema.inlineContentSchema,
                    r.schema.styleSchema
                  ),
                  updateInlineContent: (u) => {
                    const d = Zr(
                      [u],
                      r.schema.inlineContentSchema
                    ), f = Ir(
                      d,
                      r.pmSchema
                    ), m = c.getPos();
                    m !== void 0 && r.transact(
                      (h) => h.replaceWith(m, m + c.node.nodeSize, f)
                    );
                  }
                }
              )
            }
          );
        },
        {
          className: "bn-ic-react-node-view-renderer",
          as: "span"
          // contentDOMElementTag: "span", (requires tt upgrade)
        }
      )(i);
    }
  });
  return Or(
    e,
    {
      ...t,
      node: n,
      render(r, i, c) {
        const s = t.render;
        return ie((u) => /* @__PURE__ */ a(
          mt,
          {
            inlineContentProps: r.props,
            inlineContentType: e.type,
            propSchema: e.propSchema,
            children: /* @__PURE__ */ a(
              s,
              {
                contentRef: (d) => {
                  u(d), d && (d.dataset.editable = "");
                },
                editor: c,
                inlineContent: r,
                updateInlineContent: i
              }
            )
          }
        ), c);
      },
      toExternalHTML(r, i) {
        const c = t.toExternalHTML || t.render;
        return ie((l) => /* @__PURE__ */ a(
          mt,
          {
            inlineContentProps: r.props,
            inlineContentType: e.type,
            propSchema: e.propSchema,
            children: /* @__PURE__ */ a(
              c,
              {
                contentRef: (u) => {
                  l(u), u && (u.dataset.editable = "");
                },
                editor: i,
                inlineContent: r,
                updateInlineContent: () => {
                }
              }
            )
          }
        ), i);
      }
    }
  );
}
function A1(e, t) {
  const n = jr.create({
    name: e.type,
    addAttributes() {
      return Nr(e.propSchema);
    },
    parseHTML() {
      return Pr(e);
    },
    renderHTML({ mark: o }) {
      const r = t.render, i = ie(
        (c) => /* @__PURE__ */ a(
          r,
          {
            editor: this.options.editor,
            value: e.propSchema === "boolean" ? void 0 : o.attrs.stringValue,
            contentRef: (s) => {
              c(s), s && (s.dataset.editable = "");
            }
          }
        ),
        this.options.editor
      );
      return ot(
        i,
        e.type,
        o.attrs.stringValue,
        e.propSchema
      );
    },
    addMarkView() {
      const o = this.options.editor;
      return (r) => {
        const i = Ur((c) => {
          const s = Ge(Gr).markViewContentRef;
          if (!s)
            throw new Error("markViewContentRef is not set");
          const l = t.render;
          return /* @__PURE__ */ a(
            l,
            {
              editor: o,
              contentRef: (u) => {
                s(u), u && (u.dataset.markViewContent = "");
              },
              value: e.propSchema === "boolean" ? void 0 : c.mark.attrs.stringValue
            }
          );
        })(r);
        return i.didMountContentDomElement = !0, i;
      };
    }
  });
  return Ar(e, {
    ...t,
    mark: n,
    render(o, r) {
      const i = t.render, c = ie(
        (s) => /* @__PURE__ */ a(
          i,
          {
            editor: r,
            value: o,
            contentRef: (l) => {
              s(l), l && (l.dataset.editable = "");
            }
          }
        ),
        r
      );
      return ot(
        c,
        e.type,
        o,
        e.propSchema
      );
    },
    toExternalHTML(o, r) {
      const i = t.render, c = ie(
        (s) => /* @__PURE__ */ a(
          i,
          {
            editor: r,
            value: o,
            contentRef: (l) => {
              s(l), l && (l.dataset.editable = "");
            }
          }
        ),
        r
      );
      return ot(
        c,
        e.type,
        o,
        e.propSchema
      );
    }
  });
}
function $1(e, t) {
  const n = e.getBoundingClientRect(), o = t.getBoundingClientRect(), r = n.top < o.top, i = n.bottom > o.bottom;
  return r && i ? "both" : r ? "top" : i ? "bottom" : "none";
}
function D1(e) {
  return (t) => {
    e.forEach((n) => {
      typeof n == "function" ? n(t) : n != null && (n.current = t);
    });
  };
}
export {
  Lu as AddBlockButton,
  Mn as AddButton,
  vu as AddCommentButton,
  bu as AddCommentButtonInner,
  Zd as AddFileButton,
  Cu as AddTiptapCommentButton,
  Rd as AudioBlock,
  Ld as AudioPreview,
  zd as AudioToExternalHTML,
  Ie as BasicTextStyleButton,
  Ru as BlockColorsItem,
  dt as BlockContentWrapper,
  jn as BlockNoteContext,
  bd as BlockNoteDefaultUI,
  Td as BlockNoteViewEditor,
  w1 as BlockNoteViewRaw,
  Gn as BlockPopover,
  gu as BlockTypeSelect,
  ud as ColorPickerButton,
  qi as ColorStyleButton,
  Qd as Comment,
  e1 as Comments,
  Kr as ComponentsContext,
  Ji as CreateLinkButton,
  rd as DeleteButton,
  Tu as DeleteLinkButton,
  Au as DragHandleButton,
  Nu as DragHandleMenu,
  Hu as EditLinkButton,
  so as EditLinkMenuItems,
  qr as EmbedTab,
  H1 as ExperimentalMobileFormattingToolbarController,
  od as ExtendButton,
  Dt as FigureWithCaption,
  Ft as FileBlockWrapper,
  au as FileCaptionButton,
  uu as FileDeleteButton,
  _u as FileDownloadButton,
  Id as FileNameWithIcon,
  Un as FilePanel,
  Yr as FilePanelController,
  wu as FilePreviewButton,
  du as FileRenameButton,
  fu as FileReplaceButton,
  t1 as FloatingComposer,
  n1 as FloatingComposerController,
  r1 as FloatingThreadController,
  Ro as FormattingToolbar,
  xu as FormattingToolbarController,
  Q as GenericPopover,
  Wu as GridSuggestionMenuController,
  Gu as GridSuggestionMenuWrapper,
  Pd as ImageBlock,
  Bd as ImagePreview,
  Od as ImageToExternalHTML,
  mt as InlineContentWrapper,
  Mu as LinkToolbar,
  Zu as LinkToolbarController,
  nt as LinkWithCaption,
  mu as NestBlockButton,
  Vu as OpenLinkButton,
  Mt as PositionPopover,
  k1 as ReactAudioBlock,
  y1 as ReactFileBlock,
  S1 as ReactImageBlock,
  x1 as ReactVideoBlock,
  Bu as RemoveBlockItem,
  $o as ResizableFileBlockWrapper,
  $u as SideMenu,
  Du as SideMenuController,
  dd as SplitButton,
  td as SuggestionMenuController,
  Yu as SuggestionMenuWrapper,
  md as TableCellButton,
  fd as TableCellMenu,
  ku as TableCellMergeButton,
  V1 as TableCellPopover,
  Pu as TableColumnHeaderItem,
  ad as TableHandle,
  sd as TableHandleMenu,
  hd as TableHandlesController,
  Ou as TableRowHeaderItem,
  ut as TextAlignButton,
  Do as Thread,
  z1 as ThreadsSidebar,
  T1 as ToggleWrapper,
  hu as UnnestBlockButton,
  Xr as UploadTab,
  Fd as VideoBlock,
  $d as VideoPreview,
  Dd as VideoToExternalHTML,
  pu as blockTypeSelectItems,
  tt as createReactBlockSpec,
  N1 as createReactInlineContentSpec,
  A1 as createReactStyleSpec,
  $1 as elementOverflow,
  Fu as getDefaultReactEmojiPickerItems,
  ed as getDefaultReactSlashMenuItems,
  Su as getFormattingToolbarItems,
  Jr as getMountedBoundingClientRectCache,
  E1 as getPageBreakReactSlashMenuItems,
  zn as getReferenceText,
  D1 as mergeRefs,
  R1 as useActiveStyles,
  ne as useBlockNoteContext,
  C as useBlockNoteEditor,
  Oo as useCloseSuggestionMenuNoItems,
  _ as useComponentsContext,
  jt as useCreateBlockNote,
  H as useDictionary,
  vd as useEditorChange,
  B1 as useEditorSelectionBoundingBox,
  Cd as useEditorSelectionChange,
  P as useEditorState,
  M1 as useExtendButtonsPositioning,
  Z as useExtension,
  L as useExtensionState,
  O1 as useFocusWithin,
  Uu as useGridSuggestionMenuKeyboardNavigation,
  Po as useLoadSuggestionMenuItems,
  Vd as useOnUploadEnd,
  Md as useOnUploadStart,
  _d as usePrefersColorScheme,
  $t as useResolveUrl,
  P1 as useSelectedBlocks,
  qu as useSuggestionMenuKeyboardHandler,
  Ju as useSuggestionMenuKeyboardNavigation,
  Z1 as useTableHandlesPositioning,
  Fo as useThreads,
  Ao as useUploadLoading,
  Xd as useUser,
  Gt as useUsers
};
//# sourceMappingURL=blocknote-react.js.map
